(function () {
  window.__KUSHAL_FAST_FILTER_MODE__ = true;
  window.__K_POLICY__ = window.__K_POLICY__ || {
    backgroundHydrationMode: 'off', // 'off' | 'onDemand' | 'idle'
    mutationSyncMode: 'explicit', // 'explicit' | 'observerFallback'
  };
  let ROOT_SELECTOR = '[data-section-type="collection-template"][data-k-custom-filter="true"]';
  let root = document.querySelector(ROOT_SELECTOR);
  if (!root) return;
  // The section opts in only after its complete collection markup is parsed.
  let collectionDomReady = !!(document.currentScript &&
    document.currentScript.hasAttribute('data-k-filter-dom-ready'));
  let pinnedProductIds = new Set(
    String(root.getAttribute('data-k-pinned-product-ids') || '')
      .split(',')
      .map(function (id) { return id.trim(); })
      .filter(Boolean)
  );
  let pinnedProductRanks = new Map();
  Array.from(pinnedProductIds).forEach(function (id, index) {
    pinnedProductRanks.set(id, index);
  });

  let nodes = {
    list: root.querySelector('#infinite-scroll-loop'),
    pagination: root.querySelector('#infinite-scroll-pagination'),
    noMatches: root.querySelector('#kushal-filter-no-matches'),
    appliedItems: root.querySelector('.ct_filter_apply .ct_filter-apply__items'),
    countTargets: root.querySelectorAll('.js-filter-product-count, .CT_fil_utility-bar__centre span, .ct_utility-bar__centre span'),
    mainForm: root.querySelector('#CollectionFilterForm'),
    plpForm: root.querySelector('#CollectionFilterForm_custom_dd'),
  };
  if (!nodes.list) return;
  let FILTER_SOURCE_SESSION_KEY = 'kushal_filter_selection_source_v1';
  let CLEVERTAP_EVENTS = {
    QUICK_FILTER_SELECTED: 'QuickFilter_Selected',
    BREAKER_FILTER_INTERACTED: 'BreakerFilter_Interacted',
    BREAKER_FILTER_SELECTED: 'BreakerFilter_Selected',
    MAIN_FILTER_OPENED: 'MainFilter_Opened',
    MAIN_FILTER_OPTION_SELECTED: 'MainFilter_OptionSelected',
    FILTER_CLEARED: 'Filter_Cleared',
  };
  let BREAKER_POSITION_IN_FEED = 6;
  // Every 7th product is a full-width hero card, then the breaker — the same
  // slot sequence sections/main-collection.liquid renders server-side (6 cards,
  // hero, breaker). This engine rebuilds the grid from JSON on every filter,
  // sort and PLP tab change, so without this the hero survived only until the
  // first re-render. Position-based on purpose: whichever product lands in the
  // 7th slot is promoted, whatever the filter, sort or tab.
  let HERO_SLOT_FREQUENCY = 7;
  // PLP+ chips are multi-select, so they are checkboxes (snippets/plp_plus_filter.liquid).
  // Matched by class, not by type, so a strip still rendered as radios by an
  // older cached copy of that snippet keeps working.
  let PLP_INPUT_SELECTOR = 'input.breaker_filter-group__checkbox';
  // Flex order for the "All" pill: last in the rail. Every category chip gets
  // its list index + 2, and a selected one gets 1, so this only has to clear
  // the longest rail the shop can publish.
  let PLP_ALL_ORDER = '9999';

  // The rail always leads with these five, in this order, whatever order the
  // collection's facet values come back in. Everything else keeps its authored
  // position behind them. Matched on the handleized label with a starts-with
  // test so the singular here catches "Necklaces", "Earrings", "Bangles",
  // "Kadas" and the like. A rail that is not the Category rail
  // (Style/Subcategory, Metal Type, Occasion) matches none of them and is left
  // in its original order.
  let PLP_PINNED_CATEGORIES = ['necklace', 'earring', 'bangle', 'bracelet', 'kada'];
  // Non-pinned pills start past the pinned block, which occupies 2..6.
  let PLP_UNPINNED_ORDER_BASE = 20;

  // Label of a rail pill, from its text span, falling back to the token its
  // input carries. Returns '' for the "All" pill, which has no input.
  function plpPillLabel(li) {
    if (!li) return '';
    let text = li.querySelector('.filter-group__item__text');
    if (text && text.textContent) return handleize(text.textContent);
    let input = li.querySelector(PLP_INPUT_SELECTOR);
    if (input) return handleize(input.getAttribute('data-q-token') || input.value || '');
    return '';
  }

  // Rank in PLP_PINNED_CATEGORIES, or -1 when the pill is not one of them.
  function plpPinnedRank(li) {
    let label = plpPillLabel(li);
    if (!label) return -1;
    for (let i = 0; i < PLP_PINNED_CATEGORIES.length; i++) {
      if (label.indexOf(PLP_PINNED_CATEGORIES[i]) === 0) return i;
    }
    return -1;
  }

  // The flex order a pill should carry. Selection never changes it — a chosen
  // tab stays where it was drawn.
  function plpPillOrder(li, originalOrder) {
    let rank = plpPinnedRank(li);
    return rank >= 0 ? String(rank + 2) : String(originalOrder + PLP_UNPINNED_ORDER_BASE);
  }

  function clearOtherPlpSelections(list, selectedInput) {
    if (!list) return;
    let selectedName = String(selectedInput && selectedInput.name || '');
    getAllFilterInputs().forEach(function (input) {
      if (input === selectedInput) return;
      if (selectedName && String(input.name || '') !== selectedName) return;
      if (!input.checked) return;
      input.checked = false;
      input.removeAttribute('checked');
      let key = mapNameToKey(String(input.name || ''), input);
      let token = deriveToken(input);
      syncTokenAcrossInputs(key, token, false, String(input.name || ''));
      if (key) delete state.selectionSourceByKey[key];
    });
  }

  function revealPlpSelection(list, li) {
    if (!list || !li) return;
    let listRect = list.getBoundingClientRect();
    let itemRect = li.getBoundingClientRect();
    let left = itemRect.left - listRect.left + list.scrollLeft;
    let right = left + itemRect.width;
    let visibleLeft = list.scrollLeft;
    let visibleRight = visibleLeft + list.clientWidth;
    if (left < visibleLeft || right > visibleRight) {
      list.scrollTo({
        left: Math.max(0, left - Math.max(0, (list.clientWidth - itemRect.width) / 2)),
        behavior: 'smooth'
      });
    }
  }
  // The applied-filter chip row above the strip ("Finger Rings ×  Necklace ×
  // … Clear all"). The chips duplicate what the selected PLP+ chips already
  // show, so the row is off; flip to true to bring it back.
  let SHOW_APPLIED_FILTER_CHIPS = false;
  // Missing attribute means ON, not off. The section publishes
  // data-k-hero-cards, but this file also runs against markup rendered before
  // that attribute existed (a cached section, a page served mid-deploy, another
  // template rendering the same grid). Reading a missing value as "false" turned
  // heroes off there while the SERVER kept rendering them — so the big card
  // vanished on the first sort or filter, and the breaker was left sitting after
  // six plain cards with no big card above it. Only an explicit "false" disables.
  let heroCardsAttr = root.getAttribute('data-k-hero-cards');
  let heroCardsEnabled =
    heroCardsAttr === null || String(heroCardsAttr).toLowerCase() !== 'false';
  let SORT_KEYS = {
    RECOMMENDED: 'manual',
    BEST_SELLER: 'best-selling',
    PRICE_LOW_TO_HIGH: 'price-ascending',
    PRICE_HIGH_TO_LOW: 'price-descending',
    NEW_ARRIVAL: 'created-descending',
    DATE_OLD_TO_NEW: 'created-ascending',
  };
  let SORT_KEY_ALIASES = {
    'date-descending': SORT_KEYS.NEW_ARRIVAL,
    'date-ascending': SORT_KEYS.DATE_OLD_TO_NEW,
  };
  let SORT_LABELS = {
    manual: 'Recommended',
    'best-selling': 'Best Selling',
    'price-ascending': 'Price, low to high',
    'price-descending': 'Price, high to low',
    'created-descending': 'New Arrival',
    'created-ascending': 'Date, old to new',
  };
  let INITIAL_EAGER_CARD_IMAGE_COUNT = 4;
  let APPEND_EAGER_CARD_IMAGE_COUNT = 8;
  let PAGINATION_SKELETON_CARD_COUNT = 4;
  let PAGINATION_SKELETON_MIN_VISIBLE_MS = 280;
  let INITIAL_HYDRATION_PAGE_COUNT = 3;
  let INITIAL_HYDRATION_BATCH_SIZE = 4;
  let BACKGROUND_HYDRATION_BATCH_SIZE = 6;
  let IMG_PLACEHOLDER_PIXEL =
    'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

  // Maps handleized alias tokens → canonical display name.
  // Both the alias and the canonical collapse to the same filter option.
  let CITY_ALIASES = {
    'mangaluru': 'Mangalore',
    'mangalore': 'Mangalore',
    'bangalore': 'Bengaluru',
    'bengaluru': 'Bengaluru',
    'bombay': 'Mumbai',
    'madras': 'Chennai',
    'calcutta': 'Kolkata',
    'pondicherry': 'Puducherry',
    'puducherry': 'Puducherry',
    'trivandrum': 'Trivandrum',
    'thiruvananthapuram': 'Trivandrum',
    'mysuru': 'Mysore',
    'mysore': 'Mysore',
    'visakhapatnam': 'Vishakapatnam',
    'vishakapatnam': 'Vishakapatnam',
    'rajamahendravaram': 'Rajmundry',
    'rajahmundry': 'Rajmundry',
    'rajmundry': 'Rajmundry',
    'hubballi': 'Hubli',
    'hubli': 'Hubli',
    'belagavi': 'Belgaum',
    'belgaum': 'Belgaum',
    'hosapete': 'Hospet',
    'hospet': 'Hospet',
    'gurgaon': 'Gurugram',
    'gurugram': 'Gurugram',
    'guwahati': 'Guwahati',
  };

  function resolveCityCanonical(raw) {
    let token = typeof raw === 'string' && raw.indexOf('-') > -1 ? raw : handleize(raw);
    let display = CITY_ALIASES[token];
    return display ? { token: handleize(display), display: display } : null;
  }

  let state = {
    products: [],
    filtered: [],
    active: {},
    priceRange: null,
    sortBy: getSortByFromUrl(),
    page: 1,
    perPage: 16,
    observer: null,
    loaded: false,
    loading: false,
    pendingApply: false,
    plpObserver: null,
    plpSyncScheduled: false,
    lastSelectedTokenByName: {},
    breakerTemplateHtml: '',
    breakerFrequency: 6,
    // 60-min chip (assets/plp-flash-filter.js drives it through the API below)
    flashOnly: false,
    appBannerTemplateHtml: '',
    appBannerInsertAfter: 10,
    bodyScrollLocked: false,
    bodyScrollTop: 0,
    filterContainerObserver: null,
    mobileSplitScrollBound: false,
    mainFormScrollCompensationBound: false,
    wasMobileFilterDrawerOpen: false,
    wasAnyFilterDrawerOpen: false,
    selectionSourceByKey: {},
    appliedSelectionSourceByKey: {},
    sortOrderCache: {},
    sortOrderLoading: {},
    applyRunId: 0,
    freezeWatchdogBound: false,
    lastDrawerToggleAt: 0,
    lastMainFilterOpenedEventAt: 0,
    startupMaskActive: false,
    startupLoaderGuardTimer: null,
    startupMaskReleaseTimer: null,
    deferredApplyLoaderActive: false,
    sortIndexViewEnabled: null,
    sortUiObserver: null,
    sortUiSyncQueued: false,
    startupSortSyncTimers: [],
    startupSkeletonActive: false,
    startupSkeletonBackupHtml: '',
    startupPreviewSignature: '',
    deferApplyAfterLoad: false,
    sortReapplyPendingKey: '',
    pendingMainFilterCompensationFrame: 0,
    locationStoreWatcherBound: false,
    locationStoreSignature: '',
    paginationSkeletonActive: false,
    updateOptionVisibilityTimerId: null,
    appliedActive: {},
    appliedPriceRange: null,
    paginationLoadInProgress: false,
    mainDesktopDefaultCollapsed: false,
    progressiveImageObserver: null,
    progressiveImageInteractionBound: false,
    fullHydrated: false,
    countsAreFinal: false,
    paginationFallbackHandler: null,
    paginationFallbackBound: false,
    paginationFallbackTimer: null,
    hydrationTotalPages: 1,
    hydrationNextPage: 2,
    hydrationBaseSortKey: 'manual',
    hydrationPreserveCurrentFilters: false,
    hydrationPromise: null,
    filterDatasetPreparing: false,
    filterDatasetHydrationPromise: null,
    urlFiltersAtLoad: false,
    filterInteractionStarted: false,
  };

  function getBackgroundHydrationMode() {
    let mode = window.__K_POLICY__ && window.__K_POLICY__.backgroundHydrationMode;
    if (mode === 'idle' || mode === 'onDemand' || mode === 'off') return mode;
    return 'idle';
  }

  function getMutationSyncMode() {
    let mode = window.__K_POLICY__ && window.__K_POLICY__.mutationSyncMode;
    if (mode === 'observerFallback' || mode === 'explicit') return mode;
    return 'explicit';
  }

  function shouldPreserveServerFacetUi() {
    return !!(state.urlFiltersAtLoad && !state.filterInteractionStarted);
  }


  function showFilterPreparingState(isPreparing) {
    let preparing = !!isPreparing;
    root.classList.toggle('k-filter-dataset-preparing', preparing);
    let applyButtons = root.querySelectorAll('.apply_btn.ct_submit_sec, .apply_btn.ct_submit');
    applyButtons.forEach(function (btn) {
      if (!btn) return;
      btn.classList.toggle('is-preparing', preparing);
      if (preparing) btn.setAttribute('data-preparing', 'true');
      else btn.removeAttribute('data-preparing');
    });
  }

  async function ensureFilterDatasetPreparing(reason) {
    if (state.fullHydrated) return true;
    if (state.filterDatasetHydrationPromise) return state.filterDatasetHydrationPromise;

    state.filterDatasetPreparing = true;
    showFilterPreparingState(true);

    state.filterDatasetHydrationPromise = hydrateRemainingProductsOnDemand(reason || 'filter-intent', {
      // Fetch more pages per round-trip when a filter is first used. We still
      // render only after the dataset is complete, so this does not reintroduce
      // the partial-product flash.
      batchSize: 24,
      yieldBetweenBatches: false,
    })
      .catch(function () {
        return false;
      })
      .finally(function () {
        state.filterDatasetPreparing = false;
        state.filterDatasetHydrationPromise = null;
        showFilterPreparingState(false);
        collectActiveState();
        updateOptionVisibilityDebounced(state.active, state.priceRange);
        syncFilterUiFromState({
          syncOptions: true,
          syncCount: true,
          syncHeaderToggle: true,
        });
      });

    return state.filterDatasetHydrationPromise;
  }

  function buildJsonEndpoint(page, sortBy, options) {
    let opts = options || {};
    let preserveCurrentFilters = !!opts.preserveCurrentFilters;
    let viewName = String(opts.view || 'json');
    let params = preserveCurrentFilters
      ? new URLSearchParams(window.location.search || '')
      : new URLSearchParams();

    // Always keep Shopify theme-preview params so draft theme JSON matches the page.
    try {
      let current = new URLSearchParams(window.location.search || '');
      ['preview_theme_id', 'pb', 'ite', '_ab', '_fd', '_sc', 'key'].forEach(function (key) {
        if (current.has(key) && !params.has(key)) {
          params.set(key, current.get(key));
        }
      });
    } catch (e) {}

    // Always control pagination/view from this runtime call.
    params.delete('view');
    params.delete('page');

    params.set('view', viewName);
    params.set('page', String(page));
    if (sortBy) {
      params.set('sort_by', normalizeSortKey(sortBy));
    }

    return window.location.pathname + '?' + params.toString();
  }


  function getSortOrderSessionKey(sortKey) {
    let key = normalizeSortKey(sortKey || 'manual');
    return 'k_custom_sort_order_v3|' + String(window.location.pathname || '') + '|' + key;
  }

  function loadSortOrderCacheFromSession(sortKey) {
    try {
      let raw = window.sessionStorage ? window.sessionStorage.getItem(getSortOrderSessionKey(sortKey)) : '';
      if (!raw) return null;
      let parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return null;
      return parsed;
    } catch (e) {
      return null;
    }
  }

  function saveSortOrderCacheToSession(sortKey, map) {
    try {
      if (!window.sessionStorage) return;
      if (!map || typeof map !== 'object') return;
      let keys = Object.keys(map);
      if (!keys.length) return;
      window.sessionStorage.setItem(getSortOrderSessionKey(sortKey), JSON.stringify(map));
    } catch (e) {}
  }

  function setStartupLoader(isVisible) {
    try {
      let visible = !!isVisible;
      toggleStartupSkeleton(visible);
      if (!visible) root.classList.remove('k-custom-filter-pending');
      if (nodes.pagination) nodes.pagination.style.display = visible ? 'none' : '';
      if (visible) forceHideNoMatches('startup-loader');
      if (nodes.countTargets && nodes.countTargets.forEach) {
        nodes.countTargets.forEach(function (node) {
          if (!node) return;
          node.style.visibility = visible ? 'hidden' : '';
        });
      }
      root.classList.toggle('k-custom-startup-pending', visible);

      if (visible) {
        state.startupLoaderGuardTimer = null;
      }
    } catch (e) {}
  }

  function setDeferredApplyLoader(isVisible) {
    let visible = !!isVisible;
    if (state.deferredApplyLoaderActive === visible) return;
    state.deferredApplyLoaderActive = visible;

    if (state.startupMaskActive) return;

    // Collection filtering uses the local shimmer skeleton; never open the global full-screen loader.
  }

  function buildStartupSkeletonHtml() {
    let count = Math.max(8, toNumber(state.perPage, 16) || 16);
    let html = '';
    for (let i = 0; i < count; i += 1) {
      html +=
        '<article class="CT_product-block product-block k-custom-product-skeleton" aria-hidden="true">' +
          '<div class="block-inner">' +
            '<div class="block-inner-inner">' +
              '<div class="k-custom-sk-media k-custom-sk-shimmer"></div>' +
              '<div class="product-info">' +
                '<div class="k-custom-sk-line k-custom-sk-shimmer"></div>' +
                '<div class="k-custom-sk-line k-custom-sk-line--short k-custom-sk-shimmer"></div>' +
                '<div class="k-custom-sk-price-row">' +
                  '<span class="k-custom-sk-price k-custom-sk-shimmer"></span>' +
                  '<span class="k-custom-sk-offer k-custom-sk-shimmer"></span>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</article>';
    }
    return html;
  }

  function toggleStartupSkeleton(visible) {
    if (!nodes.list) return;
    if (visible) {
      if (state.startupSkeletonActive) return;
      state.startupSkeletonBackupHtml = nodes.list.innerHTML;
      nodes.list.innerHTML = buildStartupSkeletonHtml();
      nodes.list.classList.add('k-custom-skeleton-active');
      state.startupSkeletonActive = true;
      return;
    }

    if (!state.startupSkeletonActive) return;
    nodes.list.classList.remove('k-custom-skeleton-active');
    if (!state.loaded && !state.startupPreviewSignature && state.startupSkeletonBackupHtml) {
      nodes.list.innerHTML = state.startupSkeletonBackupHtml;
    }
    state.startupSkeletonBackupHtml = '';
    state.startupSkeletonActive = false;
  }

  function buildPaginationSkeletonHtml(count) {
    let total = Math.max(4, toNumber(count, 6) || 6);
    let html = '';
    for (let i = 0; i < total; i += 1) {
      html +=
        '<article class="CT_product-block product-block k-custom-product-skeleton ct-page-load-skeleton" aria-hidden="true">' +
          '<div class="block-inner">' +
            '<div class="block-inner-inner">' +
              '<div class="k-custom-sk-media k-custom-sk-shimmer"></div>' +
              '<div class="product-info">' +
                '<div class="k-custom-sk-line k-custom-sk-shimmer"></div>' +
                '<div class="k-custom-sk-line k-custom-sk-line--short k-custom-sk-shimmer"></div>' +
                '<div class="k-custom-sk-price-row">' +
                  '<span class="k-custom-sk-price k-custom-sk-shimmer"></span>' +
                  '<span class="k-custom-sk-offer k-custom-sk-shimmer"></span>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</article>';
    }
    return html;
  }

  function showPaginationSkeleton() {
    if (!nodes.list || state.paginationSkeletonActive) return;
    if (nodes.list.querySelector('.ct-page-load-skeleton')) return;
    nodes.list.insertAdjacentHTML('beforeend', buildPaginationSkeletonHtml(PAGINATION_SKELETON_CARD_COUNT));
    state.paginationSkeletonActive = true;
  }

  function hidePaginationSkeleton() {
    if (!nodes.list) return;
    let nodesToRemove = nodes.list.querySelectorAll('.ct-page-load-skeleton');
    nodesToRemove.forEach(function (node) {
      if (node && node.parentNode) node.parentNode.removeChild(node);
    });
    state.paginationSkeletonActive = false;
  }

  function waitMs(ms) {
    return new Promise(function (resolve) {
      window.setTimeout(resolve, Math.max(0, toNumber(ms, 0)));
    });
  }

  function waitForNextPaint() {
    return new Promise(function (resolve) {
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(resolve);
        });
        return;
      }
      window.setTimeout(resolve, 16);
    });
  }

  let NEAR_STORE_LABEL_MAP = {
    "AHMALP": "Alpha Mall",
    "ATPCTR": "Court Road",
    "AURNBR": "Nirala Bazar",
    "BGMABR": "Ambedkar Road 2",
    "BGMMPR": "Mahatma Phule Road",
    "BIMJPR": "Jp Road",
    "BLRBRO": "Brookefield",
    "BLR4JN": "4th Block Jayanagar",
    "BLRARS": "Ars Complex Malleswaram",
    "BLRBEL": "Bel Road",
    "BLRBSW": "Basaweshwar Nagar",
    "BLRCST": "Commercial Street",
    "BLRDVG": "Dvg Road",
    "BLRFSB": "Forum South Bangalore",
    "BLRGRD": "Garuda Mall",
    "BLRHNR": "Hennur Road",
    "BLRHSR": "Hsr Layout",
    "BLRIND": "Indiranagar",
    "BLRJAY": "Jayanagar",
    "BLRKGP": "Kathriguppe",
    "BLRKHL": "Kammanahalli",
    "BLRKMG": "Kormangala",
    "BLRKRP": "K R Puram",
    "BLRMAL": "Malleswaram",
    "BLRMNT": "Mantri Mall",
    "BLRMOA": "Mall Of Asia",
    "BLRNKM": "Nexus Koramangala Mall",
    "BLRORN": "Orion Mall",
    "BLRRMM": "Royal Meenakshi Mall",
    "BLRRMZ": "Rmz Mall",
    "BLRRRN": "Rr Nagar",
    "BLRSKR": "Sahakarnagar",
    "BLRSMR": "Sarjapur Main Road",
    "BLRSNK": "Forum Shantiniketan Mall",
    "BLRVGA": "Vega City Mall",
    "BLRWMR": "Whitefield Main Road",
    "BLRWPX": "Phoenix Mall Whitefield",
    "BPLDCM": "Db City Mall",
    "CBTBFM": "Brookefield Mall",
    "CBTRSP": "Rs Puram",
    "CDRELT": "Elante Mall",
    "CHNADR": "Adyar",
    "CHNCTN": "T Nagar",
    "CHNEXA": "Express Avenue Mall",
    "CHNMRN": "Marina Mall",
    "CHNMWR": "Mogappair West Road",
    "CHNNVM": "Nexus Vijaya Mall",
    "CHNPMR": "Paper Mill Road",
    "CHNPNX": "Phoenix Mall Velachery",
    "CHNSLR": "Selaiyur",
    "CHNTPM": "Thoraipakkam",
    "CHNVBR": "Velachery Bypass Road",
    "CHNVRM": "Vr Mall 1",
    "DELKMN": "Kamla Nagar",
    "ECOM": "Ecom",
    "ECOM-ORDER": "Ecom Sales",
    "GTRLXM": "Laxmipuram",
    "GURMGF": "Mgf Metro Politian Mall",
    "GWTGSR": "G S Road",
    "HBLGKR": "Gokul Road",
    "HBLKPR": "Koppikar Road",
    "HOSAPL": "Avalapalli",
    "HSPVCR": "Vijayanagar College Road",
    "HYDASR": "As Rao Nagar",
    "HYDATP": "Attapur",
    "HYDDSL": "Dsl Virtue Mall",
    "HYDGBL": "Gachibowli",
    "HYDHMT": "Himayath Nagar",
    "HYDIOM": "Inorbit Mall 1",
    "HYDJBH": "Jubilee Hills",
    "HYDKDP": "Kondapur",
    "HYDKOK": "Kokapet",
    "HYDKPL": "Kompalli",
    "HYDKTL": "Kukatpally",
    "HYDKTP": "Kothapet",
    "HYDLSM": "Lakeshore Mall",
    "HYDLTM": "Lt Mall",
    "HYDNEX": "Nexus Mall 2",
    "HYDNGD": "Nallagandla",
    "HYDPKL": "Parklane",
    "HYDPNG": "Panjagutta",
    "HYDSCC": "Sarath City Mall",
    "HYDVPR": "Vanatsalipuram",
    "IDR 140": "Scheme No 140",
    "IDROBT": "Orbit Mall",
    "IDRPNX": "Pheonix Citadel Mall",
    "IDRSNR": "Sneh Nagar",
    "KCHFRM": "Forum Mall",
    "KCHLUL": "Lulu Mall 2",
    "KCHMGR": "Mg Road 1",
    "KHMWRD": "Wyra Road",
    "KKNRKP": "Rama Krishnarao Pet",
    "KPRRJR": "Rajarampuri",
    "KRLBGN": "Bhagya Nagar",
    "KRMABR": "Ambedkar Road 1",
    "LUKPXP": "Phoenix Palassio Mall",
    "MDRANR": "Anna Nagar",
    "MGLBMT": "Balmatta",
    "MGLCCM": "City Center Mall",
    "MGLNFM": "Nexus Fiza Mall",
    "MUMNSM": "Nexus Seawood Mall",
    "MUMPMC": "Phoenix Market City",
    "MUMRCT": "R City Mall",
    "MYSDUR": "Devraj Urs Road",
    "MYSMOM": "Mall Of Mysore",
    "MYSNEX": "Nexus Mall 1",
    "NLRMBR": "Mini Bypass Road",
    "NZMPGN": "Pragathi Nagar",
    "ONGMMR": "M M Road",
    "PDCMST": "Mission Street",
    "PDCPDM": "Providence Mall",
    "PUNKGP": "Koregaon Park",
    "PUNMLM": "Mall Of Milleennium",
    "PUNPMC": "Pimpri Chinchwad",
    "PUNPVN": "Phoenix Mall Viman Nagar",
    "PUNSBH": "Solitaire Business Hub",
    "PUNWST": "Westend Mall",
    "RJMDNP": "Danvaipeta",
    "SLMSCR": "Sarada College Road",
    "SURVRM": "Vr Mall 2",
    "TIRPMR": "Palladam Main Road",
    "TPLKBR": "Karur Bypass Road",
    "TRPARD": "Air Road",
    "TRVLUL": "Lulu Mall 1",
    "TRVMOT": "Mall Of Travancore",
    "UDPMMT": "Main Market",
    "VIGIBM": "Inorbit Mall 2",
    "VIGMRD": "Madhurwada",
    "VIGSRP": "Siripuram",
    "VJNSRN": "Srinivasa Nagar",
    "VJWGTN": "Gayathri Nagar",
    "VJWMGR": "Mg Road 2",
    "WH": "Warehouse",
    "WRLNGR": "Naim Nagar"
  };
  function mapNearStoreLabel(codeOrLabel) {
    let raw = String(codeOrLabel || "").trim();
    let code = raw.toUpperCase();
    if (Object.prototype.hasOwnProperty.call(NEAR_STORE_LABEL_MAP, code)) {
      return NEAR_STORE_LABEL_MAP[code];
    }
    return raw;
  }

  function handleize(value) {
    return String(value || '')
      .toLowerCase()
      .trim()
      .replace(/['"]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function toNumber(value, fallback) {
    let n = Number(value);
    return Number.isFinite(n) ? n : fallback;
  }

  function isIOSWebKit() {
    let ua = window.navigator && window.navigator.userAgent ? window.navigator.userAgent : '';
    let platform = window.navigator && window.navigator.platform ? window.navigator.platform : '';
    let touchPoints = window.navigator ? Number(window.navigator.maxTouchPoints || 0) : 0;
    return /iPhone|iPad|iPod/i.test(ua) || (platform === 'MacIntel' && touchPoints > 1);
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function parseList(raw) {
    if (raw == null) return [];
    if (Array.isArray(raw)) return raw.map(function (v) { return String(v || '').trim(); }).filter(Boolean);
    let text = String(raw || '').trim();
    if (!text) return [];
    if (text.charAt(0) === '[' || text.charAt(0) === '{') {
      try {
        let parsed = JSON.parse(text);
        return parseList(parsed);
      } catch (e) {}
    }
    if (text.indexOf(',') > -1) {
      return text.split(',').map(function (v) { return String(v || '').trim(); }).filter(Boolean);
    }
    return [text];
  }

  function readStorageValue(key) {
    try {
      if (window.KushalsStorageTTL && typeof window.KushalsStorageTTL.get === 'function') {
        let ttlValue = window.KushalsStorageTTL.get(key);
        if (ttlValue != null && String(ttlValue).trim() !== '') return ttlValue;
      }
    } catch (e) {}
    try {
      let localValue = window.localStorage ? window.localStorage.getItem(key) : '';
      if (localValue != null && String(localValue).trim() !== '') return localValue;
    } catch (e) {}
    return '';
  }

  function getStoredCurrentLocationCity() {
    let locationStoreRaw = readStorageValue('location_store');
    let locationStoreText = String(locationStoreRaw || '').trim();
    if (locationStoreText) {
      try {
        let parsed = typeof locationStoreRaw === 'string' ? JSON.parse(locationStoreText) : locationStoreRaw;
        let city = parsed && (
          parsed.city ||
          parsed.cityName ||
          parsed.state ||
          (Array.isArray(parsed.storeList) && parsed.storeList[0] && (parsed.storeList[0].cityName || parsed.storeList[0].city)) ||
          ''
        );
        city = String(city || '').trim();
        if (city) return city;
      } catch (e) {}
    }

    let currentLocation = String(readStorageValue('current_location') || '').trim();
    if (currentLocation) return currentLocation;

    if (!locationStoreText) return '';
    try {
      let parsed = JSON.parse(locationStoreText);
      let city = parsed && (parsed.city || parsed.state || parsed.cityName || '');
      return String(city || '').trim();
    } catch (e) {
      return '';
    }
  }

  function normalizeNearStoreCode(value) {
    return String(value || '')
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9]/g, '');
  }

  function getLocationStorePayload() {
    let raw = readStorageValue('location_store');
    if (!raw) return null;
    if (typeof raw === 'string') {
      let text = String(raw || '').trim();
      if (!text) return null;
      try {
        return JSON.parse(text);
      } catch (e) {
        return null;
      }
    }
    if (typeof raw === 'object') return raw;
    return null;
  }

  function getLocationStoreListFromPayload(payload) {
    if (!payload) return [];
    if (Array.isArray(payload)) return payload;
    if (payload && typeof payload === 'object') {
      if (Array.isArray(payload.storeList)) return payload.storeList;
      if (Array.isArray(payload.stores)) return payload.stores;
      if (Array.isArray(payload.data)) return payload.data;
    }
    return [];
  }

  function getLocationStoreShortCodeSet() {
    let set = new Set();
    let payload = getLocationStorePayload();
    let stores = getLocationStoreListFromPayload(payload);
    stores.forEach(function (store) {
      if (!store || typeof store !== 'object') return;
      let code = normalizeNearStoreCode(store.shortCode || '');
      if (!code) return;
      set.add(code);
    });
    return set;
  }

  function hasLocationStoreEntries() {
    let payload = getLocationStorePayload();
    let stores = getLocationStoreListFromPayload(payload);
    return Array.isArray(stores) && stores.length > 0;
  }

  function setNearbyToggleVisibility(isVisible) {
    root.querySelectorAll('.ct_nearby-products-toggle-wrap').forEach(function (wrap) {
      if (!wrap) return;
      wrap.style.display = '';
    });
  }

  function isNearStoreAllowedByLocationStore(input, codeSet) {
    let hasCodeRestriction = codeSet && codeSet.size > 0;
    if (!hasCodeRestriction) return true;
    let code = normalizeNearStoreCode(getNearStoreCodeFromInput(input));
    return !!(code && codeSet.has(code));
  }

  function getLocationStoreSignature() {
    let city = String(readStorageValue('current_location') || '').trim();
    let raw = '';
    try {
      raw = String(readStorageValue('location_store') || '');
    } catch (e) {}
    return city + '|' + raw;
  }

  function getNearStoreCodeFromInput(input) {
    if (!input) return '';
    let item = input.closest('.filter-group__item');
    if (item) {
      let itemCode = normalizeNearStoreCode(item.getAttribute('data-near-store-code'));
      if (itemCode) return itemCode;
      let textNode = item.querySelector('.default_filter-group__item__text[data-near-store-code], .filter-group__item__text[data-near-store-code]');
      if (textNode) {
        let textCode = normalizeNearStoreCode(textNode.getAttribute('data-near-store-code'));
        if (textCode) return textCode;
      }
    }
    return normalizeNearStoreCode(input.value || '');
  }

  function areAvailableCityOptionsReady() {
    return !!state.loaded && getAvailableCityFilterInputs().length > 0;
  }

  function refreshNearbyToggleVisibility() {
    if (!hasLocationStoreEntries()) {
      setNearbyToggleVisibility(false);
      return false;
    }
    // Available-city options are only rendered after product hydration, so an
    // empty option list means "not known yet", not "city unsupported". Hiding
    // here would kill the toggle on first paint with nothing to restore it.
    if (!areAvailableCityOptionsReady()) {
      setNearbyToggleVisibility(true);
      return true;
    }
    setNearbyToggleVisibility(!!findAvailableCityInputForCity(getStoredCurrentLocationCity()));
    return true;
  }

  function applyNearStoreShortCodeRestrictionInDom() {
    let hasNearbyStores = hasLocationStoreEntries();
    refreshNearbyToggleVisibility();

    let allowedCodes = getLocationStoreShortCodeSet();
    let restrictionEnabled = hasNearbyStores && allowedCodes.size > 0;
    let selectionChanged = false;
    let disabledCount = 0;
    let checkedCount = 0;

    root.querySelectorAll('input[name*="near_stores"]').forEach(function (input) {
      let item = input.closest('.filter-group__item');
      let textNode = item ? item.querySelector('.default_filter-group__item__text, .filter-group__item__text') : null;
      let code = normalizeNearStoreCode(input.value || '');
      if (!code) return;

      if (item) item.setAttribute('data-near-store-code', code);
      if (textNode) textNode.setAttribute('data-near-store-code', code);

      if (!hasNearbyStores) {
        if (input.checked) {
          input.checked = false;
          selectionChanged = true;
          checkedCount++;
        }
        input.disabled = true;
        if (item) item.style.display = 'none';
        disabledCount++;
        return;
      }

      let isAllowed = !restrictionEnabled || isNearStoreAllowedByLocationStore(input, allowedCodes);
      if (!isAllowed) {
        if (input.checked) {
          input.checked = false;
          selectionChanged = true;
          checkedCount++;
        }
        input.disabled = true;
        if (item) item.style.display = 'none';
        disabledCount++;
        return;
      }

      if (item && item.style && item.style.display === 'none') item.style.display = '';
      if (!input.checked) input.disabled = false;
    });

    return {
      hasNearbyStores: hasNearbyStores,
      restrictionEnabled: restrictionEnabled,
      allowedCodes: allowedCodes,
      selectionChanged: selectionChanged
    };
  }

  function refreshNearStoreRestrictionFromLocationChange(reason) {
    ensureAllNearStoreOptionsPresent();
    let result = applyNearStoreShortCodeRestrictionInDom();

    let availableCitySelectionChanged = syncAvailableCityFilterFromLocationChange();
    collectActiveState();

    syncFilterUiFromState({
      syncChips: false,
      syncCount: false,
    });

    if ((result && result.selectionChanged) || availableCitySelectionChanged) {
      applyFilters();
      return;
    }
    syncFilterUiFromState({
      syncOptions: false,
      syncHeaderToggle: false,
    });
  }

  function bindLocationStoreWatcher() {
    if (state.locationStoreWatcherBound) return;
    state.locationStoreWatcherBound = true;
    state.locationStoreSignature = getLocationStoreSignature();

    let handleMaybeChanged = function (reason) {
      let nextSig = getLocationStoreSignature();
      if (nextSig === state.locationStoreSignature) return;
      state.locationStoreSignature = nextSig;
      refreshNearStoreRestrictionFromLocationChange(reason || 'location_store_change');
    };

    window.addEventListener('storage', function (event) {
      let key = event && event.key ? String(event.key) : '';
      if (key && key !== 'location_store' && key !== 'current_location') return;
      handleMaybeChanged('storage_event');
    });

    if (!window.__kCustomFilterLocationStoragePatchApplied && window.localStorage) {
      window.__kCustomFilterLocationStoragePatchApplied = true;
      let originalSetItem = window.localStorage.setItem;
      let originalRemoveItem = window.localStorage.removeItem;

      try {
        window.localStorage.setItem = function (key, value) {
          let result = originalSetItem.apply(this, arguments);
          if (key === 'location_store' || key === 'current_location') {
            setTimeout(function () { handleMaybeChanged('setItem'); }, 0);
          }
          return result;
        };
      } catch (e) {}

      try {
        window.localStorage.removeItem = function (key) {
          let result = originalRemoveItem.apply(this, arguments);
          if (key === 'location_store' || key === 'current_location') {
            setTimeout(function () { handleMaybeChanged('removeItem'); }, 0);
          }
          return result;
        };
      } catch (e) {}
    }
  }

  function getSortByFromUrl() {
    let params = new URLSearchParams(window.location.search);
    let raw = params.get('sort_by');
    if (raw != null && String(raw).trim() !== '') {
      return normalizeSortKey(raw);
    }

    let uiSort = getSortByFromUiState();
    if (uiSort) return normalizeSortKey(uiSort);

    return SORT_KEYS.RECOMMENDED;
  }

  function getSortByFromUiState() {
    let checkedSortInput = root.querySelector('input[name="sort_by"]:checked');
    if (checkedSortInput && checkedSortInput.value != null) {
      let inputSort = normalizeSortKey(checkedSortInput.value);
      if (inputSort) return inputSort;
    }

    let activeSortLink = root.querySelector(
      '.CT_link-dropdown__options .CT_short_link.link-dropdown__link--active, .link-dropdown__options .link-dropdown__link.link-dropdown__link--active'
    );
    if (activeSortLink) {
      let hrefSort = getSortValueFromHref(activeSortLink.getAttribute('href'));
      if (hrefSort) return hrefSort;
    }

    return '';
  }

  function normalizeSortKey(sortKey) {
    let key = String(sortKey || '').trim().toLowerCase();
    if (!key) key = SORT_KEYS.RECOMMENDED;
    key = SORT_KEY_ALIASES[key] || key;
    return Object.prototype.hasOwnProperty.call(SORT_LABELS, key) ? key : SORT_KEYS.RECOMMENDED;
  }

  function requiresServerSortOrder(sortKey) {
    let key = normalizeSortKey(sortKey);
    return (
      key === SORT_KEYS.BEST_SELLER ||
      key === SORT_KEYS.NEW_ARRIVAL ||
      key === SORT_KEYS.DATE_OLD_TO_NEW
    );
  }

  function shouldApplyAfterLoadNow() {
    return (
      state.deferApplyAfterLoad ||
      Object.keys(state.active || {}).length > 0 ||
      !!(state.priceRange && (state.priceRange.min != null || state.priceRange.max != null)) ||
      normalizeSortKey(state.sortBy || SORT_KEYS.RECOMMENDED) !== SORT_KEYS.RECOMMENDED
    );
  }

  function hasAnyActiveFilterState() {
    return (
      Object.keys(state.active || {}).length > 0 ||
      !!(state.priceRange && (state.priceRange.min != null || state.priceRange.max != null))
    );
  }

  function syncFilteredFromProductsForUnfilteredState() {
    if (hasAnyActiveFilterState()) return;
    if (normalizeSortKey(state.sortBy || SORT_KEYS.RECOMMENDED) !== SORT_KEYS.RECOMMENDED) return;
    state.filtered = sortProducts(Array.isArray(state.products) ? state.products.slice() : []);
  }

  function getRenderedProductCardCount() {
    if (!nodes.list) return 0;
    return nodes.list.querySelectorAll('.product-block[data-product-id]').length;
  }

  function getProductTimestamp(product) {
    if (!product || typeof product !== 'object') return 0;
    return Date.parse(product.created_at || '') || Date.parse(product.published_at || '') || 0;
  }

  function getBestSellerScore(product) {
    if (!product || typeof product !== 'object') return 0;

    let score = 0;
    let tags = Array.isArray(product.tags) ? product.tags : parseList(product.tags);
    let tagText = tags.map(function (t) { return String(t || '').toLowerCase(); }).join('|');
    let htmlText = String(product.card_html || '').toLowerCase();

    if (/ct_bestseller_badge|best[\s-]?seller/.test(htmlText)) score += 1000;
    if (/best[\s-]?seller/.test(tagText)) score += 500;
    if (/top[\s-]?seller/.test(tagText)) score += 350;
    if (/bestselling/.test(tagText)) score += 300;

    return score;
  }

  function getTotalCountHint() {
    let first = root.querySelector('.CT_fil_utility-bar__centre span, .ct_utility-bar__centre span');
    if (!first) return 0;
    let m = String(first.textContent || '').match(/(\d+)/);
    return m ? toNumber(m[1], 0) : 0;
  }

  function getCustomerId() {
    try {
      if (window.__st && window.__st.cid != null) return String(window.__st.cid);
    } catch (e) {}
    return '';
  }

  function pushCleverTapEvent(eventName, payload) {
    if (!eventName) return;
    try {
      if (window.clevertap && clevertap.event && typeof clevertap.event.push === 'function') {
        clevertap.event.push(String(eventName), payload || {});
      }
    } catch (e) {}
  }

  function parseCountFromText(text) {
    let normalized = String(text || '').replace(/,/g, '');
    let match = normalized.match(/\(\s*(\d+)\s*\)/);
    if (!match) return 0;
    return toNumber(match[1], 0);
  }

  function getOptionCountFromInput(input) {
    if (!input) return 0;
    let item = input.closest('.filter-group__item');
    if (!item) return 0;

    let badgeCountNode = item.querySelector('.ct-filter-count');
    if (badgeCountNode) {
      let badgeCount = toNumber(String(badgeCountNode.textContent || '').replace(/[^0-9]/g, ''), 0);
      if (badgeCount > 0) return badgeCount;
    }

    let countNode = item.querySelector('.filter-group__item__count');
    if (countNode) {
      let count = parseCountFromText(countNode.textContent || '');
      if (count > 0) return count;
    }

    let labelNode =
      item.querySelector('.default_filter-group__item__text') ||
      item.querySelector('.ct-filter-name') ||
      item.querySelector('.filter-group__item__text');
    if (labelNode) return parseCountFromText(labelNode.textContent || '');

    return 0;
  }

  function getSelectedTabCategoryLabel() {
    let plpList = root.querySelector('#CollectionFilterForm_custom_dd .plp_filter_main');
    if (!plpList) return 'All';

    let selectedInputs = Array.from(plpList.querySelectorAll(PLP_INPUT_SELECTOR + ':checked'));
    if (selectedInputs.length) {
      // Multi-select: report every chip that is on, in strip order
      let selectedLabels = [];
      selectedInputs.forEach(function (input) {
        let label = deriveOptionLabel(input);
        if (label && selectedLabels.indexOf(label) === -1) selectedLabels.push(label);
      });
      if (selectedLabels.length) return selectedLabels.join(', ');
    }

    let radios = Array.from(plpList.querySelectorAll(PLP_INPUT_SELECTOR));
    if (radios.length) {
      let filterName = String(radios[0].name || '');
      let rememberedToken = filterName ? String((state.lastSelectedTokenByName || {})[filterName] || '') : '';
      if (rememberedToken) {
        for (let i = 0; i < radios.length; i += 1) {
          let radio = radios[i];
          if (deriveToken(radio) !== rememberedToken) continue;
          let rememberedLabel = deriveOptionLabel(radio);
          if (rememberedLabel) return rememberedLabel;
        }
      }

      let filterKey = filterName ? mapNameToKey(filterName, radios[0]) : '';
      let activeTokens = filterKey ? (state.active && state.active[filterKey] ? state.active[filterKey] : []) : [];
      if (activeTokens.length === 1) {
        let activeToken = String(activeTokens[0] || '');
        for (let j = 0; j < radios.length; j += 1) {
          let candidate = radios[j];
          if (deriveToken(candidate) !== activeToken) continue;
          let activeLabel = deriveOptionLabel(candidate);
          if (activeLabel) return activeLabel;
        }
      }
    }

    let activeAllText = plpList.querySelector('a.filter-group__clear-link.active span');
    if (activeAllText) {
      let allLabel = String(activeAllText.textContent || '').trim();
      if (allLabel) return allLabel;
    }

    return 'All';
  }

  function getVisibleMainFilterLabels() {
    let labels = [];
    let seen = {};
    let form = root.querySelector('#CollectionFilterForm');
    if (!form) return labels;

    form.querySelectorAll('.ct_filter-group.filter-group').forEach(function (group) {
      if (!group || (group.style && group.style.display === 'none')) return;
      let heading = group.querySelector('.filter-group__heading__text');
      if (!heading) return;
      let label = String(heading.textContent || '').replace(/\s+/g, ' ').trim();
      if (!label || seen[label]) return;
      seen[label] = true;
      labels.push(label);
    });

    return labels;
  }

  function getCurrentProductCount() {
    if (state.loaded) return toNumber((state.filtered || []).length, 0);
    return getTotalCountHint();
  }

  function getFilterGroupLabelFromKey(key) {
    let map = {
      category: 'Category',
      stylesubcategory: 'Style/Subcategory',
      craftmanship: 'Craftsmanship',
      occasion: 'Occasion',
      metaltype: 'Metal Type',
      stonetype: 'Stone Type',
      closuretype: 'Closure Type',
      designshape: 'Design Shape',
      motif: 'Motif',
      returnable: 'Returnable',
      nearstores: 'Near Stores',
      availablecities: 'Available Cities',
      size: 'Size',
      color: 'Colors',
      polish: 'Polish',
      price: 'Price',
    };
    return map[String(key || '')] || 'Filter';
  }

  function normalizeEventFilterType(input) {
    if (!input) return 'unknown';
    if (isPriceMinInput(input) || isPriceMaxInput(input)) return 'price';
    let key = mapNameToKey(input.name, input);
    if (!key) return 'unknown';
    if (key.indexOf('__') === 0) key = key.replace(/^__+/, '');
    return key || 'unknown';
  }

  function getPriceRangeLabelFromContainer(container) {
    if (!container || !container.querySelector) return '';
    let minInput = container.querySelector('input.cc-price-range__input--min, input[name="filter.v.price.gte"], input[name="PriceFilterMin"]');
    let maxInput = container.querySelector('input.cc-price-range__input--max, input[name="filter.v.price.lte"], input[name="PriceFilterMax"]');
    let minVal = minInput ? String(minInput.value || '').trim() : '';
    let maxVal = maxInput ? String(maxInput.value || '').trim() : '';
    if (!minVal && !maxVal) return '';
    let minText = minVal || '0';
    let maxText = maxVal || 'Max';
    return minText + '-' + maxText;
  }

  function getPriceRangeLabelFromState(priceRange) {
    if (!priceRange || (priceRange.min == null && priceRange.max == null)) return '';
    let minText = priceRange.min == null ? '0' : String(priceRange.min);
    let maxText = priceRange.max == null ? 'Max' : String(priceRange.max);
    return minText + '-' + maxText;
  }

  function buildFiltersSnapshotPayload(activeState, priceRange) {
    let payload = {};
    let source = activeState || {};
    let lookup = buildAppliedLabelLookup();

    Object.keys(source).forEach(function (key) {
      let tokens = source[key] || [];
      if (!tokens.length) return;
      let groupLabel = getFilterGroupLabelFromKey(key);
      payload[groupLabel] = tokens.map(function (token) {
        let lookupItem = lookup[key + '::' + token];
        return (lookupItem && lookupItem.label) || humanizeToken(token);
      });
    });

    let priceLabel = getPriceRangeLabelFromState(priceRange);
    if (priceLabel) payload.Price = [priceLabel];

    return payload;
  }

  function getAppliedFilterCountFromSnapshot(snapshot) {
    let source = snapshot || {};
    let active = source.active || {};
    let total = 0;

    Object.keys(active).forEach(function (key) {
      total += (active[key] || []).length;
    });

    let price = source.price || null;
    if (price && (price.min != null || price.max != null)) total += 1;
    return total;
  }

  function getRemovedLabelsFromSnapshots(previousSnapshot, nextSnapshot, lookup) {
    let before = previousSnapshot || {};
    let after = nextSnapshot || {};
    let beforeActive = before.active || {};
    let afterActive = after.active || {};
    let labels = [];
    let seen = {};
    let resolvedLookup = lookup || buildAppliedLabelLookup();

    Object.keys(beforeActive).forEach(function (key) {
      let beforeTokens = beforeActive[key] || [];
      let afterSet = {};
      (afterActive[key] || []).forEach(function (token) {
        let safeToken = String(token || '');
        if (safeToken) afterSet[safeToken] = true;
      });

      beforeTokens.forEach(function (token) {
        let safeToken = String(token || '');
        if (!safeToken || afterSet[safeToken]) return;
        let lookupItem = resolvedLookup[key + '::' + safeToken];
        let label = (lookupItem && lookupItem.label) || humanizeToken(safeToken);
        if (!label || seen[label]) return;
        seen[label] = true;
        labels.push(label);
      });
    });

    let beforePriceLabel = getPriceRangeLabelFromState(before.price || null);
    let afterPriceLabel = getPriceRangeLabelFromState(after.price || null);
    if (beforePriceLabel && beforePriceLabel !== afterPriceLabel && !seen[beforePriceLabel]) {
      labels.push(beforePriceLabel);
    }

    return labels;
  }

  function buildFilterClearedPartialPayload(previousSnapshot, nextSnapshot) {
    if (!previousSnapshot || !nextSnapshot) return null;

    let beforeCount = getAppliedFilterCountFromSnapshot(previousSnapshot);
    let afterCount = getAppliedFilterCountFromSnapshot(nextSnapshot);

    if (beforeCount <= 1) return null;
    if (afterCount <= 0) return null;
    if (afterCount >= beforeCount) return null;

    let lookup = buildAppliedLabelLookup();
    let removed = getRemovedLabelsFromSnapshots(previousSnapshot, nextSnapshot, lookup);
    if (!removed.length) return null;
    return {
      filter_removed: removed.join(', '),
    };
  }

  function getVisibleBreakerOptionLabels(scopeRoot) {
    let labels = [];
    let seen = {};
    if (!scopeRoot || !scopeRoot.querySelectorAll) return labels;

    scopeRoot.querySelectorAll('.filter-group__item').forEach(function (item) {
      if (!item) return;
      if (item.style && item.style.display === 'none') return;
      let input = item.querySelector('input.filter-group__checkbox, input.breaker_filter-group__checkbox');
      if (!input || !input.name || input.name === 'sort_by') return;
      if (input.disabled) return;
      let label = deriveOptionLabel(input);
      if (!label || seen[label]) return;
      seen[label] = true;
      labels.push(label);
    });

    return labels;
  }

  function getBreakerActiveGroupElement(breakerForm) {
    if (!breakerForm || !breakerForm.querySelectorAll) return null;
    let groups = Array.from(breakerForm.querySelectorAll('.ct_filter-group.filter-group'));
    if (!groups.length) return null;

    for (let i = 0; i < groups.length; i += 1) {
      let group = groups[i];
      if (!group || (group.style && group.style.display === 'none')) continue;
      let heading = group.querySelector('a[data-toggle-target], .filter-group__heading[data-toggle-target]');
      if (heading && heading.classList.contains('Show_filter')) return group;
      let items = group.querySelector('.filter-group__items');
      if (items && items.classList.contains('Show_filter')) return group;
    }

    for (let j = 0; j < groups.length; j += 1) {
      let candidate = groups[j];
      if (!candidate || (candidate.style && candidate.style.display === 'none')) continue;
      return candidate;
    }

    return null;
  }

  function getBreakerGroupFilterKey(group) {
    if (!group || !group.querySelectorAll) return '';
    let inputs = group.querySelectorAll('input.filter-group__checkbox, input.breaker_filter-group__checkbox');
    for (let i = 0; i < inputs.length; i += 1) {
      let input = inputs[i];
      if (!input || !input.name || input.name === 'sort_by') continue;
      let key = mapNameToKey(input.name, input);
      if (!key || key.indexOf('__') === 0) continue;
      return key;
    }
    return '';
  }

  function getBreakerActiveHeadingLabel(breakerForm) {
    if (!breakerForm || !breakerForm.querySelector) return '';
    let activeGroup = getBreakerActiveGroupElement(breakerForm);
    if (!activeGroup) return '';
    let heading = activeGroup.querySelector('.filter-group__heading__text');
    if (!heading) return '';
    return String(heading.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function emitQuickFilterSelectedEvent(inputOrNull, selectedValueOverride) {
    let selectedValue = String(selectedValueOverride || '').trim();
    let filterType = 'Category';
    let productCount = getCurrentProductCount();

    if (inputOrNull) {
      filterType = deriveParentCategoryLabel(inputOrNull) || getFilterGroupLabelFromKey(normalizeEventFilterType(inputOrNull));
      if (!selectedValue) selectedValue = deriveOptionLabel(inputOrNull) || String(inputOrNull.value || '').trim();
      let optionCount = getOptionCountFromInput(inputOrNull);
      if (optionCount > 0) productCount = optionCount;
    }

    if (!selectedValue) selectedValue = 'All';

    pushCleverTapEvent(CLEVERTAP_EVENTS.QUICK_FILTER_SELECTED, {
      filter_type: filterType,
      filter_value: selectedValue,
      product_count: productCount,
      userId: getCustomerId(),
    });
  }

  function emitMainFilterOpenedEvent() {
    let allLabels = getVisibleMainFilterLabels();
    pushCleverTapEvent(CLEVERTAP_EVENTS.MAIN_FILTER_OPENED, {
      quick_filter_context: getSelectedTabCategoryLabel(),
      visible_filters: allLabels,
      product_count: getCurrentProductCount(),
      userId: getCustomerId(),
    });
  }

  function emitMainFilterOpenedEventOnce() {
    let now = Date.now();
    let lastAt = toNumber(state.lastMainFilterOpenedEventAt, 0);
    if (lastAt > 0 && now - lastAt < 600) return;
    state.lastMainFilterOpenedEventAt = now;
    emitMainFilterOpenedEvent();
  }

  function buildMainFilterSelectionEventPayload(snapshot) {
    if (!snapshot) return null;
    let activeState = snapshot.active || {};
    let priceRange = snapshot.price || null;
    let lookup = buildAppliedLabelLookup();
    let keyOrder = [
      'category',
      'stylesubcategory',
      'craftmanship',
      'occasion',
      'color',
      'polish',
      'metaltype',
      'stonetype',
      'closuretype',
      'designshape',
      'size',
      'motif',
      'returnable',
      'nearstores',
      'availablecities',
    ];

    let orderedKeys = [];
    keyOrder.forEach(function (key) {
      if (activeState[key] && activeState[key].length) orderedKeys.push(key);
    });
    Object.keys(activeState).forEach(function (key) {
      if (!activeState[key] || !activeState[key].length) return;
      if (orderedKeys.indexOf(key) > -1) return;
      orderedKeys.push(key);
    });

    let filterGroups = [];
    let selectedChunks = [];

    orderedKeys.forEach(function (key) {
      let tokens = activeState[key] || [];
      if (!tokens.length) return;
      let labels = tokens.map(function (token) {
        let lookupItem = lookup[key + '::' + token];
        return (lookupItem && lookupItem.label) || humanizeToken(token);
      }).filter(Boolean);
      if (!labels.length) return;
      filterGroups.push(getFilterGroupLabelFromKey(key));
      selectedChunks.push(labels.join(', '));
    });

    let priceLabel = getPriceRangeLabelFromState(priceRange);
    if (priceLabel) {
      filterGroups.push('Price');
      selectedChunks.push(priceLabel);
    }

    if (!selectedChunks.length) return null;
    return {
      filter_group: filterGroups.join(', '),
      selected_value: selectedChunks.join(' | '),
    };
  }

  function emitMainFilterOptionSelectedEvent(snapshot) {
    let payload = buildMainFilterSelectionEventPayload(snapshot);
    if (!payload) return;
    pushCleverTapEvent(CLEVERTAP_EVENTS.MAIN_FILTER_OPTION_SELECTED, {
      filter_group: payload.filter_group,
      selected_value: payload.selected_value,
      plp_context: getSelectedTabCategoryLabel(),
    });
  }

  function emitBreakerFilterInteractedEvent(input, filterForm) {
    if (!input) return;
    if (input.name === 'sort_by') return;
    let key = normalizeEventFilterType(input);
    if (key === 'sort' || key === 'unknown') return;

    let selectedValue = '';
    if (isPriceMinInput(input) || isPriceMaxInput(input)) {
      selectedValue = getPriceRangeLabelFromContainer(filterForm || input.closest('.collection-filter-form'));
    } else {
      selectedValue = deriveOptionLabel(input) || String(input.value || '').trim();
    }

    pushCleverTapEvent(CLEVERTAP_EVENTS.BREAKER_FILTER_INTERACTED, {
      filter_type: key,
      selected_value: selectedValue,
      position_in_feed: BREAKER_POSITION_IN_FEED,
      previous_filters: buildFiltersSnapshotPayload(state.active, state.priceRange),
      userId: getCustomerId(),
    });
  }

  function emitBreakerFilterSelectedEvent(breakerForm, snapshot) {
    if (!breakerForm || !snapshot) return;
    let activeGroup = getBreakerActiveGroupElement(breakerForm);
    let filterType = getBreakerActiveHeadingLabel(breakerForm) || 'All';
    let filterKey = getBreakerGroupFilterKey(activeGroup);

    let selectedValue = '';
    if (filterKey) {
      selectedValue = (snapshot.active && snapshot.active[filterKey] ? snapshot.active[filterKey] : []).join(', ');
    } else if (String(filterType).toLowerCase() === 'price') {
      selectedValue = getPriceRangeLabelFromState(snapshot.price);
    }

    pushCleverTapEvent(CLEVERTAP_EVENTS.BREAKER_FILTER_SELECTED, {
      filter_type: filterType,
      position_in_feed: BREAKER_POSITION_IN_FEED,
      selected_value: selectedValue,
      plp_context: getSelectedTabCategoryLabel(),
      userId: getCustomerId(),
      filter_options_shown: getVisibleBreakerOptionLabels(activeGroup || breakerForm),
    });
  }

  function emitFilterClearedEvent(filterGroup, context) {
    let resolvedGroup = String(filterGroup || '').trim() || 'All';
    let payload = { filter_group: resolvedGroup };

    let previousSnapshot = context && context.previousSnapshot ? context.previousSnapshot : null;
    let nextSnapshot = context && context.nextSnapshot ? context.nextSnapshot : null;
    let partialPayload = buildFilterClearedPartialPayload(previousSnapshot, nextSnapshot);
    if (partialPayload) {
      payload.filter_removed = partialPayload.filter_removed;
    }
    payload.plp_context = getSelectedTabCategoryLabel();

    pushCleverTapEvent(CLEVERTAP_EVENTS.FILTER_CLEARED, payload);
  }

  function getPriceInputs() {
    let minInput = root.querySelector('.cc-price-range__input--min,[name="filter.v.price.gte"],[name="PriceFilterMin"]');
    let maxInput = root.querySelector('.cc-price-range__input--max,[name="filter.v.price.lte"],[name="PriceFilterMax"]');
    return { minInput: minInput, maxInput: maxInput };
  }

  function getSortValueFromHref(href) {
    if (!href) return '';
    try {
      let url = new URL(href, window.location.origin);
      return normalizeSortKey(url.searchParams.get('sort_by') || SORT_KEYS.RECOMMENDED);
    } catch (e) {
      return '';
    }
  }

  function getFallbackSortLabel(sortBy) {
    let key = normalizeSortKey(sortBy || SORT_KEYS.RECOMMENDED);
    return SORT_LABELS[key] || SORT_LABELS[SORT_KEYS.RECOMMENDED];
  }

  function syncSortDropdownUI() {
    let targetSort = normalizeSortKey(state.sortBy || SORT_KEYS.RECOMMENDED);
    let links = root.querySelectorAll('.CT_link-dropdown__options .CT_short_link, .link-dropdown__options .link-dropdown__link');
    let activeLink = null;

    links.forEach(function (link) {
      let linkSort = getSortValueFromHref(link.getAttribute('href')) || SORT_KEYS.RECOMMENDED;
      let isActive = linkSort === targetSort;
      link.classList.toggle('link-dropdown__link--active', isActive);
      if (isActive && !activeLink) activeLink = link;
    });

    let labelText = '';
    if (activeLink) {
      let labelNode = activeLink.querySelector('.ct_cl_sort') || activeLink;
      labelText = String(labelNode.textContent || '').trim();
    }
    if (!labelText) labelText = getFallbackSortLabel(targetSort);

    let buttonTexts = root.querySelectorAll('.CT_link-dropdown__button .link-dropdown__button-text, .link-dropdown__button .link-dropdown__button-text');
    buttonTexts.forEach(function (node) {
      node.textContent = labelText;
    });
  }

  function syncSortUiFromUrl() {
    let sortFromUrl = getSortByFromUrl();
    if (sortFromUrl) state.sortBy = normalizeSortKey(sortFromUrl);
    syncSortDropdownUI();
  }

  function queueSortUiSyncFromUrl() {
    if (state.sortUiSyncQueued) return;
    state.sortUiSyncQueued = true;
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        state.sortUiSyncQueued = false;
        syncSortUiFromUrl();
      });
      return;
    }
    setTimeout(function () {
      state.sortUiSyncQueued = false;
      syncSortUiFromUrl();
    }, 0);
  }

  function scheduleStartupSortUiSync() {
    if (Array.isArray(state.startupSortSyncTimers) && state.startupSortSyncTimers.length) {
      state.startupSortSyncTimers.forEach(function (timerId) {
        window.clearTimeout(timerId);
      });
    }
    state.startupSortSyncTimers = [];

    [0, 80, 220, 500, 1000, 2000, 4000].forEach(function (delay) {
      let timerId = window.setTimeout(function () {
        syncSortUiFromUrl();
      }, delay);
      state.startupSortSyncTimers.push(timerId);
    });
  }

  function observeSortUiMutations() {
    if (getMutationSyncMode() !== 'observerFallback') return;
    if (!window.MutationObserver || state.sortUiObserver) return;
    state.sortUiObserver = new MutationObserver(function (mutations) {
      for (let i = 0; i < mutations.length; i += 1) {
        let mutation = mutations[i];
        if (mutation.type !== 'childList') continue;
        if (mutation.addedNodes && mutation.addedNodes.length) {
          queueSortUiSyncFromUrl();
          return;
        }
      }
    });

    state.sortUiObserver.observe(root, {
      childList: true,
      subtree: true,
    });
  }

  function closeSortDropdownUI() {
    let buttons = root.querySelectorAll('.link-dropdown__button[aria-expanded="true"]');
    buttons.forEach(function (button) {
      button.setAttribute('aria-expanded', 'false');
      button.style.width = '';
    });

    let shades = root.querySelectorAll('.ct_fil_shade');
    shades.forEach(function (shade) {
      shade.classList.remove('ct_fill_active');
    });

    let header = document.querySelector('#shopify-section-header');
    if (header) header.classList.remove('ct_active_sort');
    document.querySelectorAll('.template-collection').forEach(function (node) {
      node.classList.remove('ct_active_sort_body');
    });

    window.themeScrollLock && window.themeScrollLock.unlock();

    if (typeof window.closeCollectionSortShade === 'function') {
      window.closeCollectionSortShade();
    }
  }

  function isElementVisible(node) {
    return !!(
      node &&
      (node.offsetWidth || node.offsetHeight || (node.getClientRects && node.getClientRects().length))
    );
  }

  function isSortDropdownActuallyOpenInRoot() {
    let buttons = root.querySelectorAll('.link-dropdown__button[aria-expanded="true"]');
    if (!buttons.length) return false;

    for (let i = 0; i < buttons.length; i += 1) {
      let button = buttons[i];
      if (!isElementVisible(button)) continue;
      let options = button.nextElementSibling;
      if (!options || !options.classList || !options.classList.contains('link-dropdown__options')) return true;
      let computed = window.getComputedStyle ? window.getComputedStyle(options) : null;
      if (!computed) return true;
      if (computed.display !== 'none' && computed.visibility !== 'hidden') return true;
    }

    return false;
  }

  function releaseStaleInteractionLocks(options) {
    let opts = options || {};
    let forceCloseSort = !!opts.forceCloseSort;

    let container = root.querySelector('.filter-container');
    if (container && container.classList.contains('ajax-loading')) {
      container.classList.remove('ajax-loading');
    }

    if (!isAnyFilterDrawerOpen()) {
      root.querySelectorAll('.filter-shade').forEach(function (shade) {
        shade.classList.remove('active', 'is-visible', 'show');
        shade.style.pointerEvents = '';
      });
    }

    let hasExpandedSortAttr = !!root.querySelector('.link-dropdown__button[aria-expanded="true"]');
    let hasOpenSort = isSortDropdownActuallyOpenInRoot();
    let shouldForceCloseStaleSort = hasExpandedSortAttr && !hasOpenSort;

    if (forceCloseSort || !hasOpenSort || shouldForceCloseStaleSort) {
      root.querySelectorAll('.ct_fil_shade').forEach(function (shade) {
        shade.classList.remove('ct_fill_active');
        shade.style.pointerEvents = 'none';
      });
      let header = document.querySelector('#shopify-section-header');
      if (header) header.classList.remove('ct_active_sort');
      document.querySelectorAll('.template-collection').forEach(function (node) {
        node.classList.remove('ct_active_sort_body');
      });
    }

    if ((forceCloseSort || shouldForceCloseStaleSort) && hasExpandedSortAttr) {
      closeSortDropdownUI();
    }

    if (!isMobileFilterDrawerOpen()) {
      setBodyScrollLocked(false);
    }
  }

  function getAppliedFilterCountFromState() {
    let total = 0;
    Object.keys(state.active || {}).forEach(function (key) {
      total += (state.active[key] || []).length;
    });
    if (state.priceRange && (state.priceRange.min != null || state.priceRange.max != null)) total += 1;
    return total;
  }

  function updateToggleAppliedCount(count) {
    let total = toNumber(count, 0);
    let targets = root.querySelectorAll('.ct_filter-toggle-btn .toggle-btn__count, .ct_filter-toggle-btn [data-filter-count]');
    targets.forEach(function (node) {
      node.textContent = total + ' Applied';
      node.classList.toggle('ct_toggle-btn__count_zero', total === 0);
      if (node.hasAttribute('data-filter-count')) {
        node.hidden = total === 0;
      }
    });
    updateBarActiveState(total);
  }

  // The red dot on FILTER in the bottom bar (assets/custom.css, section 13):
  // on while a facet, a price range or a non-default sort is narrowing the
  // grid, off otherwise. The section stamps the same class on first paint; this
  // keeps it honest through every filter, chip and sort change after that.
  function updateBarActiveState(count) {
    let total = count == null ? getAppliedFilterCountFromState() : toNumber(count, 0);
    let sortKey = normalizeSortKey(state.sortBy || getSortByFromUrl());
    let sortActive = !!sortKey && sortKey !== SORT_KEYS.RECOMMENDED;
    // One dot per control, and each answers only for itself. FILTER used to
    // light on a sort change as well, from before SORT BY had a dot of its own —
    // with both dots in place that read as two things applied when there was one.
    // sections/main-collection.liquid splits bar_has_active / the sort class the
    // same way for first paint.
    root.querySelectorAll('.ct_filter-toggle-btn').forEach(function (node) {
      node.classList.toggle('k-bar-has-active', total > 0);
    });
    root.querySelectorAll('.sort-by-icon').forEach(function (node) {
      node.classList.toggle('k-sort-has-active', sortActive);
    });
  }

  function getAllFilterInputs() {
    return root.querySelectorAll(
      '#CollectionFilterForm input.filter-group__checkbox, .collection-filter-form input.breaker_filter-group__checkbox, #CollectionFilterForm_custom_dd input.breaker_filter-group__checkbox'
    );
  }

  function collectNearStoreCodesFromProducts() {
    let unique = new Set();
    let products = Array.isArray(state.products) ? state.products : [];
    products.forEach(function (product) {
      let variants = Array.isArray(product && product.variants) ? product.variants : [];
      variants.forEach(function (variant) {
        let nearRaw = variant && (variant.near_stores != null ? variant.near_stores : variant.metafields && variant.metafields.near_stores);
        let values = parseList(nearRaw);
        values.forEach(function (value) {
          let raw = String(value || '').trim();
          if (!raw) return;
          unique.add(raw.toUpperCase());
        });
      });
    });
    return unique;
  }

  function collectAvailableCitiesFromProducts() {
    let unique = new Set();
    let products = Array.isArray(state.products) ? state.products : [];
    products.forEach(function (product) {
      let variants = Array.isArray(product && product.variants) ? product.variants : [];
      variants.forEach(function (variant) {
        let values = getVariantAvailableCityValues(variant);
        values.forEach(function (value) {
          let raw = String(value || '').trim();
          if (!raw) return;
          unique.add(raw);
        });
      });
    });
    return unique;
  }

  function getHeaderNearbyToggleInputs() {
    return root.querySelectorAll('input[data-nearby-products-toggle]');
  }

  function normalizeCityDisplayName(city) {
    let raw = String(city || '').trim();
    if (!raw) return '';
    return raw
      .toLowerCase()
      .replace(/\b([a-z])/g, function (_, ch) {
        return String(ch || '').toUpperCase();
      });
  }

  function getActiveAvailableCityDisplayName() {
    let checked = Array.prototype.slice.call(getAllFilterInputs() || []).find(function (input) {
      return mapNameToKey(input.name, input) === 'availablecities' && !!input.checked;
    });
    if (!checked) return '';

    let labelNode = checked.closest('.filter-group__item');
    let textNode = labelNode
      ? labelNode.querySelector('.default_filter-group__item__text, .filter-group__item__text')
      : null;
    let city = textNode ? String(textNode.textContent || '').trim() : String(checked.value || '').trim();
    return normalizeCityDisplayName(city);
  }

  function syncHeaderNearbyToggleLabel(hasAvailableCity) {
    let isActive = !!hasAvailableCity;
    let cityName = getActiveAvailableCityDisplayName() || normalizeCityDisplayName(getStoredCurrentLocationCity());
    if (!cityName) cityName = 'Your City';

    root.querySelectorAll('.ct_nearby-products-toggle-wrap').forEach(function (wrap) {
      if (!wrap || !wrap.classList) return;
      wrap.classList.toggle('is-active', isActive);
      let cityNode = wrap.querySelector('.ct_nearby-products-toggle__city');
      if (cityNode) cityNode.textContent = cityName;
    });
  }

  function syncHeaderNearbyToggleFromActiveState(activeStateOverride) {
    let activeState = activeStateOverride || state.active || {};
    let hasAvailableCity = !!(activeState.availablecities && activeState.availablecities.length);
    getHeaderNearbyToggleInputs().forEach(function (input) {
      input.checked = hasAvailableCity;
    });
    syncHeaderNearbyToggleLabel(hasAvailableCity);
  }

  function isMatchingAvailableCityToken(input, cityToken) {
    if (!input || !cityToken) return false;
    let token = deriveToken(input);
    if (!token) return false;
    return token === cityToken || token.indexOf(cityToken) > -1 || cityToken.indexOf(token) > -1;
  }

  function applyStoredLocationAvailableCitySelection() {
    let storedCity = getStoredCurrentLocationCity();
    if (!storedCity) {
      return false;
    }
    let canonical = resolveCityCanonical(storedCity);
    let storedToken = canonical ? canonical.token : handleize(storedCity);
    if (!storedToken) {
      return false;
    }

    let inputs = getAvailableCityFilterInputs();
    if (!inputs.length) {
      return false;
    }

    let matched = findAvailableCityInputForCity(storedCity);
    if (!matched) {
      return false;
    }

    inputs.forEach(function (input) {
      input.checked = false;
    });
    matched.checked = true;
    state.selectionSourceByKey.availablecities = 'filter';
    return true;
  }

  function clearAvailableCitiesSelection() {
    let clearedCount = 0;
    getAllFilterInputs().forEach(function (input) {
      if (mapNameToKey(input.name, input) !== 'availablecities') return;
      input.checked = false;
      input.disabled = false;
      clearedCount++;
    });
    if (state.selectionSourceByKey && state.selectionSourceByKey.availablecities) {
      delete state.selectionSourceByKey.availablecities;
    }
  }

  function getAvailableCityFilterInputs() {
    let allInputs = getAllFilterInputs() || [];
    let cityInputs = Array.prototype.slice.call(allInputs).filter(function (input) {
      return mapNameToKey(input.name, input) === 'availablecities';
    });
    return cityInputs;
  }

  function findAvailableCityInputForCity(city) {
    let canonical = resolveCityCanonical(city || '');
    let cityToken = canonical ? canonical.token : handleize(city || '');
    if (!cityToken) {
      return null;
    }
    let inputs = getAvailableCityFilterInputs();
    for (let i = 0; i < inputs.length; i += 1) {
      if (isMatchingAvailableCityToken(inputs[i], cityToken)) {
        return inputs[i];
      }
    }
    return null;
  }

  function syncAvailableCityFilterFromLocationChange() {
    let inputs = getAvailableCityFilterInputs();
    let hasNearbyStores = hasLocationStoreEntries();
    let storedCity = getStoredCurrentLocationCity();

    let matchedInput = findAvailableCityInputForCity(storedCity);
    let hasCityMatch = !!matchedInput;
    let hadActiveSelection = !!(state.active && state.active.availablecities && state.active.availablecities.length);
    refreshNearbyToggleVisibility();

    // Without rendered city options the match result is meaningless, so do not
    // clear or replace an existing selection off the back of it.
    if (!areAvailableCityOptionsReady()) {
      syncHeaderNearbyToggleFromActiveState(state.active || {});
      return false;
    }

    if (!hadActiveSelection) {
      syncHeaderNearbyToggleFromActiveState(state.active || {});
      return false;
    }

    if (matchedInput) {
      let requiresChange = inputs.some(function (input) {
        return input !== matchedInput && !!input.checked;
      }) || !matchedInput.checked;
      if (!requiresChange) {
        return false;
      }

      inputs.forEach(function (input) {
        input.checked = false;
      });
      matchedInput.checked = true;
      state.selectionSourceByKey.availablecities = 'filter';
      return true;
    }

    let hadChecked = inputs.some(function (input) {
      return !!input.checked;
    });
    clearAvailableCitiesSelection();
    return hadChecked;
  }

  function handleHeaderNearbyToggleChange(shouldEnable) {
    if (shouldEnable) {
      let collectionTitleNode = document.querySelector('.ct_header_title-main');
      let collectionTitle = collectionTitleNode ? collectionTitleNode.textContent : document.title;
      clevertap.event.push('storeInventoryToggleClick', {
        city: localStorage.getItem('current_location') || '',
        collectionURL: window.location.href,
        collectionTitle: collectionTitle,
        pin: localStorage.getItem('pin') || ''
      })
      let applied = applyStoredLocationAvailableCitySelection();
      if (!applied && !state.fullHydrated) {
        hydrateRemainingProductsOnDemand('nearby-toggle-city-resolve')
          .then(function () {
            ensureAvailableCitiesFilterPresent();
            runExplicitUiSync('nearby-city-upsert');
            let retried = applyStoredLocationAvailableCitySelection();
            if (!retried) {
              syncHeaderNearbyToggleFromActiveState();
              return;
            }
            return applyFilters();
          })
          .then(function () {
            setTimeout(function () {
            }, 1500);
          })
          .catch(function () {
          });
        return;
      }
      if (!applied) {
        syncHeaderNearbyToggleFromActiveState();
        return;
      }
    } else {
      clevertap.event.push('storeInventoryToggleClose');
      clearAvailableCitiesSelection();
    }

    applyFilters().then(function () {
      // Wait for DOM to render before closing loader
      setTimeout(function () {
      }, 1500);
      runExplicitUiSync('nearby-toggle-change');
    }).catch(function () {
    });
  }

  function isNearStoreInput(input) {
    if (!input) return false;
    return mapNameToKey(input.name, input) === 'nearstores';
  }

  function normalizeNearStoreLabelsInContainer(container) {
    if (!container || !container.querySelectorAll) return;
    let nearInputs = container.querySelectorAll('input.filter-group__checkbox[name*="near_stores"], input.breaker_filter-group__checkbox[name*="near_stores"]');

    let serialByCode = {};
    let serialCounter = 0;
    nearInputs.forEach(function (input) {
      let raw = String(input.value || '').trim();
      if (!raw) return;
      let code = raw.toUpperCase();
      if (!serialByCode[code]) {
        serialCounter += 1;
        serialByCode[code] = serialCounter;
      }
    });

    nearInputs.forEach(function (input) {
      let textNode = null;
      let item = input.closest('.filter-group__item');
      if (item) textNode = item.querySelector('.default_filter-group__item__text, .filter-group__item__text');
      if (!textNode && input.parentElement) textNode = input.parentElement.querySelector('.default_filter-group__item__text, .filter-group__item__text');
      if (!textNode) return;

      let currentText = String(textNode.textContent || '').trim();
      let baseRaw = currentText.replace(/\(.*?\)/g, '').trim();
      let rawValue = String(input.value || '').trim();
      let code = rawValue.toUpperCase();
      let mapped = mapNearStoreLabel(baseRaw || rawValue || '');
      if (!mapped) return;

      if (item) item.setAttribute('data-near-store-code', code);
      textNode.setAttribute('data-near-store-code', code);
      textNode.dataset.baseLabel = mapped;
      textNode.textContent = mapped;
    });
  }

  function getNearStoreCountsFromProducts() {
    let counts = {};
    // Use state.filtered (filtered products) if available, otherwise fall back to state.products
    let products = Array.isArray(state.filtered) && state.filtered.length ? state.filtered : (Array.isArray(state.products) ? state.products : []);
    products.forEach(function (product) {
      let variants = Array.isArray(product && product.variants) ? product.variants : [];
      let productCodes = {};

      variants.forEach(function (variant) {
        let nearRaw = variant && (variant.near_stores != null ? variant.near_stores : variant.metafields && variant.metafields.near_stores);
        let values = parseList(nearRaw);
        values.forEach(function (value) {
          let raw = String(value || '').trim();
          if (!raw) return;
          productCodes[raw.toUpperCase()] = true;
        });
      });

      Object.keys(productCodes).forEach(function (code) {
        counts[code] = (counts[code] || 0) + 1;
      });
    });

    return counts;
  }

  function getAllKnownNearStoreCodes() {
    let seen = {};
    let ordered = [];

    Object.keys(NEAR_STORE_LABEL_MAP).forEach(function (code) {
      let key = String(code || '').trim().toUpperCase();
      if (!key || seen[key]) return;
      seen[key] = true;
      ordered.push(key);
    });

    let nearInputs = root.querySelectorAll('input[name*="near_stores"]');
    nearInputs.forEach(function (input) {
      let raw = String(input.value || '').trim().toUpperCase();
      if (!raw || seen[raw]) return;
      seen[raw] = true;
      ordered.push(raw);
    });

    collectNearStoreCodesFromProducts().forEach(function (code) {
      let key = String(code || '').trim().toUpperCase();
      if (!key || seen[key]) return;
      seen[key] = true;
      ordered.push(key);
    });

    // Include allowed codes from location_store even if they have 0 products
    let allowedCodes = getLocationStoreShortCodeSet();
    allowedCodes.forEach(function (code) {
      let key = String(code || '').trim().toUpperCase();
      if (!key || seen[key]) return;
      seen[key] = true;
      ordered.push(key);
    });

    if (!allowedCodes.size) return ordered;
    return ordered.filter(function (code) {
      return allowedCodes.has(normalizeNearStoreCode(code));
    });
  }

  function buildNearStoreOptionFromTemplate(templateLabel, inputName, inputClassName, code, count) {
    if (!templateLabel) return null;
    let mapped = mapNearStoreLabel(code);
    if (!mapped) return null;

    let label = templateLabel.cloneNode(true);
    label.classList.remove('filter-group__item--active');
    label.classList.remove('filter-group__item--disabled');
    label.setAttribute('data-tag', handleize(code));
    label.setAttribute('data-near-store-code', String(code || '').trim().toUpperCase());

    let input = label.querySelector('input[type="checkbox"], input[type="radio"]');
    if (!input) {
      input = document.createElement('input');
      label.insertBefore(input, label.firstChild);
    }
    input.className = inputClassName;
    input.type = 'checkbox';
    input.name = inputName;
    input.value = code;
    input.checked = false;
    input.disabled = false;
    input.removeAttribute('checked');
    input.removeAttribute('disabled');

    let textNode = label.querySelector('.default_filter-group__item__text, .filter-group__item__text');
    if (!textNode) {
      textNode = document.createElement('span');
      textNode.className = 'filter-group__item__text default_filter-group__item__text';
      label.appendChild(textNode);
    }
    textNode.setAttribute('data-near-store-code', String(code || '').trim().toUpperCase());
    textNode.dataset.baseLabel = mapped;
    textNode.textContent = mapped;

    let countNode = label.querySelector('.filter-group__item__count');
    if (countNode) countNode.textContent = '(' + toNumber(count, 0) + ')';

    return label;
  }

  function ensureAllNearStoreOptionsPresent() {
    if (!state.loaded) return;

    let nearInputs = root.querySelectorAll('input[name*="near_stores"]');
    if (!nearInputs.length) return;

    let counts = getNearStoreCountsFromProducts();
    let allowedCodes = getLocationStoreShortCodeSet();
    let hasRestriction = allowedCodes.size > 0;
    let allCodes = getAllKnownNearStoreCodes();
    if (!allCodes.length) return;

    let containerSet = new Set();
    nearInputs.forEach(function (input) {
      let label = input.closest('.filter-group__item');
      if (!label) return;
      let container =
        label.parentElement ||
        input.closest('.toggle-target-container, .breaker-container, .filter-group__items, .ct_filter-group__items');
      if (container) containerSet.add(container);
    });

    containerSet.forEach(function (container) {
      let templateInput = container.querySelector('input[name*="near_stores"]');
      if (!templateInput) return;
      let templateLabel = templateInput.closest('.filter-group__item');
      if (!templateLabel) return;

      let inputName = String(templateInput.name || '');
      let inputClassName = String(templateInput.className || 'filter-group__checkbox');

      let existing = {};
      container.querySelectorAll('input[name*="near_stores"]').forEach(function (existingInput) {
        let code = String(existingInput.value || '').trim().toUpperCase();
        if (!code) return;
        existing[code] = true;
      });

      allCodes.forEach(function (code) {
        if (existing[code]) return;
        let labelNode = buildNearStoreOptionFromTemplate(templateLabel, inputName, inputClassName, code, counts[code] || 0);
        if (!labelNode) return;
        container.appendChild(labelNode);
        existing[code] = true;
      });

      container.querySelectorAll('input[name*="near_stores"]').forEach(function (existingInput) {
        let code = String(existingInput.value || '').trim().toUpperCase();
        if (!code) return;
        let labelNode = existingInput.closest('.filter-group__item');
        if (!labelNode) return;
        labelNode.setAttribute('data-tag', handleize(code));
        labelNode.setAttribute('data-near-store-code', code);

        let textNode = labelNode.querySelector('.default_filter-group__item__text, .filter-group__item__text');
        if (textNode) textNode.setAttribute('data-near-store-code', code);

        let isAllowed = !hasRestriction || isNearStoreAllowedByLocationStore(existingInput, allowedCodes);
        if (!isAllowed) {
          existingInput.checked = false;
          existingInput.disabled = true;
          labelNode.style.display = 'none';
          return;
        }

        if (labelNode.style && labelNode.style.display === 'none') labelNode.style.display = '';
        if (!existingInput.checked) existingInput.disabled = false;

        let countNode = labelNode.querySelector('.filter-group__item__count');
        if (countNode) countNode.textContent = '(' + toNumber(counts[code], 0) + ')';

        // Hide near-stores options with 0 count (unless checked)
        let count = toNumber(counts[code], 0);
        let show = existingInput.checked || count > 0;
        labelNode.style.display = show ? '' : 'none';
      });
    });

    normalizeNearStoreLabelsInContainer(root);
  }

  function getAvailableCityCountsFromProducts() {
    let countsByToken = {};
    let displayByToken = {};
    let products = Array.isArray(state.products) ? state.products : [];
    products.forEach(function (product) {
      let variants = Array.isArray(product && product.variants) ? product.variants : [];
      let productTokens = {};

      variants.forEach(function (variant) {
        let values = getVariantAvailableCityValues(variant);
        values.forEach(function (value) {
          let city = String(value || '').trim();
          if (!city) return;
          let token = getAvailableCityCanonicalToken(city);
          if (!token) return;
          productTokens[token] = true;
          if (!displayByToken[token]) displayByToken[token] = getAvailableCityDisplayValue(city);
        });
      });

      Object.keys(productTokens).forEach(function (token) {
        countsByToken[token] = (countsByToken[token] || 0) + 1;
      });
    });
    return {
      byToken: countsByToken,
      displayByToken: displayByToken,
    };
  }

  function getAllKnownAvailableCities() {
    let seen = {};
    let ordered = [];

    let availableFromProducts = collectAvailableCitiesFromProducts();
    Array.from(availableFromProducts).forEach(function (city) {
      let key = String(city || '').trim();
      if (!key || seen[key]) return;
      seen[key] = true;
      ordered.push(key);
    });

    root.querySelectorAll('input[name*="available_cities"]').forEach(function (input) {
      let key = String(input.value || '').trim();
      if (!key || seen[key]) return;
      seen[key] = true;
      ordered.push(key);
    });

    ordered.sort(function (a, b) {
      return String(a).localeCompare(String(b), undefined, { sensitivity: 'base' });
    });
    return ordered;
  }

  function getAvailableCityCanonicalToken(city) {
    let raw = String(city || '').trim();
    if (!raw) return '';
    let canonical = resolveCityCanonical(raw);
    if (canonical && canonical.token) return canonical.token;
    return handleize(raw);
  }

  function getAvailableCityDisplayValue(city) {
    let raw = String(city || '').trim();
    if (!raw) return '';
    let canonical = resolveCityCanonical(raw);
    return canonical && canonical.display ? canonical.display : raw;
  }

  function upsertAvailableCitiesIntoContainer(container, allCities, counts) {
    if (!container) return;
    let templateInput = container.querySelector('input[name*="available_cities"]');
    if (!templateInput) return;
    let templateLabel = templateInput.closest('.filter-group__item');
    if (!templateLabel) return;

    let inputName = String(templateInput.name || '');
    if (!inputName) return;
    let inputClassName = String(templateInput.className || 'filter-group__checkbox filter-group__checkbox_list');

    let byToken = {};
    container.querySelectorAll('input[name*="available_cities"]').forEach(function (input) {
      let token = getAvailableCityCanonicalToken(input.value || deriveOptionLabel(input));
      if (!token) return;
      if (!byToken[token]) byToken[token] = [];
      byToken[token].push(input);
    });

    allCities.forEach(function (city) {
      let token = getAvailableCityCanonicalToken(city);
      if (!token) return;
      let displayCity = getAvailableCityDisplayValue(city);

      let existing = byToken[token] || [];
      if (!existing.length) {
        let option = buildAvailableCityOptionFromTemplate(templateLabel, inputName, inputClassName, displayCity, 0);
        if (!option) return;
        container.appendChild(option);
        return;
      }

      let primary = existing[0];
      let item = primary.closest('.filter-group__item');
      let labelNode = item ? item.querySelector('.default_filter-group__item__text, .filter-group__item__text') : null;
      primary.value = displayCity;
      if (labelNode) {
        labelNode.dataset.baseLabel = displayCity;
        labelNode.textContent = displayCity;
      }

      for (let i = 1; i < existing.length; i += 1) {
        let dupItem = existing[i].closest('.filter-group__item');
        if (dupItem && dupItem.parentNode) dupItem.parentNode.removeChild(dupItem);
      }
    });
  }

  function buildAvailableCityOptionFromTemplate(templateLabel, inputName, inputClassName, city, count) {
    if (!templateLabel) return null;
    let cityText = String(city || '').trim();
    if (!cityText) return null;

    let label = templateLabel.cloneNode(true);
    label.classList.remove('filter-group__item--active');
    label.classList.remove('filter-group__item--disabled');
    label.setAttribute('data-tag', handleize(cityText));

    let input = label.querySelector('input[type="checkbox"], input[type="radio"]');
    if (!input) {
      input = document.createElement('input');
      label.insertBefore(input, label.firstChild);
    }
    input.className = inputClassName;
    input.type = 'checkbox';
    input.name = inputName;
    input.value = cityText;
    input.checked = false;
    input.disabled = false;
    input.removeAttribute('checked');
    input.removeAttribute('disabled');

    let textNode = label.querySelector('.default_filter-group__item__text, .filter-group__item__text');
    if (!textNode) {
      textNode = document.createElement('span');
      textNode.className = 'filter-group__item__text default_filter-group__item__text';
      label.appendChild(textNode);
    }
    textNode.dataset.baseLabel = cityText;
    textNode.textContent = cityText;

    let countNode = label.querySelector('.filter-group__item__count');
    if (countNode) countNode.textContent = '(' + toNumber(count, 0) + ')';

    return label;
  }

  function ensureAvailableCitiesFilterPresent() {
    if (!state.loaded) return;

    let allCities = getAllKnownAvailableCities();
    if (!allCities.length) return;

    let counts = getAvailableCityCountsFromProducts();
    let existingInputs = root.querySelectorAll('input[name*="available_cities"]');
    if (existingInputs.length) {
      let containerSet = new Set();
      existingInputs.forEach(function (input) {
        let label = input.closest('.filter-group__item');
        let container = label
          ? (label.parentElement || input.closest('.toggle-target-container, .breaker-container, .filter-group__items, .ct_filter-group__items'))
          : null;
        if (container) containerSet.add(container);
      });
      containerSet.forEach(function (container) {
        upsertAvailableCitiesIntoContainer(container, allCities, counts);
      });
      updateOptionVisibilityDebounced(state.active, state.priceRange);
      return;
    }

    let nearInput = root.querySelector('#CollectionFilterForm input[name*="near_stores"]');
    if (!nearInput) return;
    let nearLabel = nearInput.closest('.filter-group__item');
    let nearGroup = nearInput.closest('.ct_filter-group.filter-group');
    if (!nearLabel || !nearGroup) return;

    let clonedGroup = nearGroup.cloneNode(true);
    clonedGroup.classList.remove('ct_Near_Store', 'ct_Near_Stores');
    clonedGroup.classList.add('ct_Available_Cities');

    let heading = clonedGroup.querySelector('.filter-group__heading__text');
    if (heading) heading.textContent = 'Available Cities';

    let headingToggle = clonedGroup.querySelector('.ct_filter-group__heading.filter-group__heading');
    let itemsWrap = clonedGroup.querySelector('.ct_filter-group__items.filter-group__items');
    if (headingToggle && itemsWrap) {
      headingToggle.setAttribute('data-toggle-target', '.filter-group--available-cities');
      itemsWrap.className = itemsWrap.className
        .replace(/filter-group--\d+/g, '')
        .trim();
      itemsWrap.classList.add('filter-group--available-cities');
    }

    let container = clonedGroup.querySelector('.toggle-target-container');
    if (!container) return;
    container.innerHTML = '';

    let sourceName = String(nearInput.name || '');
    let inputName = sourceName.replace(/near_stores/gi, 'available_cities');
    if (!inputName || inputName === sourceName) inputName = 'filter.v.option.available_cities';
    let inputClassName = String(nearInput.className || 'filter-group__checkbox filter-group__checkbox_list');

    allCities.forEach(function (city) {
      let option = buildAvailableCityOptionFromTemplate(nearLabel, inputName, inputClassName, city, counts[city] || 0);
      if (!option) return;
      container.appendChild(option);
    });

    nearGroup.insertAdjacentElement('afterend', clonedGroup);
    upsertAvailableCitiesIntoContainer(container, allCities, counts);
    updateOptionVisibilityDebounced(state.active, state.priceRange);
  }

  // Currently unused: selecting a tab no longer scrolls the rail home, and the
  // "All" reset path scrolls itself inside activateAllPlpTabs(). Kept because it
  // is the one place that handles the scrollTo/scrollLeft fallback.
  function scrollListToStart(list) {
    if (!list) return;
    if (typeof list.scrollTo === 'function') {
      try {
        list.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      } catch (e) {}
    }
    list.scrollLeft = 0;
  }

  function syncPlpFocusStates() {
    let lists = root.querySelectorAll('.plp_filter_main');
    lists.forEach(function (list) {
      let selectedLi = null;
      // Multi-select: every checked chip stays lit and sorts to the front. The
      // scroll token is the whole selection, so the strip only jumps back to
      // the start when the set actually changes.
      let selectedInputs = Array.from(list.querySelectorAll('li ' + PLP_INPUT_SELECTOR + ':checked'));
      let selectedTokens = selectedInputs.map(function (input) {
        return String(deriveToken(input) || '');
      });
      let selectedToken = selectedTokens.length ? selectedTokens.join('|') : '__all__';
      let items = list.querySelectorAll('li');
      let allItem = null;

      items.forEach(function (li, index) {
        let radio = li.querySelector(PLP_INPUT_SELECTOR);
        if (!radio) {
          li.classList.remove('has-focus');
          if (li.querySelector('a.filter-group__clear-link')) allItem = li;
          return;
        }

        let isChecked = !!radio.checked;
        li.classList.remove('has-focus');
        li.classList.toggle('active', isChecked);

        let text = li.querySelector('.default_filter-group__item__text, .filter-group__item__text');
        if (text) {
          text.style.color = isChecked ? '#454545' : '';
          text.style.opacity = isChecked ? '1' : '';
        }

        if (isChecked) selectedLi = li;

        let originalOrder = toNumber(li.dataset.plpOriginalOrder, index);
        if (!li.dataset.plpOriginalOrder) {
          li.dataset.plpOriginalOrder = String(index);
          originalOrder = index;
        }
        // Selection does NOT reorder the rail. Pulling the checked pill to
        // order 1 moved it out from under the customer's finger mid-tap, and
        // with multi-select it shuffled every chosen category to the front, so
        // the rail stopped matching the order it was authored in. Order now
        // comes from the pinned-category rank when the pill is one of the five
        // the rail must lead with, and from its original index otherwise —
        // never from whether it is selected.
        // "All" still sits last via PLP_ALL_ORDER below, and is hidden by CSS.
        li.style.order = plpPillOrder(li, originalOrder);
      });

      let allLink = list.querySelector('a.filter-group__clear-link');
      if (allLink) {
        // A combined selection made in the main filter is represented by All
        // on the PLP Plus rail. Direct rail taps remain single-select.
        let allShouldBeActive = list.classList.contains('has-main-multiple-selection');
        allLink.classList.toggle('active', allShouldBeActive);
        if (!allShouldBeActive) allLink.classList.remove('active');
        let allItem = allLink.closest('li');
        if (allItem) allItem.classList.toggle('active', allShouldBeActive);
        let allText = allLink.querySelector('span');
        if (allText) {
          allText.style.color = '#454545';
          allText.style.opacity = '1';
        }
      }
      if (!allItem && allLink) allItem = allLink.closest('li');
      // "All" sits at the END of the rail, past every category pill. The order
      // has to beat the largest chip order this function hands out (index + 2),
      // and PLP_ALL_ORDER is far above any rail's value count. The matching
      // CSS rule in plp_plus_filter.liquid puts it there before this JS runs.
      if (allItem) allItem.style.order = PLP_ALL_ORDER;

      let prevScrollToken = String(list.dataset.plpScrollToken || '');
      // Token still tracked so a caller can tell the selection changed, but the
      // rail is NOT scrolled home any more. Now that a checked pill keeps its
      // place, scrolling to x=0 pushed the tab the customer had just tapped off
      // the left of the viewport - the rail jumped even though nothing had
      // reordered. The "All" reset path scrolls itself in activateAllPlpTabs().
      if (prevScrollToken !== String(selectedToken || '')) {
        list.dataset.plpScrollToken = String(selectedToken || '');
      }
      if (allItem && allLink && allLink.classList.contains('active')) {
        revealPlpSelection(list, allItem);
      } else if (selectedLi) {
        // Keep the active PLP Plus pill in view on reload, URL restore, and
        // after filter state is synchronised. revealPlpSelection() is a no-op
        // when the pill is already inside the visible viewport.
        revealPlpSelection(list, selectedLi);
      }

      let optionItems = [];
      Array.prototype.forEach.call(list.children, function (child, index) {
        if (!(child instanceof HTMLElement)) return;
        let hasRadio = !!child.querySelector(PLP_INPUT_SELECTOR);
        if (!hasRadio) return;
        if (!child.dataset.plpOriginalOrder) child.dataset.plpOriginalOrder = String(index);
        optionItems.push(child);
      });

      if (!optionItems.length) return;
    });
  }

  function schedulePlpSelectionSync() {
    if (state.plpSyncScheduled) return;
    state.plpSyncScheduled = true;

    let runSync = function () {
      state.plpSyncScheduled = false;
      ensureAllNearStoreOptionsPresent();
      ensureAvailableCitiesFilterPresent();
      normalizeNearStoreLabelsInContainer(root);
      syncPlpSelectionFromCheckedInputs();
    };

    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(runSync);
      return;
    }
    setTimeout(runSync, 0);
  }

  function runExplicitUiSync(source) {
    if (getMutationSyncMode() !== 'explicit') return;
    ensureAllNearStoreOptionsPresent();
    ensureAvailableCitiesFilterPresent();
    normalizeNearStoreLabelsInContainer(root);
    syncPlpSelectionFromCheckedInputs();
    syncSortUiFromUrl();
    // A sort change moves no filter count, so SORT BY's own dot needs this nudge
    updateBarActiveState();
    syncBodyScrollLock();
    scheduleMainFilterPanelCompensation();
  }

  function activateAllPlpTabs() {
    let lists = root.querySelectorAll('.plp_filter_main');
    lists.forEach(function (list) {
      let items = list.querySelectorAll('li');
      items.forEach(function (li, index) {
        let radio = li.querySelector(PLP_INPUT_SELECTOR);
        if (!radio) return;
        radio.checked = false;
        li.classList.remove('active');
        let originalOrder = toNumber(li.dataset.plpOriginalOrder, index);
        if (!li.dataset.plpOriginalOrder) li.dataset.plpOriginalOrder = String(index);
        li.style.order = plpPillOrder(li, originalOrder);
      });

      let allLink = list.querySelector('a.filter-group__clear-link');
      if (allLink) {
        allLink.classList.add('active');
        let allItem = allLink.closest('li');
        if (allItem) {
          allItem.classList.add('active');
          allItem.style.order = PLP_ALL_ORDER;
        }
      }

      if (typeof list.scrollTo === 'function') {
        try {
          list.scrollTo({ left: 0, behavior: 'smooth' });
        } catch (e) {
          list.scrollLeft = 0;
        }
      } else {
        list.scrollLeft = 0;
      }
    });
  }

  function observePlpListMutations() {
    if (getMutationSyncMode() !== 'observerFallback') return;
    if (!window.MutationObserver || state.plpObserver) return;
    let target = root.querySelector('#CollectionFilterForm_custom_dd') || root;
    if (!target) return;

    state.plpObserver = new MutationObserver(function (mutations) {
      for (let i = 0; i < mutations.length; i += 1) {
        let mutation = mutations[i];
        if (mutation.type !== 'childList') continue;

        let changed = false;
        if (mutation.target && mutation.target.nodeType === 1) {
          let targetEl = mutation.target;
          if (targetEl.classList && targetEl.classList.contains('plp_filter_main')) changed = true;
          if (!changed && targetEl.closest && targetEl.closest('.plp_filter_main')) changed = true;
        }

        if (!changed && mutation.addedNodes && mutation.addedNodes.length) {
          for (let n = 0; n < mutation.addedNodes.length; n += 1) {
            let node = mutation.addedNodes[n];
            if (!node || node.nodeType !== 1) continue;
            if (node.classList && node.classList.contains('plp_filter_main')) {
              changed = true;
              break;
            }
            if (node.querySelector && node.querySelector('.plp_filter_main')) {
              changed = true;
              break;
            }
          }
        }

        if (changed) {
          schedulePlpSelectionSync();
          return;
        }
      }
    });

    state.plpObserver.observe(target, { childList: true, subtree: true });
  }

  function getCheckedTokensForName(filterName) {
    let tokenSet = new Set();
    if (!filterName) return tokenSet;

    getAllFilterInputs().forEach(function (input) {
      if (!input || !input.checked) return;
      if (String(input.name || '') !== String(filterName)) return;

      let token = deriveToken(input);
      if (token) tokenSet.add(token);
    });

    return tokenSet;
  }

  function hasExplicitFiltersInUrl() {
    let params = new URLSearchParams(window.location.search);
    let has = false;
    params.forEach(function (_value, key) {
      if (has) return;
      if (key === 'q' || String(key).indexOf('filter.') === 0) has = true;
    });
    return has;
  }

  function clearCheckedFilterInputs() {
    getAllFilterInputs().forEach(function (input) {
      if (!input || input.name === 'sort_by') return;
      input.checked = false;
    });
  }

  // Set ONE token on or off everywhere it appears — the PLP+ chip and the same
  // value in the sidebar drawer — leaving every other token in that group
  // alone. Replaces forceSingleSelectionAcrossKey(), which unchecked the rest
  // of the group and so made the chip strip single-select.
  function syncTokenAcrossInputs(filterKey, token, shouldCheck, preferredName) {
    if (!token) return;
    let targetToken = String(token);
    let targetKey = String(filterKey || '');
    let targetName = String(preferredName || '');

    getAllFilterInputs().forEach(function (input) {
      if (!input || !input.name || input.name === 'sort_by') return;
      if (input.disabled) return;
      if (String(deriveToken(input) || '') !== targetToken) return;

      let matchesKey = targetKey && mapNameToKey(input.name, input) === targetKey;
      let matchesName = targetName && String(input.name || '') === targetName;
      if (!matchesKey && !matchesName) return;

      input.checked = !!shouldCheck;
      if (shouldCheck) input.setAttribute('checked', 'checked');
      else input.removeAttribute('checked');
    });
  }

  function isPriceMinInput(input) {
    return !!(
      input &&
      input.matches &&
      input.matches('input.cc-price-range__input--min, input[name="filter.v.price.gte"], input[name="PriceFilterMin"]')
    );
  }

  function isPriceMaxInput(input) {
    return !!(
      input &&
      input.matches &&
      input.matches('input.cc-price-range__input--max, input[name="filter.v.price.lte"], input[name="PriceFilterMax"]')
    );
  }

  function syncPriceInputsFromRange(priceRange) {
    let minValue =
      priceRange && priceRange.min != null && Number.isFinite(Number(priceRange.min))
        ? String(priceRange.min)
        : '';
    let maxValue =
      priceRange && priceRange.max != null && Number.isFinite(Number(priceRange.max))
        ? String(priceRange.max)
        : '';

    root
      .querySelectorAll('input.cc-price-range__input--min, input[name="filter.v.price.gte"], input[name="PriceFilterMin"]')
      .forEach(function (input) {
        if (!input) return;
        input.value = minValue;
      });
    root
      .querySelectorAll('input.cc-price-range__input--max, input[name="filter.v.price.lte"], input[name="PriceFilterMax"]')
      .forEach(function (input) {
        if (!input) return;
        input.value = maxValue;
      });

    syncAllPriceRangeVisuals();
  }

  function syncPriceRangeVisuals(rangeEl) {
    if (!rangeEl) return;

    let minInput = rangeEl.querySelector('input.cc-price-range__input--min, input[name="filter.v.price.gte"], input[name="PriceFilterMin"]');
    let maxInput = rangeEl.querySelector('input.cc-price-range__input--max, input[name="filter.v.price.lte"], input[name="PriceFilterMax"]');
    if (!minInput || !maxInput) return;

    let sliderMin = toNumber(minInput.min, 0);
    let sliderMax = toNumber(minInput.max, toNumber(maxInput.max, sliderMin));
    if (sliderMax < sliderMin) sliderMax = sliderMin;

    let minRaw = String(minInput.value || '').trim();
    let maxRaw = String(maxInput.value || '').trim();
    let minValue = minRaw === '' ? toNumber(minInput.placeholder, sliderMin) : toNumber(minRaw, sliderMin);
    let maxValue = maxRaw === '' ? toNumber(maxInput.placeholder, sliderMax) : toNumber(maxRaw, sliderMax);

    minValue = Math.max(sliderMin, Math.min(minValue, sliderMax));
    maxValue = Math.max(minValue, Math.min(maxValue, sliderMax));

    let denom = sliderMax - sliderMin;
    let ratio = denom > 0 ? 100 / denom : 0;
    let minLeft = (minValue - sliderMin) * ratio;
    let maxLeft = (maxValue - sliderMin) * ratio;
    let activeLeft = minLeft;
    let activeRight = (sliderMax - maxValue) * ratio;

    let controlMin = rangeEl.querySelector('.cc-price-range__control--min');
    let controlMax = rangeEl.querySelector('.cc-price-range__control--max');
    let activeBar = rangeEl.querySelector('.cc-price-range__bar-active');

    if (controlMin) {
      controlMin.style.left = minLeft + '%';
      controlMin.setAttribute('aria-valuenow', String(minValue));
    }
    if (controlMax) {
      controlMax.style.left = maxLeft + '%';
      controlMax.setAttribute('aria-valuenow', String(maxValue));
    }
    if (activeBar) {
      activeBar.style.left = activeLeft + '%';
      activeBar.style.right = activeRight + '%';
    }
  }

  function syncAllPriceRangeVisuals() {
    root.querySelectorAll('.cc-price-range').forEach(function (rangeEl) {
      syncPriceRangeVisuals(rangeEl);
    });
  }

  function syncAllFilterInputsFromState(activeState, priceRange) {
    let normalizedActive = activeState || {};

    getAllFilterInputs().forEach(function (input) {
      if (!input || !input.name || input.name === 'sort_by') return;
      let key = mapNameToKey(input.name, input);
      if (!key || key.indexOf('__') === 0) return;

      let token = deriveToken(input);
      if (!token) return;

      let selectedTokens = normalizedActive[key] || [];
      let isRadio = String(input.type || '').toLowerCase() === 'radio';
      let shouldCheck = isRadio
        ? selectedTokens.length === 1 && selectedTokens.indexOf(token) > -1
        : selectedTokens.indexOf(token) > -1;

      input.checked = shouldCheck;
      if (shouldCheck) input.setAttribute('checked', 'checked');
      else input.removeAttribute('checked');
    });

    syncPriceInputsFromRange(priceRange);
  }

  function syncPlpSelectionFromCheckedInputs() {    let lists = root.querySelectorAll('.plp_filter_main');
    lists.forEach(function (list) {
      let radios = list.querySelectorAll('li ' + PLP_INPUT_SELECTOR);
      if (!radios.length) return;

      let listFilterName = String(radios[0].name || '');
      let sameNameTokens = Array.from(getCheckedTokensForName(listFilterName));
      // The main filter drawer can select multiple values, but the PLP Plus
      // rail is single-select. Only mirror a single active value; when the
      // drawer has multiple values active, keep all category pills off and
      // let the rail's trailing All item represent that combined state.
      let lastMatchedToken = '';
      let hasSingleSelection = sameNameTokens.length === 1;
      let autoOpenInput = list.querySelector('li.plp-auto-open ' + PLP_INPUT_SELECTOR);
      list.classList.toggle('has-main-multiple-selection', sameNameTokens.length > 1);

      radios.forEach(function (radio) {
        let token = String(deriveToken(radio) || '');
        let isAutoOpenDefault = sameNameTokens.length === 0 && radio === autoOpenInput;
        let shouldCheck = (hasSingleSelection && !!token && sameNameTokens.indexOf(token) > -1) || isAutoOpenDefault;
        if (shouldCheck && radio.disabled) shouldCheck = false;
        radio.checked = shouldCheck;
        if (shouldCheck) lastMatchedToken = token;
      });

      if (lastMatchedToken) {
        state.lastSelectedTokenByName[listFilterName] = lastMatchedToken;
      } else if (listFilterName && sameNameTokens.length !== 1) {
        delete state.lastSelectedTokenByName[listFilterName];
      }
    });

    syncPlpFocusStates();  }

  function deriveOptionLabel(input) {
    let item = input.closest('.filter-group__item');
    let textEl = getFilterItemLabelNode(item);
    if (!textEl && input.parentElement) {
      textEl =
        input.parentElement.querySelector('.default_filter-group__item__text') ||
        input.parentElement.querySelector('.ct-filter-name') ||
        input.parentElement.querySelector('.filter-group__item__text:not(.ct-filter-count)') ||
        input.parentElement.querySelector('.filter-group__item__text');
    }
    let text = textEl ? String(textEl.textContent || '') : String(input.value || '');
    let label = text
      .replace(/\(\s*Products?\s+Available\s*\d+\s*\)/gi, '')
      .replace(/\(\s*\d+\s*\)/g, '')
      .trim();
    if (isNearStoreInput(input)) {
      return mapNearStoreLabel(label || input.value || '');
    }
    return label;
  }

  function deriveToken(input) {
    if (isNearStoreInput(input)) {
      let nearToken = handleize(input.value || '');
      if (nearToken) return nearToken;
    }

    let dataToken = handleize(input.getAttribute('data-q-token') || '');
    if (dataToken) return dataToken;

    let item = input.closest('.filter-group__item');
    if (item && item.dataset && item.dataset.tag) {
      let tagToken = handleize(item.dataset.tag);
      if (tagToken) return tagToken;
    }
    return handleize(deriveOptionLabel(input) || input.value);
  }

  function mapNameToKey(name, input) {
    let n = String(name || '').toLowerCase();

    if (n === 'q') return 'category';
    if (n === 'sort_by') return '__sort';
    if (n.indexOf('price') > -1) return '__price';
    if (n.indexOf('custom.product') > -1) return 'category';
    if (n.indexOf('custom.style_sub_product') > -1 || n.indexOf('custom.style/subcategory') > -1) return 'stylesubcategory';
    if (n.indexOf('custom.specialised') > -1) return 'craftmanship';
    if (n.indexOf('custom.occasion') > -1) return 'occasion';
    if (n.indexOf('custom.metal') > -1) return 'metaltype';
    if (n.indexOf('custom.stone_type') > -1) return 'stonetype';
    if (n.indexOf('custom.closure') > -1) return 'closuretype';
    if (n.indexOf('custom.shape') > -1) return 'designshape';
    if (n.indexOf('custom.motif') > -1) return 'motif';
    if (n.indexOf('custom.return_condition') > -1) return 'returnable';
    if (n.indexOf('near_stores') > -1) return 'nearstores';
    if (n.indexOf('custom.available_cities') > -1 || n.indexOf('custom.available-city') > -1 || n.indexOf('available_cities') > -1) return 'availablecities';
    if (n.indexOf('color') > -1) return 'color';
    if (n.indexOf('size') > -1) return 'size';
    if (n.indexOf('polish') > -1) return 'polish';

    let item = input ? input.closest('.filter-group__item') : null;
    if (item && item.dataset && item.dataset.tag) return handleize(item.dataset.tag);
    return n || '__unknown';
  }

  function normalizeProduct(product, index) {
    let out = Object.assign({}, product);
    out._yIndex = index;
    out.price = toNumber(product.price, 0);
    out.compare_at_price = toNumber(product.compare_at_price, 0);
    out.tags = Array.isArray(product.tags) ? product.tags : parseList(product.tags);
    out.variants = Array.isArray(product.variants) ? product.variants : [];
    return out;
  }

  function getSortIdentity(product) {
    if (!product || typeof product !== 'object') return '';
    if (product.id != null && product.id !== '') return 'id:' + String(product.id);
    if (product.handle) return 'h:' + String(product.handle);
    return '';
  }

  async function fetchPage(page, sortBy, options) {
    let result = await fetchPageDetailed(page, sortBy, options);
    return result.items;
  }

  async function fetchPageDetailed(page, sortBy, options) {
    let endpoint = buildJsonEndpoint(page, sortBy, options);
    let bootstrap = window.__K_PLP_BOOTSTRAP__;
    let payload = null;
    if (bootstrap && bootstrap.endpoint === endpoint) {
      // One navigation-scoped reuse only: no stale inventory/session cache.
      delete window.__K_PLP_BOOTSTRAP__;
      payload = await bootstrap.promise;
    }
    if (!payload) {
      let response = await fetch(endpoint, {
        credentials: 'same-origin',
        priority: Number(page) === 1 ? 'high' : 'low',
      });
      if (!response.ok) throw new Error('Failed ' + endpoint + ' (' + response.status + ')');
      payload = await response.json();
    }
    let items = Array.isArray(payload) ? payload : payload && payload.products ? payload.products : [];
    let pagination = payload && payload.pagination && typeof payload.pagination === 'object'
      ? payload.pagination
      : null;
    return {
      items: Array.isArray(items) ? items : [],
      pagination: pagination,
    };
  }

  async function fetchSortIndexPage(page, sortBy) {
    let endpoint = buildJsonEndpoint(page, sortBy, {
      preserveCurrentFilters: false,
      view: 'k-custom-sort-index',
    });
    let response = await fetch(endpoint, { credentials: 'same-origin' });
    if (!response.ok) throw new Error('Failed ' + endpoint + ' (' + response.status + ')');
    let payload = await response.json();
    let items = Array.isArray(payload) ? payload : payload && payload.products ? payload.products : [];
    if (!Array.isArray(items)) return [];
    return items.map(function (item) {
      return {
        id: item && item.id != null ? item.id : '',
        handle: item && item.handle ? item.handle : '',
      };
    });
  }

  async function ensureServerSortOrderIndex(sortKey) {
    let key = normalizeSortKey(sortKey);
    if (!requiresServerSortOrder(key)) return null;
    if (state.sortOrderCache[key]) {
      return state.sortOrderCache[key];
    }

    let sessionCached = loadSortOrderCacheFromSession(key);
    if (sessionCached) {
      state.sortOrderCache[key] = sessionCached;
      return sessionCached;
    }

    if (state.sortOrderLoading[key]) {
      try {
        await state.sortOrderLoading[key];
      } catch (e) {}
      return state.sortOrderCache[key] || null;
    }

    state.sortOrderLoading[key] = (async function () {
      let indexMap = {};
      let seen = 0;
      let sortPageSize = 250;

      async function fetchSortItems(pageNo, sortKeyInner) {
        if (state.sortIndexViewEnabled !== false) {
          try {
            let lightItems = await fetchSortIndexPage(pageNo, sortKeyInner);
            state.sortIndexViewEnabled = true;
            return lightItems;
          } catch (e) {
            let errText = String((e && e.message) || e || '');
            let hasHttpStatus = /\(\d{3}\)/.test(errText);
            let isTemplateMissing = errText.indexOf('Unexpected token') > -1;
            state.sortIndexViewEnabled = (hasHttpStatus || isTemplateMissing) ? false : null;
          }
        }

        let heavyItems = await fetchPage(pageNo, sortKeyInner);
        return heavyItems.map(function (item) {
          return {
            id: item && item.id != null ? item.id : '',
            handle: item && item.handle ? item.handle : '',
          };
        });
      }

      function pushItems(items) {
        for (let i = 0; i < items.length; i += 1) {
          let item = items[i];
          let identity = getSortIdentity(item);
          if (!identity) continue;
          if (indexMap[identity] != null) continue;
          indexMap[identity] = seen;
          seen += 1;
        }
      }

      let firstPageItems = [];
      try {
        firstPageItems = await fetchSortItems(1, key);
      } catch (e) {
        console.error('[kushal-fast-filter] sort order fetch failed', key, 1, e);
      }
      if (!firstPageItems.length) {
        return;
      }

      pushItems(firstPageItems);
      if (firstPageItems.length < sortPageSize) {
        state.sortOrderCache[key] = indexMap;
        saveSortOrderCacheToSession(key, indexMap);
        return;
      }

      let estimatedCount = getTotalCountHint();
      let estimatedPages = estimatedCount > 0 ? Math.ceil(estimatedCount / sortPageSize) : 0;
      let initialLastPage = estimatedPages > 0 ? Math.min(250, Math.max(2, estimatedPages + 2)) : 60;
      let pageCursor = 2;
      let pageItemsByNo = {};
      let endPage = null;
      let workerCount = Math.min(14, Math.max(2, initialLastPage - 1));

      async function worker() {
        while (true) {
          let pageNo = pageCursor;
          pageCursor += 1;
          if (pageNo > initialLastPage) break;

          let items = [];
          try {
            items = await fetchSortItems(pageNo, key);
          } catch (e) {
            console.error('[kushal-fast-filter] sort order fetch failed', key, pageNo, e);
          }
          pageItemsByNo[pageNo] = items;
          if (items.length < sortPageSize && (endPage == null || pageNo < endPage)) {
            endPage = pageNo;
          }
        }
      }

      let workers = [];
      for (let w = 0; w < workerCount; w += 1) workers.push(worker());
      if (workers.length) await Promise.all(workers);

      let mergedLastPage = endPage == null ? initialLastPage : endPage;
      for (let pageNo = 2; pageNo <= mergedLastPage; pageNo += 1) {
        let items = pageItemsByNo[pageNo] || [];
        if (!items.length) break;
        pushItems(items);
        if (items.length < sortPageSize) {
          endPage = pageNo;
          break;
        }
      }

      if (endPage == null && initialLastPage < 250) {
        for (let pageNo = initialLastPage + 1; pageNo <= 250; pageNo += 1) {
          let items = [];
          try {
            items = await fetchSortItems(pageNo, key);
          } catch (e) {
            console.error('[kushal-fast-filter] sort order fetch failed', key, pageNo, e);
            break;
          }
          if (!items.length) break;
          pushItems(items);
          if (items.length < sortPageSize) break;
        }
      }

      if (seen > 0) {
        state.sortOrderCache[key] = indexMap;
        saveSortOrderCacheToSession(key, indexMap);
      }
    })()
      .catch(function (error) {
        console.error('[kushal-fast-filter] sort order cache failed', key, error);;
      })
      .finally(function () {
        delete state.sortOrderLoading[key];
      });

    try {
      await state.sortOrderLoading[key];
    } catch (e) {}
    return state.sortOrderCache[key] || null;
  }

  function scheduleServerSortReapply(sortKey) {
    let key = normalizeSortKey(sortKey);
    if (!requiresServerSortOrder(key)) return;
    if (state.sortOrderCache[key]) return;
    if (state.sortReapplyPendingKey === key) return;
    state.sortReapplyPendingKey = key;

    ensureServerSortOrderIndex(key)
      .then(function (map) {
        if (!map || !state.loaded) return;
        if (normalizeSortKey(state.sortBy || SORT_KEYS.RECOMMENDED) !== key) return;
        applyFilters();
      })
      .catch(function () {})
      .finally(function () {
        if (state.sortReapplyPendingKey === key) {
          state.sortReapplyPendingKey = '';
        }
      });
  }

  function prewarmServerSortCaches() {
    let keys = [SORT_KEYS.BEST_SELLER, SORT_KEYS.NEW_ARRIVAL];
    keys.forEach(function (sortKey) {
      let key = normalizeSortKey(sortKey);
      if (!requiresServerSortOrder(key)) return;
      if (state.sortOrderCache[key] || state.sortOrderLoading[key]) return;
      ensureServerSortOrderIndex(key).catch(function () {});
    });
  }

  async function hydrateRemainingProductsOnDemand(reason, options) {
    if (!state.loaded) return false;
    if (state.fullHydrated) return true;
    if (state.filterDatasetHydrationPromise) return state.filterDatasetHydrationPromise;
    if (state.hydrationPromise) return state.hydrationPromise;

    let startPage = Math.max(2, toNumber(state.hydrationNextPage, 2) || 2);
    let endPage = Math.max(startPage - 1, toNumber(state.hydrationTotalPages, 1) || 1);
    let sortKey = normalizeSortKey(state.hydrationBaseSortKey || SORT_KEYS.RECOMMENDED);
    let preserveCurrentFilters = !!state.hydrationPreserveCurrentFilters;
    let opts = options || {};
    let batchSize = Math.max(1, toNumber(opts.batchSize, 4) || 4);
    let shouldYield = opts.yieldBetweenBatches !== false;
    if (startPage > endPage) {
      state.fullHydrated = true;
      state.countsAreFinal = true;
      return true;
    }

    state.hydrationPromise = (async function () {
      let appended = 0;
      try {
        let pageNos = [];
        for (let p = startPage; p <= endPage; p += 1) pageNos.push(p);
        let all = Array.isArray(state.products) ? state.products.slice() : [];

        for (let i = 0; i < pageNos.length; i += batchSize) {
          let batchPages = pageNos.slice(i, i + batchSize);
          let results = await Promise.all(
            batchPages.map(async function (pageNo) {
              try {
                let items = await fetchPage(pageNo, sortKey, {
                  preserveCurrentFilters: preserveCurrentFilters,
                });
                return { pageNo: pageNo, items: Array.isArray(items) ? items : [] };
              } catch (e) {
                return { pageNo: pageNo, error: e };
              }
            })
          );

          let failedPage = results.find(function (result) { return result.error; });
          if (failedPage) throw failedPage.error;
          results.forEach(function (result) {
            if (!result.items.length) return;
            let offset = all.length;
            all = all.concat(result.items.map(function (product, index) {
              return normalizeProduct(product, offset + index);
            }));
            appended += result.items.length;
          });

          if (shouldYield) {
            await new Promise(function (resolve) {
              if (window.requestAnimationFrame) {
                window.requestAnimationFrame(function () {
                  setTimeout(resolve, 0);
                });
                return;
              }
              setTimeout(resolve, 0);
            });
          }
        }
        state.products = all;
        state.hydrationNextPage = endPage + 1;
        state.fullHydrated = true;
        state.countsAreFinal = true;
        syncFilteredFromProductsForUnfilteredState();
        ensureAvailableCitiesFilterPresent();
        ensureAllNearStoreOptionsPresent();
      } finally {
        state.hydrationPromise = null;
      }
      return true;
    })();

    return state.hydrationPromise;
  }

  function getStartupPreviewSignature() {
    return JSON.stringify([state.active, state.priceRange, state.sortBy, state.flashOnly]);
  }

  function hasCurrentStartupPreview() {
    return !!state.startupPreviewSignature &&
      state.startupPreviewSignature === getStartupPreviewSignature();
  }

  // An ordered prefix can prove the first page without proving total counts.
  // Global sorts, unresolved URL facets and unseen pins still need full data.
  function tryRenderStartupPreview() {
    if (!state.startupMaskActive || state.startupPreviewSignature || state.urlFiltersAtLoad ||
        state.deferApplyAfterLoad || state.pendingApply || pickLandingCategory() ||
        normalizeSortKey(state.sortBy) !== SORT_KEYS.RECOMMENDED) return false;
    let seenIds = new Set(state.products.map(function (product) { return String(product.id); }));
    if (Array.from(pinnedProductIds).some(function (id) { return !seenIds.has(id); })) return false;
    let matching = state.products.filter(function (product) {
      return matchesProduct(product, state.active, state.priceRange);
    });
    if (matching.length < state.perPage) return false;
    let visible = sortProducts(matching).slice(0, state.perPage);
    renderProductsOnly({ startupProducts: visible });
    state.startupPreviewSignature = getStartupPreviewSignature();
    setStartupLoader(false);
    state.startupMaskActive = false;
    nodes.countTargets.forEach(function (node) { node.style.visibility = 'hidden'; });
    if (nodes.pagination) nodes.pagination.style.display = 'none';
    return true;
  }

  function renderStartupServerPagePreview(products) {
    if (!state.startupMaskActive || state.startupPreviewSignature ||
        state.deferApplyAfterLoad || state.pendingApply || pickLandingCategory()) return false;
    let visible = (Array.isArray(products) ? products : [])
      .map(function (product, index) { return normalizeProduct(product, index); })
      .slice(0, state.perPage);
    if (!visible.length) return false;
    renderProductsOnly({ startupProducts: visible });
    state.startupPreviewSignature = getStartupPreviewSignature();
    setStartupLoader(false);
    state.startupMaskActive = false;
    nodes.countTargets.forEach(function (node) { node.style.visibility = 'hidden'; });
    if (nodes.pagination) nodes.pagination.style.display = 'none';
    return true;
  }

  async function loadAllProducts() {
    if (state.loading || state.loaded) return;
    state.loading = true;
    if (state.startupMaskActive) setStartupLoader(true);
    try {
      // Keep in-memory base order pinned to Shopify manual sort so
      // "Recommended" does not drift to backend default/active sort.
      let baseCatalogSortKey = SORT_KEYS.RECOMMENDED;
      let startupSortKey = normalizeSortKey(state.sortBy || SORT_KEYS.RECOMMENDED);
      let sortWarmupPromise = null;
      if (requiresServerSortOrder(startupSortKey) && !state.sortOrderCache[startupSortKey]) {
        sortWarmupPromise = ensureServerSortOrderIndex(startupSortKey);
      }

      let hasFiltersInUrl = hasExplicitFiltersInUrl();
      let hasStartupServerState = hasFiltersInUrl || startupSortKey !== SORT_KEYS.RECOMMENDED;
      if (hasStartupServerState) {
        try {
          let startupPayload = await fetchPageDetailed(1, startupSortKey, {
            preserveCurrentFilters: true,
          });
          let startupItems = Array.isArray(startupPayload.items) ? startupPayload.items : [];
          if (renderStartupServerPagePreview(startupItems)) await waitForNextPaint();
        } catch (e) {
          // Fall back to the full client hydration path below.
        }
      }
      // Startup source-of-truth for filtering:
      // always hydrate base catalog data first, then apply URL filters on top.
      // This keeps full facet universe available after reload.
      let preserveCurrentFilters = false;
      let firstPayload = await fetchPageDetailed(1, baseCatalogSortKey, {
        preserveCurrentFilters: preserveCurrentFilters,
      });
      let first = Array.isArray(firstPayload.items) ? firstPayload.items : [];
      let all = first.slice();
      state.products = all.map(normalizeProduct);
      if (tryRenderStartupPreview()) await waitForNextPaint();

      let pageSize = Math.max(1, first.length);
      let totalCountHint = getTotalCountHint();
      let serverPagesHint = toNumber(firstPayload && firstPayload.pagination ? firstPayload.pagination.pages : 0, 0);
      let serverItemsHint = toNumber(firstPayload && firstPayload.pagination ? firstPayload.pagination.items : 0, 0);
      let estimatedCount = Math.max(0, serverItemsHint || totalCountHint, 0);
      if (estimatedCount <= 0 && pageSize > 0) estimatedCount = pageSize;
      let estimatedPages = serverPagesHint > 0
        ? Math.max(1, serverPagesHint)
        : (estimatedCount > 0 ? Math.max(1, Math.ceil(estimatedCount / pageSize)) : 1);
      let fetchedPageLengths = { 1: first.length };
      let backgroundMode = getBackgroundHydrationMode();

      // Load first N pages quickly before showing results
      let initialPagesToLoad = Math.min(INITIAL_HYDRATION_PAGE_COUNT, estimatedPages);
      // Important: partial dataset is never final, regardless of hydration mode.
      // If total estimated pages exceed initial loaded pages, keep final flags false
      // so server-rendered count is not overwritten by partial JS counts.
      let hasPartialDataset = initialPagesToLoad < estimatedPages;
      let hasBackgroundHydration = hasPartialDataset && backgroundMode === 'idle';
      state.fullHydrated = false;
      state.countsAreFinal = false;
      state.hydrationTotalPages = estimatedPages;
      state.hydrationNextPage = Math.max(2, initialPagesToLoad + 1);
      state.hydrationBaseSortKey = baseCatalogSortKey;
      state.hydrationPreserveCurrentFilters = preserveCurrentFilters;
      let initialPages = [];
      for (let p = 2; p <= initialPagesToLoad; p += 1) {
        initialPages.push(p);
      }

      // Bound request contention with visible images; commit ordered batches.
      for (let start = 0; start < initialPages.length; start += INITIAL_HYDRATION_BATCH_SIZE) {
        let initialResults = await Promise.all(
          initialPages.slice(start, start + INITIAL_HYDRATION_BATCH_SIZE).map(async function (pageNo) {
            try {
              let items = await fetchPage(pageNo, baseCatalogSortKey, {
                preserveCurrentFilters: preserveCurrentFilters,
              });
              return { pageNo: pageNo, items: items };
            } catch (e) {
              return { pageNo: pageNo, error: e };
            }
          })
        );

        let failedPage = initialResults.find(function (result) { return result.error; });
        if (failedPage) throw failedPage.error;
        initialResults.forEach(function (result) {
          let items = Array.isArray(result.items) ? result.items : [];
          fetchedPageLengths[result.pageNo] = items.length;
          if (items.length) all = all.concat(items);
        });
        if (!state.startupPreviewSignature) {
          state.products = all.map(normalizeProduct);
          tryRenderStartupPreview();
        }
        await waitForNextPaint();
      }

      state.products = all.map(normalizeProduct);
      state.fullHydrated = !hasPartialDataset;
      state.countsAreFinal = !hasPartialDataset;
      state.loaded = true;
      state.loading = false;
      ensureAvailableCitiesFilterPresent();
      refreshNearbyToggleVisibility();
      restoreFromUrl();
      // Must sit HERE, not in initInitialStateSync(). restoreFromUrl() above
      // calls clearCheckedFilterInputs() whenever the URL carries no filters,
      // which is exactly the landing case — an earlier auto-open got its pill
      // unchecked and its bookkeeping wiped right here, so collectActiveState()
      // saw nothing, shouldApplyAfterLoadNow() stayed false and the unfiltered
      // server-rendered grid was kept. Checking the pill after the wipe and
      // before collectActiveState() is what makes the grid actually filter.
      autoOpenFirstCategoryOnLanding();
      collectActiveState();
      syncFilteredFromProductsForUnfilteredState();
      let canDeferPreviewCompletion = hasCurrentStartupPreview() && !state.fullHydrated && backgroundMode === 'idle';
      if (sortWarmupPromise && shouldApplyAfterLoadNow() && !canDeferPreviewCompletion) {
        try {
          await sortWarmupPromise;
        } catch (e) {}
      }

      // Keep server-rendered PLP intact on default unfiltered load.
      // Only switch to JS full-render path when filters/sort actually require it.
      if (shouldApplyAfterLoadNow() && canDeferPreviewCompletion) {
        syncAllFilterInputsFromState(state.active, state.priceRange);
        syncFilterUiFromState({
          syncOptions: false,
          syncHeaderToggle: false,
          syncPlp: true,
          syncPlpDeferred: true,
        });
        setDeferredApplyLoader(false);
      } else if (shouldApplyAfterLoadNow()) {
        await applyFilters().catch(function () {});
      } else {
        let existingCount = getRenderedProductCardCount();
        state.page = Math.max(1, Math.ceil(existingCount / Math.max(1, toNumber(state.perPage, 16) || 16)));
        resetAndRebindPagination('loadAllProducts-unfiltered');
        // Keep SSR cards, but heal any blanked image srcs + wishlist state.
        repairNewCardImages(nodes.list);
        if (typeof window.checkVisibilityAndCallAPI === 'function') {
          try {
            window.checkVisibilityAndCallAPI();
          } catch (e) {}
        }
      }

      // Optional idle-mode hydration only (disabled by default in production policy).
      if (initialPagesToLoad < estimatedPages && backgroundMode === 'idle') {
        (async function hydrateRemainingPages() {
          try {
            let batchSize = Math.max(1, toNumber(BACKGROUND_HYDRATION_BATCH_SIZE, 8) || 8);
            for (let batchStart = initialPagesToLoad + 1; batchStart <= estimatedPages; batchStart += batchSize) {
              let batchEnd = Math.min(estimatedPages, batchStart + batchSize - 1);
              let batchPages = [];
              for (let pageNo = batchStart; pageNo <= batchEnd; pageNo += 1) {
                batchPages.push(pageNo);
              }

              let batchResults = await Promise.all(
                batchPages.map(async function (pageNo) {
                  try {
                    let items = await fetchPage(pageNo, baseCatalogSortKey, {
                      preserveCurrentFilters: preserveCurrentFilters,
                    });
                    return { pageNo: pageNo, items: Array.isArray(items) ? items : [] };
                  } catch (e) {
                    console.error('[kushal-fast-filter] background page fetch failed', pageNo, e);
                    return { pageNo: pageNo, items: [] };
                  }
                })
              );

              let hasAnyNewItems = false;
              batchResults.forEach(function (result) {
                if (result.items.length) {
                  all = all.concat(result.items);
                  hasAnyNewItems = true;
                }
              });

              if (hasAnyNewItems) {
                state.products = all.map(normalizeProduct);
                syncFilteredFromProductsForUnfilteredState();
                ensureAvailableCitiesFilterPresent();
                ensureAllNearStoreOptionsPresent();
                if (!shouldApplyAfterLoadNow()) {
                  renderPagination();
                }
              }
            }
          } catch (error) {
            console.error('[kushal-fast-filter] background hydration failed', error);
          }
          state.fullHydrated = true;
          state.countsAreFinal = true;
          state.hydrationNextPage = estimatedPages + 1;
          if ((state.deferApplyAfterLoad || hasCurrentStartupPreview()) && state.loaded) {
            if (sortWarmupPromise) {
              try {
                await sortWarmupPromise;
              } catch (e) {}
            }
            await applyFilters().catch(function () {});
          }
        })();
      } else if (initialPagesToLoad < estimatedPages) {
        state.fullHydrated = false;
        state.countsAreFinal = false;
      }
    } catch (error) {
      console.error('[kushal-fast-filter] load failed', error);
      state.deferApplyAfterLoad = false;
    } finally {
      state.loading = false;
      if (state.startupMaskReleaseTimer) {
        window.clearTimeout(state.startupMaskReleaseTimer);
        state.startupMaskReleaseTimer = null;
      }
      // Keep startup loader alive when URL-applied filters are waiting
      // for full hydration and deferred apply.
      if (state.deferApplyAfterLoad) {
        setDeferredApplyLoader(true);
      } else {
        setDeferredApplyLoader(false);
      }
      if (state.startupMaskActive && !state.deferApplyAfterLoad) {
        setStartupLoader(false);
        state.startupMaskActive = false;
      }
    }
  }

  function getProductFacetValues(product, key) {
    let map = {
      category: 'meta_category',
      stylesubcategory: 'meta_style_subcategory',
      craftmanship: ['meta_craftmanship', 'meta_craftsmanship', 'meta_specialised', 'meta_specialized'],
      occasion: 'meta_occasion',
      metaltype: 'meta_metal_type',
      stonetype: 'meta_stone_type',
      closuretype: 'meta_closure_type',
      designshape: 'meta_design_shape',
      motif: 'meta_motif',
      returnable: 'meta_returnable',
    };
    let field = map[key];
    if (!field) return [];

    let fields = Array.isArray(field) ? field : [field];
    let values = [];
    fields.forEach(function (name) {
      if (!name) return;
      values = values.concat(parseList(product[name]));
    });

    return Array.from(new Set(values.map(handleize).filter(Boolean)));
  }

  function matchVariantOptionByName(product, targetName, values) {
    let options = Array.isArray(product.options) ? product.options : [];
    let target = handleize(targetName);
    let variants = Array.isArray(product.variants) ? product.variants : [];
    for (let i = 0; i < variants.length; i += 1) {
      let variant = variants[i];
      let variantOptions = [variant.option1, variant.option2, variant.option3];
      for (let idx = 0; idx < options.length && idx < variantOptions.length; idx += 1) {
        if (handleize(options[idx]) !== target) continue;
        if (values.indexOf(handleize(variantOptions[idx])) > -1) return true;
      }
    }
    return false;
  }

  function getVariantColorValues(variant) {
    if (!variant) return [];

    let sources = [];
    sources.push(variant.color);
    sources.push(variant.custom_color);
    sources.push(variant['custom.color']);

    let metafields = variant.metafields || {};
    sources.push(metafields.color);
    sources.push(metafields['custom.color']);
    if (metafields.custom) {
      sources.push(metafields.custom.color);
      sources.push(metafields.custom['color']);
      sources.push(metafields.custom.colour);
    }
    if (metafields.custom_color != null) sources.push(metafields.custom_color);

    let values = [];
    sources.forEach(function (source) {
      values = values.concat(parseList(source));
    });

    return values.filter(Boolean);
  }

  function matchVariantColor(product, values) {
    let variants = Array.isArray(product.variants) ? product.variants : [];
    for (let i = 0; i < variants.length; i += 1) {
      let variant = variants[i];
      let colorValues = getVariantColorValues(variant);
      for (let c = 0; c < colorValues.length; c += 1) {
        if (values.indexOf(handleize(colorValues[c])) > -1) return true;
      }
    }
    return false;
  }

  function matchNearStores(product, values) {
    let variants = Array.isArray(product.variants) ? product.variants : [];
    let nearList = [];
    for (let i = 0; i < variants.length; i += 1) {
      let variant = variants[i];
      let nearRaw = variant && (variant.near_stores != null ? variant.near_stores : variant.metafields && variant.metafields.near_stores);
      nearList = nearList.concat(parseList(nearRaw).map(handleize));
    }
    nearList = nearList.filter(Boolean);
    for (let v = 0; v < values.length; v += 1) {
      let token = values[v];
      if (token === 'near-stores' && nearList.length) return true;
      if (nearList.indexOf(token) > -1) return true;
    }
    return false;
  }

  function getVariantAvailableCityValues(variant) {
    if (!variant) return [];

    let sources = [];
    sources.push(variant.available_cities);
    sources.push(variant['custom.available_cities']);
    sources.push(variant.custom_available_cities);

    let metafields = variant.metafields || {};
    sources.push(metafields.available_cities);
    sources.push(metafields['custom.available_cities']);
    if (metafields.custom) {
      sources.push(metafields.custom.available_cities);
      sources.push(metafields.custom['available_cities']);
    }

    let values = [];
    sources.forEach(function (source) {
      values = values.concat(parseList(source));
    });

    return values.filter(Boolean);
  }

  function matchVariantAvailableCities(product, values) {
    let variants = Array.isArray(product.variants) ? product.variants : [];
    for (let i = 0; i < variants.length; i += 1) {
      let variant = variants[i];
      let cityValues = getVariantAvailableCityValues(variant);
      for (let c = 0; c < cityValues.length; c += 1) {
        if (values.indexOf(handleize(cityValues[c])) > -1) return true;
      }
    }
    return false;
  }

  function variantMatchesOptionByName(product, variant, targetName, values) {
    let options = Array.isArray(product && product.options) ? product.options : [];
    let target = handleize(targetName);
    let variantOptions = [variant && variant.option1, variant && variant.option2, variant && variant.option3];
    for (let idx = 0; idx < options.length && idx < variantOptions.length; idx += 1) {
      if (handleize(options[idx]) !== target) continue;
      if (values.indexOf(handleize(variantOptions[idx])) > -1) return true;
    }
    return false;
  }

  function variantMatchesColor(variant, values) {
    let colorValues = getVariantColorValues(variant);
    for (let c = 0; c < colorValues.length; c += 1) {
      if (values.indexOf(handleize(colorValues[c])) > -1) return true;
    }
    return false;
  }

  function variantMatchesNearStores(variant, values) {
    let nearRaw = variant && (variant.near_stores != null ? variant.near_stores : variant.metafields && variant.metafields.near_stores);
    let nearList = parseList(nearRaw).map(handleize).filter(Boolean);
    for (let v = 0; v < values.length; v += 1) {
      let token = values[v];
      if (token === 'near-stores' && nearList.length) return true;
      if (nearList.indexOf(token) > -1) return true;
    }
    return false;
  }

  function variantMatchesAvailableCities(variant, values) {
    let cityValues = getVariantAvailableCityValues(variant);
    for (let c = 0; c < cityValues.length; c += 1) {
      let rawToken = handleize(cityValues[c]);
      let canonical = resolveCityCanonical(rawToken);
      let token = canonical ? canonical.token : rawToken;
      if (values.indexOf(token) > -1 || values.indexOf(rawToken) > -1) return true;
    }
    return false;
  }

  function matchesVariantScopedFilters(product, active) {
    let variants = Array.isArray(product && product.variants) ? product.variants : [];
    if (!variants.length) return false;
    let hasVariantScopedFilter =
      !!((active.size && active.size.length) ||
         (active.polish && active.polish.length) ||
         (active.color && active.color.length) ||
         (active.nearstores && active.nearstores.length) ||
         (active.availablecities && active.availablecities.length));
    if (!hasVariantScopedFilter) return true;

    for (let i = 0; i < variants.length; i += 1) {
      let variant = variants[i];
      let ok = true;
      if (active.size && active.size.length) {
        ok = ok && variantMatchesOptionByName(product, variant, 'size', active.size);
      }
      if (ok && active.polish && active.polish.length) {
        ok = ok && variantMatchesOptionByName(product, variant, 'polish', active.polish);
      }
      if (ok && active.color && active.color.length) {
        ok = ok && variantMatchesColor(variant, active.color);
      }
      if (ok && active.nearstores && active.nearstores.length) {
        ok = ok && variantMatchesNearStores(variant, active.nearstores);
      }
      if (ok && active.availablecities && active.availablecities.length) {
        ok = ok && variantMatchesAvailableCities(variant, active.availablecities);
      }
      if (ok) return true;
    }
    return false;
  }

  function getVariantOptionTokensByName(product, targetName) {
    let tokens = [];
    let options = Array.isArray(product.options) ? product.options : [];
    let target = handleize(targetName);
    let variants = Array.isArray(product.variants) ? product.variants : [];

    for (let i = 0; i < variants.length; i += 1) {
      let variant = variants[i];
      let variantOptions = [variant.option1, variant.option2, variant.option3];
      for (let idx = 0; idx < options.length && idx < variantOptions.length; idx += 1) {
        if (handleize(options[idx]) !== target) continue;
        let token = handleize(variantOptions[idx]);
        if (token && tokens.indexOf(token) === -1) tokens.push(token);
      }
    }

    return tokens;
  }

  function getVariantColorTokens(product) {
    let tokens = [];
    let variants = Array.isArray(product.variants) ? product.variants : [];
    for (let i = 0; i < variants.length; i += 1) {
      let variant = variants[i];
      let colorValues = getVariantColorValues(variant);
      for (let c = 0; c < colorValues.length; c += 1) {
        let token = handleize(colorValues[c]);
        if (token && tokens.indexOf(token) === -1) tokens.push(token);
      }
    }
    return tokens;
  }

  function getNearStoreTokens(product) {
    let tokens = [];
    let variants = Array.isArray(product.variants) ? product.variants : [];
    for (let i = 0; i < variants.length; i += 1) {
      let variant = variants[i];
      let nearRaw = variant && (variant.near_stores != null ? variant.near_stores : variant.metafields && variant.metafields.near_stores);
      let nearValues = parseList(nearRaw);
      for (let n = 0; n < nearValues.length; n += 1) {
        let token = handleize(nearValues[n]);
        if (token && tokens.indexOf(token) === -1) tokens.push(token);
      }
    }
    if (tokens.length && tokens.indexOf('near-stores') === -1) tokens.push('near-stores');
    return tokens;
  }

  function getAvailableCityTokens(product) {
    let tokens = [];
    let variants = Array.isArray(product.variants) ? product.variants : [];
    for (let i = 0; i < variants.length; i += 1) {
      let variant = variants[i];
      let cityValues = getVariantAvailableCityValues(variant);
      for (let c = 0; c < cityValues.length; c += 1) {
        let token = handleize(cityValues[c]);
        if (token && tokens.indexOf(token) === -1) tokens.push(token);
      }
    }
    return tokens;
  }

  function getProductTokensForKey(product, key) {
    if (!product || !key) return [];
    if (key === 'category' || key === 'stylesubcategory' || key === 'craftmanship' || key === 'occasion' ||
        key === 'metaltype' || key === 'stonetype' || key === 'closuretype' || key === 'designshape' ||
        key === 'motif' || key === 'returnable') {
      return getProductFacetValues(product, key);
    }
    if (key === 'size') return getVariantOptionTokensByName(product, 'size');
    if (key === 'polish') return getVariantOptionTokensByName(product, 'polish');
    if (key === 'color') return getVariantColorTokens(product);
    if (key === 'nearstores') return getNearStoreTokens(product);
    if (key === 'availablecities') return getAvailableCityTokens(product);

    let tags = (product.tags || []).map(handleize).filter(Boolean);
    return Array.from(new Set(tags));
  }

  // 60-min delivery, as a real filter dimension rather than a coat of paint over
  // the rendered grid. assets/plp-flash-filter.js used to hide ineligible cards
  // in place, which left the server's 6-cards / hero / breaker rhythm intact
  // around holes: half-empty rows, a breaker after one card, dividers with
  // nothing left to divide. Narrowing state.filtered instead means
  // renderProductsOnly() rebuilds the whole rhythm over the 60-min set, exactly
  // as it does for a category or a price range.
  function flashEligible(product) {
    let api = window.KQD && window.KQD.quickcom ? window.KQD.quickcom : null;
    if (!api || !api.record || !api.record()) return true;   // nothing to filter by yet
    return api.hasProduct(product && product.id) === true;
  }

  function matchesProduct(product, active, priceRange) {
    if (state.flashOnly && !flashEligible(product)) return false;
    if (!matchesVariantScopedFilters(product, active || {})) return false;

    let keys = Object.keys(active || {});
    for (let i = 0; i < keys.length; i += 1) {
      let key = keys[i];
      let values = active[key];
      if (!values || !values.length) continue;

      let ok = false;
      if (key === 'category' || key === 'stylesubcategory' || key === 'craftmanship' || key === 'occasion' ||
          key === 'metaltype' || key === 'stonetype' || key === 'closuretype' || key === 'designshape' ||
          key === 'motif' || key === 'returnable') {
        let productValues = getProductFacetValues(product, key);
        ok = values.some(function (v) { return productValues.indexOf(v) > -1; });
      } else if (key === 'size' || key === 'polish' || key === 'color' || key === 'nearstores' || key === 'availablecities') {
        ok = true;
      } else {
        let tags = (product.tags || []).map(handleize);
        ok = values.some(function (v) { return tags.indexOf(v) > -1; });
      }

      if (!ok) return false;
    }

    if (priceRange && (priceRange.min != null || priceRange.max != null)) {
      let cents = toNumber(product.price, 0);
      if (priceRange.min != null && cents < priceRange.min * 100) return false;
      if (priceRange.max != null && cents > priceRange.max * 100) return false;
    }
    return true;
  }

  function isVariantScopedKey(key) {
    return key === 'size' || key === 'polish' || key === 'color' || key === 'nearstores' || key === 'availablecities';
  }

  function variantMatchesKeyValues(product, variant, key, values) {
    if (!values || !values.length) return true;
    if (key === 'size' || key === 'polish') return variantMatchesOptionByName(product, variant, key, values);
    if (key === 'color') return variantMatchesColor(variant, values);
    if (key === 'nearstores') return variantMatchesNearStores(variant, values);
    if (key === 'availablecities') return variantMatchesAvailableCities(variant, values);
    return false;
  }

  function getStrictCountTokensForVariantKey(product, key, scopedActive) {
    let variants = Array.isArray(product && product.variants) ? product.variants : [];
    if (!variants.length) return [];
    let tokens = [];

    for (let i = 0; i < variants.length; i += 1) {
      let variant = variants[i];
      let ok = true;
      let activeKeys = Object.keys(scopedActive || {});
      for (let k = 0; k < activeKeys.length; k += 1) {
        let activeKey = activeKeys[k];
        if (!isVariantScopedKey(activeKey) || activeKey === key) continue;
        let activeValues = scopedActive[activeKey];
        if (!activeValues || !activeValues.length) continue;
        if (!variantMatchesKeyValues(product, variant, activeKey, activeValues)) {
          ok = false;
          break;
        }
      }
      if (!ok) continue;

      let variantTokens = getVariantOptionTokensByFilterKey(product, variant, key);
      for (let t = 0; t < variantTokens.length; t += 1) {
        let token = variantTokens[t];
        if (!token || tokens.indexOf(token) > -1) continue;
        tokens.push(token);
      }
    }

    return tokens;
  }


  function sortProducts(items) {
    let sorted = items.slice();
    let key = normalizeSortKey(state.sortBy || SORT_KEYS.RECOMMENDED);
    let serverIndexMap = state.sortOrderCache[key] || null;

    function compareByOriginalPosition(a, b) {
      return toNumber(a._yIndex, 0) - toNumber(b._yIndex, 0);
    }

    function compareByTimestampDesc(a, b) {
      let diff = getProductTimestamp(b) - getProductTimestamp(a);
      if (diff) return diff;
      let aId = toNumber(a && a.id, 0);
      let bId = toNumber(b && b.id, 0);
      if (aId && bId && aId !== bId) return bId - aId;
      return compareByOriginalPosition(a, b);
    }

    function compareByTimestampAsc(a, b) {
      let diff = getProductTimestamp(a) - getProductTimestamp(b);
      if (diff) return diff;
      let aId = toNumber(a && a.id, 0);
      let bId = toNumber(b && b.id, 0);
      if (aId && bId && aId !== bId) return aId - bId;
      return compareByOriginalPosition(a, b);
    }

    function compareByPriceAsc(a, b) {
      let diff = toNumber(a.price, 0) - toNumber(b.price, 0);
      if (diff) return diff;
      return compareByOriginalPosition(a, b);
    }

    function compareByPriceDesc(a, b) {
      let diff = toNumber(b.price, 0) - toNumber(a.price, 0);
      if (diff) return diff;
      return compareByOriginalPosition(a, b);
    }

    function compareByBestSellingFallback(a, b) {
      let scoreDiff = getBestSellerScore(b) - getBestSellerScore(a);
      if (scoreDiff) return scoreDiff;
      return compareByTimestampDesc(a, b);
    }

    function compareByServerOrder(a, b, fallbackCompare) {
      let aIdentity = getSortIdentity(a);
      let bIdentity = getSortIdentity(b);
      let aHasOrder = !!(aIdentity && serverIndexMap && serverIndexMap[aIdentity] != null);
      let bHasOrder = !!(bIdentity && serverIndexMap && serverIndexMap[bIdentity] != null);
      if (aHasOrder !== bHasOrder) return aHasOrder ? -1 : 1;
      if (aHasOrder && bHasOrder) {
        let aOrder = serverIndexMap[aIdentity];
        let bOrder = serverIndexMap[bIdentity];
        if (aOrder !== bOrder) return aOrder - bOrder;
      }
      return typeof fallbackCompare === 'function'
        ? fallbackCompare(a, b)
        : compareByOriginalPosition(a, b);
    }

    if (key === SORT_KEYS.PRICE_LOW_TO_HIGH) {
      sorted.sort(compareByPriceAsc);
    } else if (key === SORT_KEYS.PRICE_HIGH_TO_LOW) {
      sorted.sort(compareByPriceDesc);
    } else if (key === SORT_KEYS.NEW_ARRIVAL) {
      if (requiresServerSortOrder(key) && serverIndexMap) {
        sorted.sort(function (a, b) {
          return compareByServerOrder(a, b, compareByTimestampDesc);
        });
      } else {
        sorted.sort(compareByTimestampDesc);
      }
    } else if (key === SORT_KEYS.DATE_OLD_TO_NEW) {
      if (requiresServerSortOrder(key) && serverIndexMap) {
        sorted.sort(function (a, b) {
          return compareByServerOrder(a, b, compareByTimestampAsc);
        });
      } else {
        sorted.sort(compareByTimestampAsc);
      }
    } else if (key === SORT_KEYS.BEST_SELLER) {
      if (requiresServerSortOrder(key) && serverIndexMap) {
        sorted.sort(function (a, b) {
          return compareByServerOrder(a, b, compareByBestSellingFallback);
        });
      } else {
        sorted.sort(compareByBestSellingFallback);
      }
    } else {
      sorted.sort(compareByOriginalPosition);
    }

    // Pinned products lead only in the default/recommended collection order.
    // Explicit sorting must keep the order calculated above.
    if (pinnedProductIds.size && key === SORT_KEYS.RECOMMENDED) {
      sorted.sort(function (a, b) {
        let aId = String(a && a.id != null ? a.id : '');
        let bId = String(b && b.id != null ? b.id : '');
        let aPinned = pinnedProductRanks.has(aId);
        let bPinned = pinnedProductRanks.has(bId);
        if (aPinned !== bPinned) return aPinned ? -1 : 1;
        if (aPinned && bPinned) return pinnedProductRanks.get(aId) - pinnedProductRanks.get(bId);
        return 0;
      });
    }

    return sorted;
  }

  function formatMoney(cents) {
    if (
      window.theme &&
      window.theme.Shopify &&
      typeof window.theme.Shopify.formatMoney === 'function' &&
      window.Shopify &&
      window.Shopify.money_format
    ) {
      return window.theme.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return '₹ ' + (toNumber(cents, 0) / 100).toFixed(2);
  }

  function getProductByIdFromState(productId) {
    let pid = String(productId || '').trim();
    if (!pid) return null;
    let sources = [state.filtered, state.products];
    for (let s = 0; s < sources.length; s += 1) {
      let list = Array.isArray(sources[s]) ? sources[s] : [];
      for (let i = 0; i < list.length; i += 1) {
        let p = list[i];
        if (String(p && p.id != null ? p.id : '').trim() === pid) return p;
      }
    }
    return null;
  }

  function isProductLevelFilterKey(key) {
    return (
      key === 'category' ||
      key === 'stylesubcategory' ||
      key === 'craftmanship' ||
      key === 'occasion' ||
      key === 'metaltype' ||
      key === 'stonetype' ||
      key === 'closuretype' ||
      key === 'designshape' ||
      key === 'motif' ||
      key === 'returnable'
    );
  }

  function getVariantOptionTokensByFilterKey(product, variant, filterKey) {
    if (!product || !variant || !filterKey) return [];
    if (filterKey === 'color') return getVariantColorValues(variant).map(handleize).filter(Boolean);
    if (filterKey === 'nearstores') {
      let nearRaw = variant && (variant.near_stores != null ? variant.near_stores : variant.metafields && variant.metafields.near_stores);
      let near = parseList(nearRaw).map(handleize).filter(Boolean);
      if (near.length && near.indexOf('near-stores') === -1) near.push('near-stores');
      return near;
    }
    if (filterKey === 'availablecities') return getVariantAvailableCityValues(variant).map(handleize).filter(Boolean);

    if (filterKey === 'size' || filterKey === 'polish') {
      let options = Array.isArray(product.options) ? product.options : [];
      let target = filterKey === 'size' ? 'size' : 'polish';
      let variantOptions = [variant.option1, variant.option2, variant.option3];
      let tokens = [];
      for (let idx = 0; idx < options.length && idx < variantOptions.length; idx += 1) {
        if (handleize(options[idx]) !== target) continue;
        let token = handleize(variantOptions[idx]);
        if (token && tokens.indexOf(token) === -1) tokens.push(token);
      }
      return tokens;
    }
    return [];
  }

  function isAvailabilityOnlyFilterKey(key) {
    return key === 'availablecities' || key === 'nearstores';
  }

  function pickBestVariantForKeys(product, active, keys) {
    let bestVariant = null;
    let bestScore = -1;

    for (let i = 0; i < product.variants.length; i += 1) {
      let variant = product.variants[i];
      let variantScore = 0;
      let allKeysMatched = true;

      for (let k = 0; k < keys.length; k += 1) {
        let key = keys[k];
        let required = (active[key] || []).map(handleize).filter(Boolean);
        let variantTokens = getVariantOptionTokensByFilterKey(product, variant, key);
        if (!required.length || !variantTokens.length) {
          allKeysMatched = false;
          break;
        }

        let matchedIndex = -1;
        for (let r = 0; r < required.length; r += 1) {
          if (variantTokens.indexOf(required[r]) > -1) {
            matchedIndex = r;
            break;
          }
        }

        if (matchedIndex < 0) {
          allKeysMatched = false;
          break;
        }

        variantScore += 1000 - matchedIndex;
      }

      if (!allKeysMatched) continue;

      if (variant.featured_media_id) variantScore += 1;

      if (variantScore > bestScore) {
        bestScore = variantScore;
        bestVariant = variant;
      }
    }

    return bestVariant;
  }

  function getPreferredVariantForActiveFilters(product, active) {
    if (!product || !Array.isArray(product.variants) || !product.variants.length) return null;
    let keys = Object.keys(active || {}).filter(function (key) {
      if (key === '__sort' || key === '__price') return false;
      if (isProductLevelFilterKey(key)) return false;
      let values = active[key];
      return Array.isArray(values) && values.length > 0;
    });
    if (!keys.length) return null;

    // First pass: try to find a variant matching all active keys (including availability filters).
    let bestVariant = pickBestVariantForKeys(product, active, keys);
    if (bestVariant) return bestVariant;

    // Second pass: availability filters (availablecities, nearstores) are metafield-level and
    // may not share a variant with the visual attribute (color). Fall back to visual keys only
    // so the correct color image is still shown on the card.
    let visualKeys = keys.filter(function (key) { return !isAvailabilityOnlyFilterKey(key); });
    if (visualKeys.length && visualKeys.length < keys.length) {
      return pickBestVariantForKeys(product, active, visualKeys);
    }

    return null;
  }

  function appendVariantToHref(href, variantId) {
    if (!href || !variantId) return href;
    try {
      let url = new URL(href, window.location.origin);
      url.searchParams.set('variant', String(variantId));
      if (url.origin === window.location.origin) {
        return url.pathname + url.search + url.hash;
      }
      return url.toString();
    } catch (e) {
      return href;
    }
  }

  function getVariantFeaturedImageUrl(variant) {
    if (!variant || typeof variant !== 'object') return '';

    let direct = String(variant.featured_image || '').trim();
    if (direct && direct !== '[object Object]') return direct;

    let candidateKeys = ['src', 'url', 'image', 'featured_image'];
    for (let i = 0; i < candidateKeys.length; i += 1) {
      let key = candidateKeys[i];
      let value = variant[key];
      if (typeof value === 'string' && String(value || '').trim()) return String(value || '').trim();
      if (value && typeof value === 'object') {
        let nestedSrc = String(value.src || value.url || value.image || '').trim();
        if (nestedSrc) return nestedSrc;
      }
    }

    if (variant.featured_media && typeof variant.featured_media === 'object') {
      let mediaSrc = String(
        variant.featured_media.src ||
        variant.featured_media.url ||
        (variant.featured_media.preview_image && (variant.featured_media.preview_image.src || variant.featured_media.preview_image.url)) ||
        ''
      ).trim();
      if (mediaSrc) return mediaSrc;
    }

    return '';
  }

  // Path-only key for an image URL, so the same file requested at two widths
  // compares equal. The variant image arrives from
  // templates/collection.json.liquid at width 800 while the card renders its own
  // images at 540 (snippets/product-block.liquid), so a full-string comparison
  // never matches even when it is the very same photo.
  function imagePathKey(url) {
    let u = String(url || '').trim();
    if (!u) return '';
    try {
      return new URL(u, window.location.href).pathname;
    } catch (e) {
      return u.split('?')[0];
    }
  }

  // Variant image for the Figma card markup.
  //
  // The old card wrapped every image in .product-block__image[data-media-id] and
  // switched slides by class, which is what applyPreferredVariantStateToCards()
  // below still drives. The new card is a strip of <img class="product-img">
  // inside .card-slider-track, with .active marking the visible one and no media
  // id anywhere — so that media-id lookup finds nothing and the function used to
  // return before touching a single image. That is the whole reason a Colour,
  // Polish or Near-store filter left the default photo on the card.
  //
  // Contract mirrored here is setActiveIndex() in assets/custom.js: .active on
  // the slide and on the matching dot, and data-active-slide-index on the
  // .card-image-wrap root, so a later swipe or dot tap carries on from the slide
  // the filter selected instead of snapping back to the first.
  function applyPreferredVariantToNewCard(card, variant) {
    let track = card.querySelector('.card-slider-track');
    if (!track) return;

    let slides = Array.prototype.slice.call(track.querySelectorAll('.product-img'));
    if (!slides.length) return;

    let variantImage = normalizeCdnUrl(getVariantFeaturedImageUrl(variant));
    if (!variantImage) return;

    let targetPath = imagePathKey(variantImage);
    let activeIndex = -1;
    if (targetPath) {
      for (let i = 0; i < slides.length; i += 1) {
        // data-k-src first: on a deferred card that is where the real URL lives
        // and src is still the placeholder.
        let candidate =
          slides[i].getAttribute('data-slide-src') ||
          slides[i].getAttribute('data-k-src') ||
          slides[i].getAttribute('src');
        if (imagePathKey(normalizeCdnUrl(candidate)) === targetPath) {
          activeIndex = i;
          break;
        }
      }
    }

    if (activeIndex < 0) {
      // The card only carries the first three product images
      // (snippets/product-block.liquid), so a variant beyond those has no slide
      // of its own. Overwrite the first rather than leave a wrong photo showing.
      //
      // data-k-src is rewritten too, not just src: prepareCardHtmlForDeferredImages()
      // parks the real URL there for below-the-fold cards, and
      // setupProgressivePlpImages() would otherwise paint the ORIGINAL image
      // straight back over this one when the card scrolled into view.
      let first = slides[0];
      first.setAttribute('data-slide-src', variantImage);
      if (first.hasAttribute('data-k-src')) {
        first.setAttribute('data-k-src', variantImage);
      } else if (!isSameResolvedUrl(first.getAttribute('src'), variantImage)) {
        first.setAttribute('src', variantImage);
      }
      first.removeAttribute('srcset');
      first.removeAttribute('data-k-srcset');
      activeIndex = 0;
    }

    // A slide that is about to become visible must not still be a placeholder.
    loadDeferredImage(slides[activeIndex]);

    slides.forEach(function (slide, idx) {
      slide.classList.toggle('active', idx === activeIndex);
    });

    let sliderRoot = card.querySelector('.card-image-wrap') || track.parentElement;
    if (sliderRoot) {
      sliderRoot.setAttribute('data-active-slide-index', String(activeIndex));
      Array.prototype.forEach.call(
        sliderRoot.querySelectorAll('.card-carousel-dots .dot'),
        function (dot, idx) {
          dot.classList.toggle('active', idx === activeIndex);
        }
      );
    }
  }

  function applyPreferredVariantStateToCards(containerOrCards) {
    let cards;
    if (containerOrCards && typeof containerOrCards.length === 'number' && !containerOrCards.querySelectorAll) {
      cards = containerOrCards;
    } else {
      let scope = containerOrCards || nodes.list;
      if (!scope || !scope.querySelectorAll) return;
      cards = scope.querySelectorAll('.product-block[data-product-id]');
    }
    if (!cards || !cards.length) return;

    cards.forEach(function (card) {
      let product = getProductByIdFromState(card.getAttribute('data-product-id'));
      if (!product) return;
      let variant = getPreferredVariantForActiveFilters(product, state.active || {});
      if (!variant || !variant.id) return;

      card.querySelectorAll('a.product-link, a.CT-product-link').forEach(function (link) {
        let href = link.getAttribute('href');
        let nextHref = appendVariantToHref(href, variant.id);
        if (nextHref) link.setAttribute('href', nextHref);
      });

      let mediaId = String(variant.featured_media_id || '').trim();
      let images = card.querySelectorAll('.product-block__image[data-media-id]');
      if (!images || !images.length) {
        // New Figma card: different markup, different switch mechanism.
        applyPreferredVariantToNewCard(card, variant);
        return;
      }
      let imageList = Array.prototype.slice.call(images);
      let activeIndex = -1;
      if (mediaId) {
        for (let i = 0; i < imageList.length; i += 1) {
          if (String(imageList[i].getAttribute('data-media-id') || '').trim() === mediaId) {
            activeIndex = i;
            break;
          }
        }
      } else {
        activeIndex = 0;
      }

      if (activeIndex < 0) {
        let variantImage = getVariantFeaturedImageUrl(variant);
        if (variantImage) {
          let primaryNode = card.querySelector('.product-block__image--primary') || imageList[0];
          if (primaryNode) {
            primaryNode.classList.add('product-block__image--active');
            primaryNode.classList.remove('product-block__image--inactivated');
            if (mediaId) primaryNode.setAttribute('data-media-id', mediaId);

            let imageTags = primaryNode.querySelectorAll('img');
            imageTags.forEach(function (img) {
              img.setAttribute('src', variantImage);
              img.setAttribute('data-src', variantImage);
              img.setAttribute('data-k-src', variantImage);
              img.removeAttribute('srcset');
              img.removeAttribute('data-srcset');
              img.removeAttribute('data-k-srcset');
            });

            let bgNode = primaryNode.querySelector('[data-lazy-bgset-src]');
            if (bgNode) {
              bgNode.setAttribute('data-lazy-bgset-src', variantImage);
              bgNode.style.backgroundImage = 'url("' + variantImage + '")';
            }
          }
        }
        activeIndex = 0;
      }

      let hoverIndex = imageList.length > 1 ? (activeIndex + 1) % imageList.length : -1;
      imageList.forEach(function (imgNode, idx) {
        let isActive = idx === activeIndex;
        let isHoverTarget = idx === hoverIndex && idx !== activeIndex;
        imgNode.classList.toggle('product-block__image--active', isActive);
        imgNode.classList.toggle('product-block__image--show-on-hover', isHoverTarget);
        if (isActive) {
          imgNode.classList.remove('product-block__image--inactivated');
        } else {
          imgNode.classList.add('product-block__image--inactivated');
        }
      });

      let slider = card.querySelector('[data-product-card-slider]');
      if (slider) {
        slider.setAttribute('data-active-slide-index', String(activeIndex));
        slider.querySelectorAll('.product-block__image-dot[data-slide-dot-index]').forEach(function (dot, idx) {
          dot.classList.toggle('product-block__image-dot--active', idx === activeIndex);
        });
      }

      if (mediaId) {
        let swatch = card.querySelector('.product-block-options__item[data-media="' + mediaId + '"]');
        if (swatch && window.jQuery) {
          try { window.jQuery(swatch).trigger('mouseenter'); } catch (e) {}
        }
      }
    });
  }

  function renderCard(product) {
    if (product && product.card_html) {
      return String(product.card_html);
    }

    let imageUrl = product.featured_image || '';
    let title = product.title || '';
    let url = product.url || ('/products/' + (product.handle || ''));
    let price = toNumber(product.price, 0);
    let compareAt = toNumber(product.compare_at_price, 0);
    let onSale = compareAt > price && price > 0;
    let discount = onSale ? Math.round(((compareAt - price) / compareAt) * 100) : 0;

    // Analytics attributes on the JSON fallback card. The primary path returns
    // product.card_html — the real snippet, with the full attribute set — so
    // this branch only runs when the payload carries no HTML, and without these
    // "PLP Product Clicked" and the spotlight events would report a blank
    // product_name, which is the join key against "Viewed Product".
    // Price is the theme's own money format with the currency stripped, the
    // same shape money_without_currency and the PDP's Viewed Product produce.
    let analyticsPrice = price > 0 ? formatMoney(price).replace(/[^\d.,]/g, '').trim() : '';

    return (
      '<article class="CT_product-block product-block" data-product-id="' +
      (product.id || '') +
      '" data-product="' + escapeHtml(title) +
      '" data-prodPrice="' + escapeHtml(analyticsPrice) +
      '" data-prodURL="' + escapeHtml(url) +
      '" data-imageUrl="' + escapeHtml(imageUrl) +
      '">' +
      '<div class="block-inner"><div class="block-inner-inner">' +
      '<a class="product-link" href="' +
      url +
      '">' +
      '<div class="image-cont"><div class="product-block__image product-block__image--primary product-block__image--active">' +
      (imageUrl ? '<img loading="lazy" src="' + imageUrl + '" alt="' + escapeHtml(title) + '">' : '') +
      '</div></div>' +
      '<div class="product-info">' +
      '<h3 class="product-block__title">' +
      escapeHtml(title) +
      '</h3>' +
      '<div class="product-price">' +
      '<span class="product-price__item product-price__item--current">' +
      formatMoney(price) +
      '</span>' +
      (onSale
        ? '<span class="product-price__item product-price__item--compare"><s>' + formatMoney(compareAt) + '</s></span>' +
          '<span class="product-price__item product-price__item--badge">' + discount + '% OFF</span>'
        : '') +
      '</div></div></a></div></div></article>'
    );
  }

  // Standard card HTML -> hero card HTML, the shape snippets/product-hero-block.liquid
  // renders: same .card-image-wrap (badges, wishlist, slider, dots) with the
  // material pill, title and price moved onto the artwork in .hero-overlay-stack,
  // and the below-image .card-info dropped. Converted rather than fetched as a
  // second HTML string per product so the JSON payload stays the size it is.
  // assets/custom.css dresses the hero back down to an ordinary card ≥768px.
  function buildHeroCardHtml(cardHtml) {
    let html = String(cardHtml || '');
    if (!html) return html;

    let holder = document.createElement('div');
    holder.innerHTML = html;
    let card = holder.querySelector('.product-block[data-product-id], .CT_product-block[data-product-id]');
    if (!card) return html;
    if (card.classList.contains('product-hero-card')) return html;

    let wrap = card.querySelector('.card-image-wrap') || card.querySelector('.image-cont');
    if (!wrap) return html;

    let info = card.querySelector('.card-info, .product-info');
    let titleNode = card.querySelector('.card-title, .product-block__title');
    let titleLink = titleNode ? titleNode.querySelector('a') : null;
    let titleText = titleNode ? String(titleNode.textContent || '').trim() : '';
    if (!titleText) titleText = card.getAttribute('data-product') || '';

    let href = '';
    if (titleLink) href = titleLink.getAttribute('href') || '';
    if (!href) {
      let anyLink = card.querySelector('a.product-link[href], a[href]');
      if (anyLink) href = anyLink.getAttribute('href') || '';
    }

    let stack = document.createElement('div');
    stack.className = 'hero-overlay-stack';

    // The pill is absolutely placed on a normal card and flows inside the stack
    let pill = wrap.querySelector('.card-badge-bottom-left');
    if (pill) stack.appendChild(pill);

    let caption = document.createElement('a');
    caption.className = 'hero-caption product-link';
    caption.setAttribute('href', href || '#');

    let titleSpan = document.createElement('span');
    titleSpan.className = 'hero-title';
    titleSpan.textContent = titleText;
    caption.appendChild(titleSpan);

    let priceSpan = document.createElement('span');
    priceSpan.className = 'hero-price';

    let currencyNode = card.querySelector('.card-price .currency');
    let amountNode =
      card.querySelector('.card-price .price-amount') ||
      card.querySelector('.product-price__item--current');

    let priceMain = document.createElement('span');
    priceMain.className = 'hero-price-main';
    let currencySpan = document.createElement('span');
    currencySpan.className = 'currency';
    currencySpan.textContent = currencyNode ? String(currencyNode.textContent || '').trim() : '₹';
    let amountSpan = document.createElement('span');
    amountSpan.className = 'price-amount';
    amountSpan.textContent = amountNode ? String(amountNode.textContent || '').trim() : '';
    priceMain.appendChild(currencySpan);
    priceMain.appendChild(amountSpan);
    priceSpan.appendChild(priceMain);

    let compareNode = card.querySelector('.card-compare-price, .product-price__compare');
    let compareText = compareNode ? String(compareNode.textContent || '').trim() : '';
    if (compareText) {
      let compareSpan = document.createElement('span');
      compareSpan.className = 'hero-compare-price';
      compareSpan.textContent = compareText;
      priceSpan.appendChild(compareSpan);
    }

    let discountNode = card.querySelector('.card-discount, .CT_parsent_off_');
    let discountText = discountNode ? String(discountNode.textContent || '').trim() : '';
    if (discountText) {
      let discountSpan = document.createElement('span');
      discountSpan.className = 'hero-discount';
      discountSpan.textContent = discountText;
      priceSpan.appendChild(discountSpan);
    }

    caption.appendChild(priceSpan);
    stack.appendChild(caption);

    // Sibling of the image wrap, never a child — the wrap is a fixed-ratio box
    // with overflow: hidden, which on desktop clipped the caption away entirely
    // (snippets/product-hero-block.liquid keeps the same shape).
    //
    // Placed against the wrap's own parent, not against `card`: on the JSON
    // fallback card the image box is nested inside .block-inner, so
    // card.insertBefore(stack, wrap.nextSibling) threw NotFoundError — the
    // reference node was not a child of card — which killed the whole grid
    // re-render mid-flight.
    wrap.insertAdjacentElement('afterend', stack);

    if (info && info.parentNode) info.parentNode.removeChild(info);
    card.classList.add('product-hero-card');

    return holder.innerHTML;
  }

  function normalizeCdnUrl(url) {
    let u = String(url || '').trim();
    if (!u || u === '[object Object]') return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u;
  }

  // Do two URLs point at the same absolute address? Used to avoid reassigning
  // an <img> src to the value it effectively already has. The forms differ
  // ("/cdn/shop/...", "//host/cdn/shop/...", "https://host/cdn/shop/...") while
  // resolving identically, and a redundant assignment is not free: it aborts
  // the in-flight request and re-downloads the same file.
  function isSameResolvedUrl(a, b) {
    let x = String(a || '').trim();
    let y = String(b || '').trim();
    if (!x || !y) return false;
    if (x === y) return true;
    try {
      return new URL(x, window.location.href).href === new URL(y, window.location.href).href;
    } catch (e) {
      return false;
    }
  }

  function isPlaceholderOrEmptySrc(src) {
    let current = String(src || '').trim();
    return (
      !current ||
      current.indexOf('data:image') === 0 ||
      current === IMG_PLACEHOLDER_PIXEL
    );
  }

  // Force real product photo URLs into card HTML before insert.
  // Fixes flash-then-blank: SSR looks fine, then JSON re-render blanks imgs.
  function ensureCardHtmlHasImages(cardHtml, product) {
    let html = String(cardHtml || '');
    if (!html) return html;

    let holder = document.createElement('div');
    holder.innerHTML = html;
    let card = holder.querySelector('.product-block[data-product-id], .CT_product-block[data-product-id]');
    let fallback = normalizeCdnUrl(product && product.featured_image);
    if (card) {
      let fromData = normalizeCdnUrl(
        card.getAttribute('data-imageUrl') || card.getAttribute('data-imageurl') || ''
      );
      if (fromData) fallback = fromData;
    }
    if (!fallback) return html;

    let newImgs = holder.querySelectorAll('.card-slider-track .product-img, img.product-img');
    if (newImgs.length) {
      newImgs.forEach(function (img, idx) {
        let slide = normalizeCdnUrl(img.getAttribute('data-slide-src') || img.getAttribute('src'));
        let next = slide || fallback;
        if (!next) return;
        img.setAttribute('src', next);
        img.setAttribute('data-slide-src', next);
        img.removeAttribute('data-k-src');
        img.removeAttribute('data-k-srcset');
        img.classList.remove('k-plp-img-deferred');
        if (idx === 0) img.classList.add('active');
      });
      return holder.innerHTML;
    }

    let primary =
      holder.querySelector('.product-block__image--primary img, .product-block__image--active img') ||
      holder.querySelector('.image-cont img.rimage__image, .image-cont img:not(.wishlist_blank_icon):not(.wishlist_fill_icon):not(.wish_uncheck):not(.wish_fill)');
    if (primary) {
      if (isPlaceholderOrEmptySrc(primary.getAttribute('src'))) {
        primary.setAttribute('src', fallback);
        primary.removeAttribute('srcset');
      }
      primary.removeAttribute('data-k-src');
      primary.removeAttribute('data-k-srcset');
      primary.classList.remove('k-plp-img-deferred');
    }
    return holder.innerHTML;
  }

  function prepareCardHtmlForDeferredImages(cardHtml, shouldDefer) {
    let html = String(cardHtml || '');
    if (!html) return html;

    let holder = document.createElement('div');
    holder.innerHTML = html;
    // Keep real srcs to avoid blank-card regressions. Native lazy loading keeps
    // offscreen cards from competing with the first four visible product photos.
    let cardImages = holder.querySelectorAll('.product-img');
    if (cardImages.length) {
      cardImages.forEach(function (img, index) {
        let eager = index === 0 && !shouldDefer;
        img.setAttribute('loading', eager ? 'eager' : 'lazy');
        img.setAttribute('fetchpriority', eager ? 'high' : 'auto');
      });
      return holder.innerHTML;
    }
    if (!shouldDefer) return html;
    let imgs = holder.querySelectorAll('.product-block__image img');
    imgs.forEach(function (img) {
      if (
        img.closest(
          '.product-block__image--active, .product-block__image--primary, .product-block__image[data-slide-index="0"], .product-block__image[data-image-index="0"]'
        )
      ) {
        return;
      }
      let src = String(img.getAttribute('src') || '').trim();
      let srcset = String(img.getAttribute('srcset') || '').trim();
      if (src) img.setAttribute('data-k-src', src);
      if (srcset) img.setAttribute('data-k-srcset', srcset);
      img.setAttribute('src', IMG_PLACEHOLDER_PIXEL);
      img.removeAttribute('srcset');
      img.setAttribute('loading', 'lazy');
      img.classList.add('k-plp-img-deferred');
    });
    return holder.innerHTML;
  }

  function repairNewCardImages(scope) {
    let rootEl = scope && scope.querySelectorAll ? scope : nodes.list;
    if (!rootEl) return;
    let cards = rootEl.querySelectorAll
      ? rootEl.querySelectorAll('.product-block[data-product-id]')
      : [];
    if (!cards.length && rootEl.getAttribute && rootEl.getAttribute('data-product-id')) {
      cards = [rootEl];
    }

    cards.forEach(function (card) {
      let product = getProductByIdFromState(card.getAttribute('data-product-id'));
      let fallback = normalizeCdnUrl(product && product.featured_image);
      if (!fallback) {
        fallback = normalizeCdnUrl(
          card.getAttribute('data-imageUrl') || card.getAttribute('data-imageurl') || ''
        );
      }
      if (!fallback) {
        let wishImg = card.querySelector('.wishlist_img_main[data-prod-featured-image]');
        if (wishImg) {
          fallback = normalizeCdnUrl(wishImg.getAttribute('data-prod-featured-image') || '');
        }
      }

      let track = card.querySelector('.card-slider-track, .image-label-wrap, .image-cont');
      let imgs = card.querySelectorAll('.card-slider-track .product-img, .image-cont img.product-img');

      // If new-card markup has no usable product images, inject one from featured_image
      if ((!imgs || !imgs.length) && fallback && track) {
        let injected = document.createElement('img');
        injected.className = 'product-img active';
        injected.setAttribute('src', fallback);
        injected.setAttribute('data-slide-src', fallback);
        injected.setAttribute('alt', String(card.getAttribute('data-product') || 'Product'));
        injected.setAttribute('width', '180');
        injected.setAttribute('height', '220');
        injected.setAttribute('loading', 'eager');
        let sliderTrack = card.querySelector('.card-slider-track') || track;
        sliderTrack.insertBefore(injected, sliderTrack.firstChild);
        imgs = card.querySelectorAll('.card-slider-track .product-img, .image-cont img.product-img');
      }

      if (!imgs || !imgs.length) {
        // Legacy rimage cards: always restore a real primary src
        let primary =
          card.querySelector('.product-block__image--primary img, .product-block__image--active img') ||
          card.querySelector(
            '.image-cont img.rimage__image, .product-block__image img, .image-cont img:not(.wishlist_blank_icon):not(.wishlist_fill_icon):not(.wish_uncheck):not(.wish_fill)'
          );
        if (primary && fallback && isPlaceholderOrEmptySrc(primary.getAttribute('src'))) {
          primary.setAttribute('src', fallback);
          primary.removeAttribute('srcset');
          primary.removeAttribute('data-k-src');
          primary.classList.remove('k-plp-img-deferred');
        }
        // Also heal any deferred primary that still has data-k-src
        card.querySelectorAll('.product-block__image--primary img[data-k-src], .product-block__image--active img[data-k-src]').forEach(function (img) {
          let real = normalizeCdnUrl(img.getAttribute('data-k-src'));
          if (real) {
            img.setAttribute('src', real);
            img.removeAttribute('data-k-src');
            img.classList.remove('k-plp-img-deferred');
          } else if (fallback) {
            img.setAttribute('src', fallback);
          }
        });
        return;
      }

      let hasVisible = false;

      // Slide 0 is the default visible slide, but NOT when something has already
      // promoted another one. applyPreferredVariantToNewCard() marks the slide
      // matching an active Colour / Polish / Near-store filter .active, and this
      // pass runs after it — forcing 0 on top left two slides carrying .active
      // and the default photo back on screen, which is exactly the bug the
      // variant swap is there to fix. An untouched card still lands on 0,
      // because snippets/product-block.liquid ships .active on its first image.
      let preselectedIndex = -1;
      for (let a = 0; a < imgs.length; a += 1) {
        if (imgs[a].classList.contains('active')) {
          preselectedIndex = a;
          break;
        }
      }
      let visibleIndex = preselectedIndex >= 0 ? preselectedIndex : 0;

      imgs.forEach(function (img, idx) {
        let slideSrc = normalizeCdnUrl(img.getAttribute('data-slide-src') || '');
        let current = String(img.getAttribute('src') || '').trim();
        if (isPlaceholderOrEmptySrc(current) || idx === 0) {
          let nextSrc = slideSrc || fallback;
          // Always force first slide to a known-good URL after re-render
          if (idx === 0 && fallback) nextSrc = slideSrc || fallback;
          // ...but only when it would actually change the image. idx === 0 runs
          // this branch unconditionally, so without this guard every card's
          // first slide was reassigned an equivalent URL on each pass, aborting
          // the in-flight request (one net::ERR_ABORTED per card, 50 on a full
          // page) and re-downloading the same file. On a slow connection the
          // abort is what leaves a broken-image icon in the grid.
          if (nextSrc && isSameResolvedUrl(nextSrc, current)) nextSrc = '';
          if (nextSrc) {
            img.setAttribute('src', nextSrc);
            img.setAttribute('data-slide-src', nextSrc);
            img.removeAttribute('data-k-src');
            img.classList.remove('k-plp-img-deferred');
          }
        }
        if (idx === visibleIndex) {
          img.classList.add('active');
          hasVisible = true;
        } else {
          img.classList.remove('active');
        }
      });
      if (!hasVisible && imgs[0]) imgs[0].classList.add('active');
    });
  }

  function disconnectObserver() {
    if (state.observer) {
      state.observer.disconnect();
      state.observer = null;
    }
  }

  function unbindPaginationFallback() {
    if (state.paginationFallbackTimer) {
      window.clearInterval(state.paginationFallbackTimer);
      state.paginationFallbackTimer = null;
    }
    if (!state.paginationFallbackBound || !state.paginationFallbackHandler) return;
    state.paginationFallbackBound = false;
    state.paginationFallbackHandler = null;
  }

  async function triggerPaginationLoad(source) {
    if (state.paginationLoadInProgress) return;
    if (state.filtered.length <= state.page * state.perPage) {
      if (!state.fullHydrated) {
        root.classList.add('k-pagination-loading');
        showPaginationSkeleton();
        try {
          let hydrated = await hydrateRemainingProductsOnDemand('pagination');
          if (!hydrated) return;
          let next = [];
          if (Array.isArray(state.products)) {
            for (let i = 0; i < state.products.length; i += 1) {
              if (matchesProduct(state.products[i], state.active, state.priceRange)) next.push(state.products[i]);
            }
          }
          state.filtered = sortProducts(next);
          // If hydration produced more results than current page view,
          // continue this same trigger cycle and append immediately.
          if (state.filtered.length <= state.page * state.perPage) {
            renderPagination();
            return;
          }
        } catch (error) {
          console.error('[kushal-fast-filter] pagination hydration failed', error);
          return;
        } finally {
          root.classList.remove('k-pagination-loading');
          hidePaginationSkeleton();
        }
      } else {
      }
      if (state.filtered.length <= state.page * state.perPage) return;
    }

    root.classList.add('k-pagination-loading');
    forceHideNoMatches('pagination-start');
    state.paginationLoadInProgress = true;
    showPaginationSkeleton();
    let skeletonShownAt = Date.now();

    try {
      await waitForNextPaint();
      state.page += 1;
      let previousVisibleCount = Math.max(0, (state.page - 1) * state.perPage);

      // Remove current shimmer placeholders before appending real cards.
      hidePaginationSkeleton();

      // Append products immediately from already hydrated dataset.
      renderProductsOnly({ append: true, startIndex: previousVisibleCount });
    } finally {
      let elapsed = Date.now() - skeletonShownAt;
      if (elapsed < PAGINATION_SKELETON_MIN_VISIBLE_MS) {
        await waitMs(PAGINATION_SKELETON_MIN_VISIBLE_MS - elapsed);
      }
      state.paginationLoadInProgress = false;
      root.classList.remove('k-pagination-loading');
      updateNoMatchesVisibility({ source: source || 'pagination-end' });

      window.setTimeout(function () {
        runExplicitUiSync('pagination-append');
      }, 0);
    }
  }

  function bindPaginationFallback() {
    unbindPaginationFallback();
    state.paginationFallbackHandler = function () {
      if (state.paginationLoadInProgress) return;
      if (state.filtered.length <= state.page * state.perPage) return;
      let viewportH = window.innerHeight || document.documentElement.clientHeight || 0;
      let skeletonNode = nodes.list ? nodes.list.querySelector('.ct-page-load-skeleton') : null;
      let shimmerInView = false;
      if (skeletonNode) {
        let rect = skeletonNode.getBoundingClientRect();
        shimmerInView = rect.top <= (viewportH - 12) && rect.bottom >= 12;
      }
      if (shimmerInView) {
        triggerPaginationLoad('pagination-fallback-timer');
      }
    };
    state.paginationFallbackTimer = window.setInterval(state.paginationFallbackHandler, 450);
    state.paginationFallbackBound = true;
  }

  function renderPagination() {
    if (!nodes.pagination) return;
    disconnectObserver();
    unbindPaginationFallback();
    let hasMore = state.filtered.length > state.page * state.perPage;
    if (!hasMore) {
      if (!state.fullHydrated) {
        nodes.pagination.innerHTML = '';
        showPaginationSkeleton();
        bindPaginationFallback();
        let skeletonTargetPending = nodes.list ? nodes.list.querySelector('.ct-page-load-skeleton') : null;
        if (skeletonTargetPending && window.IntersectionObserver) {
          state.observer = new IntersectionObserver(function (entries) {
            let entry = entries[0];
            if (!entry || !entry.isIntersecting) return;
            triggerPaginationLoad('pagination-hydrate-observer');
          }, { root: null, rootMargin: '0px', threshold: 0.01 });
          state.observer.observe(skeletonTargetPending);
        }
        return;
      }
      nodes.pagination.innerHTML = '';
      hidePaginationSkeleton();
      updateNoMatchesVisibility({ source: 'pagination-no-more' });
      return;
    }
    nodes.pagination.innerHTML = '';
    showPaginationSkeleton();
    // Keep lightweight fallback active even when IO exists.
    bindPaginationFallback();

    let skeletonTarget = nodes.list ? nodes.list.querySelector('.ct-page-load-skeleton') : null;
    if (!skeletonTarget) return;
    if (!window.IntersectionObserver) {
      return;
    }

    state.observer = new IntersectionObserver(function (entries) {
      let entry = entries[0];
      if (!entry || !entry.isIntersecting) return;
      triggerPaginationLoad('pagination-skeleton-observer');
    }, { root: null, rootMargin: '0px', threshold: 0.01 });
    state.observer.observe(skeletonTarget);
  }

  function resetAndRebindPagination(source) {
    disconnectObserver();
    unbindPaginationFallback();
    state.paginationLoadInProgress = false;
    hidePaginationSkeleton();
    forceHideNoMatches('pagination-reset');
    root.classList.remove('k-pagination-loading');
    renderPagination();
  }

  function renderCount() {
    if (state.loading || !state.countsAreFinal) return;
    let text = state.filtered.length + ' Products found';
    let dynamicTargets = root.querySelectorAll('.js-filter-product-count, .CT_fil_utility-bar__centre span, .ct_utility-bar__centre span');
    nodes.countTargets = dynamicTargets && dynamicTargets.length ? dynamicTargets : nodes.countTargets;
    nodes.countTargets.forEach(function (node) {
      node.textContent = text;
    });
  }

  function ensureNoMatchesNode() {
    if (nodes.noMatches && root.contains(nodes.noMatches)) return nodes.noMatches;

    let existing = root.querySelector('#kushal-filter-no-matches');
    if (existing) {
      existing.hidden = true;
      existing.setAttribute('aria-hidden', 'true');
      existing.style.display = 'none';
      existing.classList.add('k-no-matches-message');
      nodes.noMatches = existing;
      return nodes.noMatches;
    }

    if (!nodes.list || !nodes.list.parentNode) return null;

    let emptyNode = document.createElement('h5');
    emptyNode.id = 'kushal-filter-no-matches';
    emptyNode.className = 'align-centre fully-spaced-row k-no-matches-message';
    emptyNode.textContent = 'Sorry, there are no products in this collection';
    emptyNode.hidden = true;
    emptyNode.setAttribute('aria-hidden', 'true');
    emptyNode.style.display = 'none';

    if (nodes.list.nextSibling) {
      nodes.list.parentNode.insertBefore(emptyNode, nodes.list.nextSibling);
    } else {
      nodes.list.parentNode.appendChild(emptyNode);
    }

    nodes.noMatches = emptyNode;
    return nodes.noMatches;
  }

  function forceHideNoMatches(source) {
    let noMatchesNode = ensureNoMatchesNode();
    if (!noMatchesNode) return;
    noMatchesNode.hidden = true;
    noMatchesNode.setAttribute('aria-hidden', 'true');
    noMatchesNode.style.display = 'none';
  }

  function updateNoMatchesVisibility(context) {
    let noMatchesNode = ensureNoMatchesNode();
    if (!noMatchesNode) return;

    let hasRootGuard =
      root.classList.contains('k-pagination-loading') ||
      root.classList.contains('k-custom-rendering');
    let hasRenderedProducts = !!(nodes.list && nodes.list.querySelector('.product-block[data-product-id]'));
    let isBusy =
      !!state.loading ||
      !!state.paginationLoadInProgress ||
      !!state.paginationSkeletonActive ||
      !!state.startupSkeletonActive ||
      hasRootGuard;

    if (isBusy) {
      forceHideNoMatches((context && context.source) || 'busy');
      return;
    }

    let shouldShow =
      !!state.loaded &&
      !isBusy &&
      !hasRenderedProducts &&
      Array.isArray(state.filtered) &&
      state.filtered.length === 0;

    if (shouldShow) {
      noMatchesNode.hidden = false;
      noMatchesNode.setAttribute('aria-hidden', 'false');
      noMatchesNode.style.display = '';
      return;
    }

    forceHideNoMatches((context && context.source) || 'hide');
  }

  function getBreakerTemplateHtml() {
    if (state.breakerTemplateHtml) return state.breakerTemplateHtml;
    if (!nodes.list) return '';

    function cleanupBreakerNode(node) {
      if (!node) return '';
      let clone = node.cloneNode(true);
      normalizeNearStoreLabelsInContainer(clone);
      let scripts = clone.querySelectorAll('script');
      scripts.forEach(function (script) {
        script.remove();
      });
      return clone.outerHTML || '';
    }

    function extractFromHtml(rawHtml) {
      let html = String(rawHtml || '').trim();
      if (!html) return '';
      let holder = document.createElement('div');
      holder.innerHTML = html;
      let node = holder.querySelector('.breaker_filter-main');
      return cleanupBreakerNode(node);
    }

    let breaker = nodes.list.querySelector('.breaker_filter-main');
    if (breaker) {
      state.breakerTemplateHtml = cleanupBreakerNode(breaker);
      return state.breakerTemplateHtml;
    }

    if (state.startupSkeletonBackupHtml) {
      let backupTemplate = extractFromHtml(state.startupSkeletonBackupHtml);
      if (backupTemplate) {
        state.breakerTemplateHtml = backupTemplate;
        return state.breakerTemplateHtml;
      }
    }

    let fallbackBreaker = root.querySelector('.breaker_filter-main');
    if (fallbackBreaker) {
      state.breakerTemplateHtml = cleanupBreakerNode(fallbackBreaker);
      return state.breakerTemplateHtml;
    }

    return state.breakerTemplateHtml;
  }

  function getCollectionAppBannerTemplateHtml() {
    if (state.appBannerTemplateHtml) return state.appBannerTemplateHtml;

    function cleanupBannerNode(node) {
      if (!node) return '';
      let clone = node.cloneNode(true);
      let scripts = clone.querySelectorAll('script');
      scripts.forEach(function (script) {
        script.remove();
      });
      return clone.outerHTML || '';
    }

    function updateBannerInsertPositionFromNode(node) {
      if (!node) return;
      let count = 0;
      let cursor = node.previousElementSibling;
      while (cursor) {
        if (cursor.hasAttribute && cursor.hasAttribute('data-product-id')) count += 1;
        cursor = cursor.previousElementSibling;
      }
      if (count > 0) state.appBannerInsertAfter = count;
    }

    function extractFromHtml(rawHtml) {
      let html = String(rawHtml || '').trim();
      if (!html) return '';
      let holder = document.createElement('div');
      holder.innerHTML = html;
      let node = holder.querySelector('.collection-app-banner, .app-download-banner-inner');
      if (!node) return '';
      updateBannerInsertPositionFromNode(node);
      return cleanupBannerNode(node);
    }

    let banner = nodes.list
      ? nodes.list.querySelector('.collection-app-banner, .app-download-banner-inner')
      : null;
    if (banner) {
      updateBannerInsertPositionFromNode(banner);
      state.appBannerTemplateHtml = cleanupBannerNode(banner);
      return state.appBannerTemplateHtml;
    }

    if (state.startupSkeletonBackupHtml) {
      let backupTemplate = extractFromHtml(state.startupSkeletonBackupHtml);
      if (backupTemplate) {
        state.appBannerTemplateHtml = backupTemplate;
        return state.appBannerTemplateHtml;
      }
    }

    let fallbackBanner = root.querySelector('.collection-app-banner, .app-download-banner-inner');
    if (fallbackBanner) {
      updateBannerInsertPositionFromNode(fallbackBanner);
      state.appBannerTemplateHtml = cleanupBannerNode(fallbackBanner);
      return state.appBannerTemplateHtml;
    }

    return state.appBannerTemplateHtml;
  }

  // Grid slot, stamped at render time rather than trusted from the cached card.
  //
  // The card_html in the JSON payload carries whatever position the JSON view
  // baked in: templates/collection.json.liquid renders `current_position:
  // forloop.index` inside `paginate by 100` and hardcodes `current_page: 1`, so
  // data-currentposition is the product's index in the UNFILTERED collection and
  // it restarts at 1 every 100 products. This engine re-renders the grid in
  // filtered/sorted order, so that attribute stopped describing the slot the
  // customer actually saw — a hero in visible slot 7 reported 37.
  //
  // Two analytics readers take it straight, and both are fixed by stamping here
  // rather than by patching either one: slotPosition() behind "Viewed Product
  // Spotlight" / "Clicked Product Spotlight", and the "PLP Product Clicked"
  // handler, both in assets/clevertap_custom.js.liquid.
  //
  // DOM order IS grid order, so the nth card is slot n+1, and hero cards are
  // included because buildHeroCardHtml() ADDS .product-hero-card to the same
  // element rather than replacing .product-block.
  //
  // data-currentpage is pinned to '1' on purpose: it is what tells both readers
  // to use the position verbatim instead of adding the server pagination offset
  // (pinned + non-pinned counts + (page-2)*16), which has no meaning for a
  // client-rendered grid that already counts every card from the top.
  function stampGridSlotPositions() {
    if (!nodes.list || !nodes.list.querySelectorAll) return;
    let cards = nodes.list.querySelectorAll('.product-block[data-product-id]');
    for (let i = 0; i < cards.length; i += 1) {
      cards[i].setAttribute('data-currentposition', String(i + 1));
      cards[i].setAttribute('data-currentpage', '1');
    }
  }

  function renderProductsOnly(options) {
    let opts = options || {};
    let appendMode = !!opts.append;
    let startupProducts = opts.startupProducts;
    root.classList.add('k-custom-rendering');
    forceHideNoMatches('render-start');
    let endIndex = Math.min(state.filtered.length, state.page * state.perPage);
    let startIndex = appendMode ? Math.max(0, toNumber(opts.startIndex, 0)) : 0;
    let visible = startupProducts || state.filtered.slice(0, endIndex);
    let breakerHtml = getBreakerTemplateHtml();
    let appBannerHtml = getCollectionAppBannerTemplateHtml();
    let appBannerInserted = appendMode
      ? !!(nodes.list && nodes.list.querySelector('.collection-app-banner, .app-download-banner-inner'))
      : false;
    let appBannerInsertAfter = Math.max(1, toNumber(state.appBannerInsertAfter, 10) || 10);
    let html = '';
    // With heroes on, the run is 6 cards + hero + breaker, so the breaker moves
    // from every 6th product to straight after the hero — the server-rendered
    // rhythm. Heroes off leaves the old every-6-cards breaker untouched.
    let heroEvery = heroCardsEnabled ? HERO_SLOT_FREQUENCY : 0;
    let breakerEvery = heroEvery > 0 ? heroEvery : state.breakerFrequency;
    for (let i = startIndex; i < visible.length; i += 1) {
      let product = visible[i];
      let cardHtml = ensureCardHtmlHasImages(renderCard(product), product);
      if (heroEvery > 0 && (i + 1) % heroEvery === 0) {
        // Never let the hero take the grid with it: this runs inside the render
        // loop, so anything thrown here would abort the whole re-render and
        // leave the page showing its last server-rendered state — filters would
        // then only appear to work after a full refresh.
        try {
          cardHtml = buildHeroCardHtml(cardHtml);
        } catch (e) {
          // fall through with the ordinary card
        }
      }
      html += prepareCardHtmlForDeferredImages(cardHtml, i >= INITIAL_EAGER_CARD_IMAGE_COUNT);
      if (!appBannerInserted && appBannerHtml && (i + 1) === appBannerInsertAfter) {
        html += appBannerHtml;
        appBannerInserted = true;
      }
      if (breakerHtml && breakerEvery > 0 && (i + 1) % breakerEvery === 0) {
        html += breakerHtml;
      }
    }
    if (!appendMode && !appBannerInserted && appBannerHtml && visible.length) {
      html += appBannerHtml;
    }
    if (appendMode) {
      if (!html) {
        root.classList.remove('k-custom-rendering');
        forceHideNoMatches('append-empty');
        resetAndRebindPagination('append-empty');
        return;
      }
      let holder = document.createElement('div');
      holder.innerHTML = html;
      let appendedCards = holder.querySelectorAll('.product-block[data-product-id]');
      nodes.list.insertAdjacentHTML('beforeend', html);
      // Whole list, not just the appended tail: infinite scroll must keep one
      // continuous 1..N sequence across every page it has pulled in.
      stampGridSlotPositions();
      let appendedNodes = [];
      if (appendedCards && appendedCards.length) {
        let allCards = nodes.list.querySelectorAll('.product-block[data-product-id]');
        let appendedCount = appendedCards.length;
        let from = Math.max(0, allCards.length - appendedCount);
        for (let c = from; c < allCards.length; c += 1) {
          appendedNodes.push(allCards[c]);
        }
        setupProgressivePlpImagesForAppendedCards(appendedNodes, from);
        applyPreferredVariantStateToCards(appendedNodes);
        repairNewCardImages(nodes.list);
        showAppendedCardImageShimmers(appendedNodes);
      } else {
        setupProgressivePlpImages();
        applyPreferredVariantStateToCards();
        repairNewCardImages(nodes.list);
      }
      if (window.KProductCardSlider && typeof window.KProductCardSlider.init === 'function') {
        if (appendedCards && appendedCards.length) {
          let allCardsForSlider = nodes.list.querySelectorAll('.product-block[data-product-id]');
          let appendedCountForSlider = appendedCards.length;
          let fromForSlider = Math.max(0, allCardsForSlider.length - appendedCountForSlider);
          for (let s = fromForSlider; s < allCardsForSlider.length; s += 1) {
            window.KProductCardSlider.init(allCardsForSlider[s]);
          }
        } else {
          window.KProductCardSlider.init(nodes.list);
        }
      }
    } else {
      nodes.list.innerHTML = html;
      stampGridSlotPositions();
      setupProgressivePlpImages();
      applyPreferredVariantStateToCards();
      repairNewCardImages(nodes.list);
      if (window.KProductCardSlider && typeof window.KProductCardSlider.init === 'function') {
        window.KProductCardSlider.init(nodes.list);
      }
    }
    if (typeof window.setHrefForElements === 'function') {
      try {
        let resultUrl = window.AF_SMART_SCRIPT_RESULT && window.AF_SMART_SCRIPT_RESULT.clickURL
          ? window.AF_SMART_SCRIPT_RESULT.clickURL
          : null;
        window.setHrefForElements(resultUrl);
      } catch (e) {}
    }
    root.classList.remove('k-custom-rendering');
    if (!startupProducts) {
      updateNoMatchesVisibility({ source: appendMode ? 'append-render-end' : 'full-render-end' });
      resetAndRebindPagination(appendMode ? 'append-render-end' : 'full-render-end');
      renderCount();
    }
    if (typeof window.updateHeaderStickyForScrollState === 'function') {
      window.updateHeaderStickyForScrollState();
    }
    // Re-apply wishlist + repair images after every PLP re-render
    repairNewCardImages(nodes.list);
    if (typeof window.checkVisibilityAndCallAPI === 'function') {
      try {
        window.checkVisibilityAndCallAPI();
      } catch (e) {}
    }
  }

  function disconnectProgressiveImageObserver() {
    if (state.progressiveImageObserver) {
      state.progressiveImageObserver.disconnect();
      state.progressiveImageObserver = null;
    }
  }

  function loadDeferredImage(img) {
    if (!img) return;
    let realSrc = String(img.getAttribute('data-k-src') || '').trim();
    let realSrcset = String(img.getAttribute('data-k-srcset') || '').trim();
    if (realSrc) img.setAttribute('src', realSrc);
    if (realSrcset) img.setAttribute('srcset', realSrcset);
    img.removeAttribute('data-k-src');
    img.removeAttribute('data-k-srcset');
    img.classList.remove('k-plp-img-deferred');
    img.classList.add('k-plp-img-revealed');
  }

  function revealCardDeferredImages(card) {
    if (!card) return;
    let imgs = card.querySelectorAll('img[data-k-src], img[data-k-srcset]');
    imgs.forEach(function (img) {
      loadDeferredImage(img);
    });
  }

  function deferCardImages(card) {
    if (!card) return;
    if (card.getAttribute('data-k-img-init') === '1') return;
    // Never blank primary/new-card photos — that caused flash-then-broken PLP images.
    if (card.querySelector('.product-img, .card-slider-track')) {
      card.setAttribute('data-k-img-init', '1');
      return;
    }
    let imgs = card.querySelectorAll(
      '.product-block__image--secondary img, .product-block__image.product-block__image--inactivated img'
    );
    imgs.forEach(function (img) {
      if (img.closest('.product-block__image--primary, .product-block__image--active')) return;
      let src = String(img.getAttribute('src') || '').trim();
      let srcset = String(img.getAttribute('srcset') || '').trim();
      if (isPlaceholderOrEmptySrc(src)) return;
      if (src) img.setAttribute('data-k-src', src);
      if (srcset) img.setAttribute('data-k-srcset', srcset);
      img.setAttribute('src', IMG_PLACEHOLDER_PIXEL);
      img.removeAttribute('srcset');
      img.setAttribute('loading', 'lazy');
      img.classList.add('k-plp-img-deferred');
    });
    card.setAttribute('data-k-img-init', '1');
  }

  function revealDeferredImagesByViewport() {
    if (!nodes.list) return;
    let cards = nodes.list.querySelectorAll('.CT_product-block.product-block[data-product-id]');
    cards.forEach(function (card, index) {
      if (index < INITIAL_EAGER_CARD_IMAGE_COUNT) {
        revealCardDeferredImages(card);
      }
    });
  }

  function bindProgressiveImageInteractionFallback() {
    if (state.progressiveImageInteractionBound) return;
    state.progressiveImageInteractionBound = true;
    let revealOnInteraction = function () {
      let hiddenCards = nodes.list
        ? nodes.list.querySelectorAll('.CT_product-block.product-block[data-product-id] img[data-k-src], .CT_product-block.product-block[data-product-id] img[data-k-srcset]')
        : [];
      let remaining = 0;
      for (let i = 0; i < hiddenCards.length; i += 1) {
        let img = hiddenCards[i];
        loadDeferredImage(img);
        remaining += 1;
        if (remaining >= 8) break;
      }
    };
    window.addEventListener('scroll', revealOnInteraction, { passive: true });
    window.addEventListener('touchstart', revealOnInteraction, { passive: true });
    window.addEventListener('mousemove', revealOnInteraction, { passive: true });
  }

  function setupProgressivePlpImages() {
    if (!nodes.list) return;
    disconnectProgressiveImageObserver();
    let cards = nodes.list.querySelectorAll('.CT_product-block.product-block[data-product-id]');
    if (!cards.length) return;

    cards.forEach(function (card, index) {
      if (card.getAttribute('data-k-img-init') === '1') return;
      if (index < INITIAL_EAGER_CARD_IMAGE_COUNT) {
        revealCardDeferredImages(card);
        card.setAttribute('data-k-img-init', '1');
        return;
      }
      deferCardImages(card);
    });

    revealDeferredImagesByViewport();
    bindProgressiveImageInteractionFallback();

    if (!window.IntersectionObserver) return;
    state.progressiveImageObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        revealCardDeferredImages(entry.target);
        if (state.progressiveImageObserver) state.progressiveImageObserver.unobserve(entry.target);
      });
    }, {
      root: null,
      rootMargin: '220px 0px',
      threshold: 0.01,
    });

    cards.forEach(function (card, index) {
      if (index < INITIAL_EAGER_CARD_IMAGE_COUNT) return;
      if (!card.querySelector('img[data-k-src], img[data-k-srcset]')) return;
      state.progressiveImageObserver.observe(card);
    });
  }

  function setupProgressivePlpImagesForAppendedCards(appendedCards, startIndex) {
    if (!Array.isArray(appendedCards) || !appendedCards.length) return;
    let baseIndex = Math.max(0, toNumber(startIndex, 0));

    appendedCards.forEach(function (card, offset) {
      if (!card || card.getAttribute('data-k-img-init') === '1') return;
      let globalIndex = baseIndex + offset;
      if (globalIndex < INITIAL_EAGER_CARD_IMAGE_COUNT || offset < APPEND_EAGER_CARD_IMAGE_COUNT) {
        revealCardDeferredImages(card);
        card.setAttribute('data-k-img-init', '1');
        return;
      }
      deferCardImages(card);
    });

    bindProgressiveImageInteractionFallback();
    if (!window.IntersectionObserver || !state.progressiveImageObserver) return;
    appendedCards.forEach(function (card) {
      if (!card || !card.querySelector) return;
      if (!card.querySelector('img[data-k-src], img[data-k-srcset]')) return;
      state.progressiveImageObserver.observe(card);
    });
  }

  // Newly appended cards can render before their first product photo has arrived.
  function showAppendedCardImageShimmers(appendedCards) {
    if (!Array.isArray(appendedCards)) return;
    appendedCards.forEach(function (card) {
      if (!card || !card.querySelector) return;
      let image = card.querySelector(
        '.product-block__image--active img, .product-block__image--primary img, .card-slider-track img.product-img, .image-cont img.product-img, .image-cont img.rimage__image'
      );
      if (!image) return;
      let wrapper = image.closest('.product-block__image, .image-cont, .card-slider-track');
      if (!wrapper) return;
      wrapper.classList.add('k-plp-image-loading');
      let finish = function () {
        wrapper.classList.remove('k-plp-image-loading');
        image.removeEventListener('load', finish);
        image.removeEventListener('error', finish);
      };
      if (image.complete && image.naturalWidth > 0) {
        finish();
      } else {
        image.addEventListener('load', finish, { once: true });
        image.addEventListener('error', finish, { once: true });
      }
    });
  }

  function cloneActive(active) {
    let copy = {};
    Object.keys(active).forEach(function (k) {
      copy[k] = (active[k] || []).slice();
    });
    return copy;
  }

  function cloneSelectionSourceMap(map) {
    let source = map || {};
    let copy = {};
    Object.keys(source).forEach(function (key) {
      if (!key) return;
      if (source[key] !== 'plp' && source[key] !== 'filter') return;
      copy[key] = source[key];
    });
    return copy;
  }

  function normalizeTokenSet(list) {
    let arr = Array.isArray(list) ? list.slice() : [];
    arr = arr.filter(function (token) { return !!token; }).map(function (token) { return String(token); });
    arr.sort();
    return arr;
  }

  function areTokenSetsEqual(a, b) {
    let left = normalizeTokenSet(a);
    let right = normalizeTokenSet(b);
    if (left.length !== right.length) return false;
    for (let i = 0; i < left.length; i += 1) {
      if (left[i] !== right[i]) return false;
    }
    return true;
  }

  function areActiveStatesEqual(leftState, rightState) {
    let left = leftState || {};
    let right = rightState || {};
    let keys = {};

    Object.keys(left).forEach(function (key) { keys[key] = true; });
    Object.keys(right).forEach(function (key) { keys[key] = true; });

    let keyList = Object.keys(keys);
    for (let i = 0; i < keyList.length; i += 1) {
      let key = keyList[i];
      if (!areTokenSetsEqual(left[key] || [], right[key] || [])) return false;
    }
    return true;
  }

  function arePriceRangesEqual(left, right) {
    let l = left || null;
    let r = right || null;
    if (!l && !r) return true;
    if (!l || !r) return false;
    return toNumber(l.min, null) === toNumber(r.min, null) && toNumber(l.max, null) === toNumber(r.max, null);
  }

  function updatePlpMainOptionCount(input, count) {
    if (!input) return;
    let li = input.closest('.plp_filter_main li');
    if (!li) return;

    let textNode = li.querySelector('.default_filter-group__item__text, .filter-group__item__text');
    if (!textNode) return;

    let baseLabel = String(textNode.dataset.baseLabel || '').trim();
    if (!baseLabel) {
      baseLabel = deriveOptionLabel(input);
      if (!baseLabel) return;
      textNode.dataset.baseLabel = baseLabel;
    }

    // Chip strip is label-only in the redesign (Figma: plp/iPhone 13 & 14 - 30).
    // The count still decides whether a chip is shown or disabled at the call
    // site; it is simply no longer printed. Left as an assignment so a stale
    // "Label (12)" in cached server HTML is cleaned up on the first recount.
    textNode.textContent = baseLabel;
  }

  function getFilterItemLabelNode(item) {
    if (!item) return null;
    return (
      item.querySelector('.default_filter-group__item__text') ||
      item.querySelector('.ct-filter-name') ||
      item.querySelector('.filter-group__item__text:not(.ct-filter-count)') ||
      item.querySelector('.filter-group__item__text')
    );
  }

  function getFilterItemBaseLabel(input, item) {
    let labelNode = getFilterItemLabelNode(item);
    if (!labelNode) return '';

    let baseLabel = String(labelNode.dataset.baseLabel || '').trim();
    if (!baseLabel) {
      let text = String(labelNode.textContent || '').trim();
      baseLabel = text
        .replace(/\(\s*Products?\s+Available\s*\d+\s*\)/gi, '')
        .replace(/\(\s*\d+\s*\)/g, '')
        .trim();
      if (!baseLabel) baseLabel = deriveOptionLabel(input);
      if (!baseLabel) baseLabel = String(input && input.value ? input.value : '').trim();
      labelNode.dataset.baseLabel = baseLabel;
    }

    return baseLabel;
  }

  function updateFilterOptionCountDisplay(input, count) {
    if (!input) return;
    let item = input.closest('.filter-group__item');
    if (!item) return;

    let numericCount = toNumber(count, 0);
    let countBadge = item.querySelector('.ct-filter-count');
    if (countBadge) countBadge.textContent = String(numericCount);

    let countNodes = item.querySelectorAll('.filter-group__item__count');
    countNodes.forEach(function (node) {
      if (!node) return;
      if (node.classList.contains('ct-filter-name')) return;
      node.textContent = '(' + numericCount + ')';
    });

    if (isNearStoreInput(input)) return;

    let labelNode = getFilterItemLabelNode(item);
    if (!labelNode) return;
    let baseLabel = getFilterItemBaseLabel(input, item);
    if (!baseLabel) return;

    let hasDedicatedCount = !!countBadge || Array.prototype.some.call(countNodes, function (node) {
      return node && !node.classList.contains('ct-filter-name');
    });

    if (hasDedicatedCount) {
      labelNode.textContent = baseLabel;
      return;
    }

    let hasInlineCount =
      labelNode.dataset.inlineCount === '1' ||
      /\(\s*\d+\s*\)\s*$/.test(String(labelNode.textContent || ''));
    if (hasInlineCount) {
      labelNode.dataset.inlineCount = '1';
      labelNode.textContent = baseLabel + ' (' + numericCount + ')';
    }
  }

  function getActiveStateFromInputs() {
    let active = {};
    getAllFilterInputs().forEach(function (input) {
      if (!input.checked) return;
      if (!input.name || input.name === 'sort_by') return;
      let key = mapNameToKey(input.name, input);
      if (!key || key.indexOf('__') === 0) return;
      let token = deriveToken(input);
      if (!token) return;
      if (!active[key]) active[key] = [];
      if (active[key].indexOf(token) === -1) active[key].push(token);
    });

    let price = null;
    let p = getPriceInputs();
    let minVal = p.minInput ? String(p.minInput.value || '').trim() : '';
    let maxVal = p.maxInput ? String(p.maxInput.value || '').trim() : '';
    let min = minVal === '' ? null : toNumber(minVal, null);
    let max = maxVal === '' ? null : toNumber(maxVal, null);
    if (min != null || max != null) {
      price = { min: min, max: max };
    }

    return { active: active, price: price };
  }

  function getActiveStateFromContainer(container) {
    let active = {};
    if (!container || !container.querySelectorAll) return { active: active, price: null };

    container.querySelectorAll('input[type="checkbox"], input[type="radio"]').forEach(function (input) {
      if (!input || !input.checked) return;
      if (!input.name || input.name === 'sort_by') return;
      if (!input.classList.contains('filter-group__checkbox') && !input.classList.contains('breaker_filter-group__checkbox')) return;
      let key = mapNameToKey(input.name, input);
      if (!key || key.indexOf('__') === 0) return;
      let token = deriveToken(input);
      if (!token) return;
      if (!active[key]) active[key] = [];
      if (active[key].indexOf(token) === -1) active[key].push(token);
    });

    let minInput = container.querySelector('input.cc-price-range__input--min, input[name="filter.v.price.gte"], input[name="PriceFilterMin"]');
    let maxInput = container.querySelector('input.cc-price-range__input--max, input[name="filter.v.price.lte"], input[name="PriceFilterMax"]');
    let minVal = minInput ? String(minInput.value || '').trim() : '';
    let maxVal = maxInput ? String(maxInput.value || '').trim() : '';
    let min = minVal === '' ? null : toNumber(minVal, null);
    let max = maxVal === '' ? null : toNumber(maxVal, null);
    let price = null;
    if (min != null || max != null) price = { min: min, max: max };

    return { active: active, price: price };
  }

  function updateOptionVisibilityDebounced(activeOverride, priceOverride, scopeContainer) {
    if (state.updateOptionVisibilityTimerId) {
      clearTimeout(state.updateOptionVisibilityTimerId);    }    state.updateOptionVisibilityTimerId = setTimeout(function () {
      state.updateOptionVisibilityTimerId = null;      updateOptionVisibility(activeOverride, priceOverride, scopeContainer);
    }, 150);
  }

  function updateOptionVisibility(activeOverride, priceOverride, scopeContainer) {
    // Avoid zero-count/hidden filters while product hydration is still in progress.
    if (!state.loaded || !state.countsAreFinal || !Array.isArray(state.products) || !state.products.length) {      return;
    }
    let effectiveActive = activeOverride || state.active || {};
    let effectivePrice = priceOverride === undefined ? state.priceRange : priceOverride;

    let groups = {};
    let inputs = scopeContainer ? scopeContainer.querySelectorAll('input.filter-group__checkbox, input.breaker_filter-group__checkbox') : getAllFilterInputs();
    inputs.forEach(function (input) {
      if (!input || !input.name || input.name === 'sort_by') return;

      let key = mapNameToKey(input.name, input);
      if (!key || key.indexOf('__') === 0) return;
      let token = deriveToken(input);
      if (!token) return;

      if (!groups[key]) groups[key] = [];
      groups[key].push({ input: input, token: token });
    });

    Object.keys(groups).forEach(function (key) {
      let scopedActive = cloneActive(effectiveActive);
      delete scopedActive[key];

      let counts = {};
      for (let i = 0; i < state.products.length; i += 1) {
        let product = state.products[i];
        if (!matchesProduct(product, scopedActive, effectivePrice)) continue;

        let tokens = isVariantScopedKey(key)
          ? getStrictCountTokensForVariantKey(product, key, scopedActive)
          : getProductTokensForKey(product, key);
        for (let t = 0; t < tokens.length; t += 1) {
          let productToken = tokens[t];
          if (!productToken) continue;
          counts[productToken] = (counts[productToken] || 0) + 1;
        }
      }

      let hasNearbyStoresForLocation = key === 'nearstores' ? hasLocationStoreEntries() : true;
      let allowedCodes = key === 'nearstores' ? getLocationStoreShortCodeSet() : new Set();
      let nearRestrictionEnabled = key === 'nearstores' && hasNearbyStoresForLocation && allowedCodes.size > 0;

      groups[key].forEach(function (entry) {
        if (key === 'nearstores' && !hasNearbyStoresForLocation) {
          let nearItemNoStore = entry.input.closest('.filter-group__item');
          if (entry.input.checked) entry.input.checked = false;
          entry.input.disabled = true;
          if (nearItemNoStore) {
            nearItemNoStore.style.display = 'none';
            nearItemNoStore.classList.remove('filter-group__item--active');
          }
          return;
        }

        if (key === 'nearstores' && nearRestrictionEnabled) {
          let nearCode = getNearStoreCodeFromInput(entry.input);
          let nearItem = entry.input.closest('.filter-group__item');
          let isAllowed = isNearStoreAllowedByLocationStore(entry.input, allowedCodes);
          if (!nearCode || !isAllowed) {
            entry.input.checked = false;
            entry.input.disabled = true;
            if (nearItem) {
              nearItem.style.display = 'none';
              nearItem.classList.remove('filter-group__item--active');
            }
            return;
          }
        }

        let count = toNumber(counts[entry.token], 0);
        updatePlpMainOptionCount(entry.input, count);
        updateFilterOptionCountDisplay(entry.input, count);

        let item = entry.input.closest('.filter-group__item');
        let show = entry.input.checked || count > 0;
        if (item) item.style.display = show ? '' : 'none';
        if (item) item.classList.toggle('filter-group__item--active', !!entry.input.checked);
        if (!entry.input.checked) entry.input.disabled = !show;
      });
    });

    updateFilterGroupVisibility();
  }

  function hasVisibleFilterItems(group) {
    if (!group) return false;
    let items = group.querySelectorAll('.filter-group__item');
    for (let i = 0; i < items.length; i += 1) {
      let item = items[i];
      if (!item) continue;
      if (item.style && item.style.display === 'none') continue;
      let input = item.querySelector('input[type="checkbox"], input[type="radio"]');
      if (!input || input.name === 'sort_by') continue;
      if (input.checked || !input.disabled) return true;
    }
    return false;
  }

  function getFilterGroupHeading(group) {
    if (!group || !group.querySelector) return null;
    return group.querySelector('a[data-toggle-target], .filter-group__heading[data-toggle-target]');
  }

  function getFilterGroupItemsContainer(scopeRoot, headingNode) {
    if (!scopeRoot || !headingNode || !headingNode.getAttribute) return null;
    let target = String(headingNode.getAttribute('data-toggle-target') || '').trim();
    if (!target) return null;
    try {
      return scopeRoot.querySelector(target);
    } catch (e) {
      return null;
    }
  }

  function hideFilterGroup(group, scopeRoot) {
    if (!group) return;
    group.style.display = 'none';
    let heading = getFilterGroupHeading(group);
    if (!heading) return;
    heading.classList.remove('Show_filter');
    heading.classList.add('toggle-target-toggler--is-hidden');
    let items = getFilterGroupItemsContainer(scopeRoot, heading);
    if (items) {
      items.classList.remove('Show_filter');
      items.classList.add('toggle-target--hidden');
    }
  }

  function showFilterGroup(group) {
    if (!group) return;
    group.style.display = '';
  }

  function activateFilterGroup(group, scopeRoot) {
    if (!group || !scopeRoot) return;
    let heading = getFilterGroupHeading(group);
    if (!heading) return;
    let items = getFilterGroupItemsContainer(scopeRoot, heading);
    heading.classList.add('Show_filter');
    heading.classList.remove('toggle-target-toggler--is-hidden');
    if (items) {
      items.classList.add('Show_filter');
      items.classList.remove('toggle-target--hidden');
    }
  }

  function deactivateFilterGroup(group, scopeRoot) {
    if (!group || !scopeRoot) return;
    let heading = getFilterGroupHeading(group);
    if (!heading) return;
    let items = getFilterGroupItemsContainer(scopeRoot, heading);
    heading.classList.remove('Show_filter');
    heading.classList.add('toggle-target-toggler--is-hidden');
    if (items) {
      items.classList.remove('Show_filter');
      items.classList.add('toggle-target--hidden');
    }
  }

  function updateFilterGroupVisibilityInScope(scopeRoot, options) {
    if (!scopeRoot || !scopeRoot.querySelectorAll) return;
    let opts = options || {};
    let forceFirstActive = !!opts.forceFirstActive;
    let preserveExpandedState = !!opts.preserveExpandedState;
    let groups = Array.from(scopeRoot.querySelectorAll('.ct_filter-group.filter-group'));
    if (!groups.length) return;

    let visibleGroups = [];
    groups.forEach(function (group) {
      let isSortGroup = group.classList.contains('ca_filter_sort');
      if (isSortGroup) return;

      let hasPriceControls = !!group.querySelector(
        'input.cc-price-range__input--min, input.cc-price-range__input--max, [name="filter.v.price.gte"], [name="filter.v.price.lte"]'
      );
      let shouldShow = hasVisibleFilterItems(group) || hasPriceControls;

      if (shouldShow) {
        showFilterGroup(group);
        visibleGroups.push(group);
      } else {
        hideFilterGroup(group, scopeRoot);
      }
    });

    if (!visibleGroups.length) return;

    if (preserveExpandedState && !forceFirstActive) {
      return;
    }

    let activeVisibleGroup = null;
    if (!forceFirstActive) {
      for (let i = 0; i < visibleGroups.length; i += 1) {
        let g = visibleGroups[i];
        let heading = getFilterGroupHeading(g);
        if (heading && heading.classList.contains('Show_filter')) {
          activeVisibleGroup = g;
          break;
        }
      }
    }

    if (!activeVisibleGroup) {
      activeVisibleGroup = visibleGroups[0];
    }

    visibleGroups.forEach(function (group) {
      if (group === activeVisibleGroup) activateFilterGroup(group, scopeRoot);
      else deactivateFilterGroup(group, scopeRoot);
    });
  }

  function updateFilterGroupVisibility() {
    let mainForm = root.querySelector('#CollectionFilterForm');
    let preserveMainDesktopState = !!(mainForm && window.innerWidth > 990);
    updateFilterGroupVisibilityInScope(mainForm, {
      preserveExpandedState: preserveMainDesktopState
    });
    root.querySelectorAll('.collection-filter-form').forEach(function (form) {
      updateFilterGroupVisibilityInScope(form);
    });
  }

  function activateFilterGroupFromHeading(scopeRoot, headingNode, options) {
    if (!scopeRoot || !headingNode) return false;
    let opts = options || {};
    let allowCollapseActive = !!opts.allowCollapseActive;
    let limitToClicked = !!opts.limitToClicked;
    let group = headingNode.closest('.ct_filter-group.filter-group');
    if (!group) return false;

    if (limitToClicked) {
      let clickedHeading = getFilterGroupHeading(group);
      if (!clickedHeading) return false;
      let isAlreadyOpen = !!clickedHeading.classList.contains('Show_filter');
      if (allowCollapseActive && isAlreadyOpen) {
        deactivateFilterGroup(group, scopeRoot);
      } else {
        activateFilterGroup(group, scopeRoot);
      }
      return true;
    }

    let visibleGroups = Array.from(scopeRoot.querySelectorAll('.ct_filter-group.filter-group')).filter(function (entry) {
      if (!entry || entry.classList.contains('ca_filter_sort')) return false;
      if (entry.style && entry.style.display === 'none') return false;
      return true;
    });
    if (!visibleGroups.length) return false;

    let activeGroup = group;
    if (visibleGroups.indexOf(activeGroup) === -1) {
      activeGroup = visibleGroups[0];
    }

    if (allowCollapseActive) {
      let clickedHeading = getFilterGroupHeading(activeGroup);
      let isAlreadyOpen = !!(clickedHeading && clickedHeading.classList.contains('Show_filter'));
      if (isAlreadyOpen) {
        deactivateFilterGroup(activeGroup, scopeRoot);
      } else {
        activateFilterGroup(activeGroup, scopeRoot);
      }
      return true;
    }

    visibleGroups.forEach(function (entry) {
      if (entry === activeGroup) activateFilterGroup(entry, scopeRoot);
      else deactivateFilterGroup(entry, scopeRoot);
    });
    return true;
  }

  function ensureMainFilterStartsFromFirst() {
    let mainForm = root.querySelector('#CollectionFilterForm');
    if (!mainForm) return;
    updateFilterGroupVisibilityInScope(mainForm, { forceFirstActive: true });
  }

  function collapseAllMainFilterGroupsForDesktop() {
    if (state.mainDesktopDefaultCollapsed) return;
    if (window.innerWidth <= 990) return;
    let mainForm = root.querySelector('#CollectionFilterForm');
    if (!mainForm) return;

    let groups = Array.from(mainForm.querySelectorAll('.ct_filter-group.filter-group'));
    if (!groups.length) return;

    groups.forEach(function (group) {
      if (!group || group.classList.contains('ca_filter_sort')) return;
      if (group.style && group.style.display === 'none') return;
      deactivateFilterGroup(group, mainForm);
    });
    state.mainDesktopDefaultCollapsed = true;
  }

  function ensureAppliedItemsContainer() {
    if (nodes.appliedItems && root.contains(nodes.appliedItems)) {
      return nodes.appliedItems;
    }

    let existingWrap = root.querySelector('.ct_filter_apply');
    if (existingWrap) {
      let existingItems = existingWrap.querySelector('.ct_filter-apply__items');
      if (existingItems) {
        nodes.appliedItems = existingItems;
        return nodes.appliedItems;
      }
    }

    let listingRoot = root.querySelector('.filters-adjacent.collection-listing') || root.querySelector('.collection-listing') || root;
    let plpForm = root.querySelector('#CollectionFilterForm_custom_dd') || nodes.plpForm;
    let wrap = document.createElement('div');
    wrap.className = 'filter-group ct_filter_apply container';
    wrap.innerHTML =
      '<div class="filter-group__heading" style="display: none;"><div class="filter-group__heading__text">Applied filters</div></div>' +
      '<div class="filter-group__items ct_filter-apply__items"></div>';

    if (plpForm && plpForm.parentNode) {
      plpForm.parentNode.insertBefore(wrap, plpForm);
    } else if (listingRoot) {
      listingRoot.insertBefore(wrap, listingRoot.firstChild);
    }

    nodes.appliedItems = wrap.querySelector('.ct_filter-apply__items');
    return nodes.appliedItems;
  }

  function humanizeToken(token) {
    return String(token || '')
      .replace(/-/g, ' ')
      .replace(/\b\w/g, function (char) { return char.toUpperCase(); })
      .trim();
  }

  function buildAppliedLabelLookup() {
    let lookup = {};
    getAllFilterInputs().forEach(function (input) {
      if (!input || !input.name || input.name === 'sort_by') return;
      let key = mapNameToKey(input.name, input);
      if (!key || key.indexOf('__') === 0) return;
      let token = deriveToken(input);
      if (!token) return;

      let label = deriveOptionLabel(input) || humanizeToken(token);
      let parentCategory = deriveParentCategoryLabel(input);
      lookup[key + '::' + token] = {
        key: key,
        token: token,
        label: label,
        parentCategory: parentCategory,
      };
    });
    return lookup;
  }

  function renderAppliedChips() {
    if (!SHOW_APPLIED_FILTER_CHIPS) {
      // Row off: clear anything the server rendered and keep the wrap hidden,
      // so no "Finger Rings ×  Necklace ×  Clear all" strip appears above the
      // PLP+ chips. The lit chips are the applied-state readout now.
      let existingItems = root.querySelector('.ct_filter_apply .ct_filter-apply__items');
      if (existingItems) existingItems.innerHTML = '';
      let existingWrap = root.querySelector('.ct_filter_apply');
      if (existingWrap) {
        existingWrap.classList.remove('active');
        existingWrap.style.display = 'none';
      }
      return;
    }

    let appliedItemsNode = ensureAppliedItemsContainer();
    if (!appliedItemsNode) return;
    let html = '';
    let labels = [];
    let seen = {};
    let lookup = buildAppliedLabelLookup();
    let selectionSourceByKey = state.selectionSourceByKey || {};
    let activeByKey = state.active || {};

    Object.keys(state.active || {}).forEach(function (key) {
      let values = state.active[key] || [];
      values.forEach(function (token) {
        let safeKey = String(key || '');
        let safeToken = String(token || '');
        if (!safeKey || !safeToken) return;

        let dedupeKey = safeKey + '::' + safeToken;
        if (seen[dedupeKey]) return;
        let keyActiveValues = activeByKey[safeKey] || [];
        if (selectionSourceByKey[safeKey] === 'plp' && keyActiveValues.length <= 1) return;
        seen[dedupeKey] = true;

        let lookupItem = lookup[dedupeKey];
        labels.push({
          key: safeKey,
          token: safeToken,
          label: (lookupItem && lookupItem.label) || humanizeToken(safeToken),
          parentCategory: (lookupItem && lookupItem.parentCategory) || 'Filter',
        });
      });
    });

    if (!labels.length) {
      getAllFilterInputs().forEach(function (input) {
        if (!input || !input.checked || !input.name || input.name === 'sort_by') return;
        let key = mapNameToKey(input.name, input);
        if (!key || key.indexOf('__') === 0) return;
        let token = deriveToken(input);
        if (!token) return;
        let dedupeKey = key + '::' + token;
        if (seen[dedupeKey]) return;
        let fallbackActiveValues = activeByKey[key] || [];
        if (selectionSourceByKey[key] === 'plp' && fallbackActiveValues.length <= 1) return;
        seen[dedupeKey] = true;
        labels.push({
          key: key,
          token: token,
          label: deriveOptionLabel(input) || humanizeToken(token),
          parentCategory: deriveParentCategoryLabel(input) || 'Filter',
        });
      });
    }

    labels = labels.filter(function (item) {
      return String(item && item.key || '') !== 'availablecities';
    });

    for (let i = 0; i < labels.length; i += 1) {
      html +=
        '<a class="filter-group__applied-item ct_true" data-parent-category="' +
        escapeHtml(labels[i].parentCategory || '') +
        '" data-key="' +
        escapeHtml(labels[i].key || '') +
        '" href="#" data-token="' +
        escapeHtml(labels[i].token) +
        '">' +
        '<span class="filter-group__applied-item__text">' +
        escapeHtml(labels[i].label) +
        '</span><span class="filter-group__applied-item__icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></span></a>';
    }
    if (labels.length) {
      html += '<div class="filter-group__clear-row"><a class="filter-group__clear-link" href="#">Clear all</a></div>';
    }
    appliedItemsNode.innerHTML = html;
    let wrap = root.querySelector('.ct_filter_apply');
    if (wrap) {
      let shouldShowAppliedWrap = labels.length > 0;
      wrap.classList.toggle('active', shouldShowAppliedWrap);
      // Some legacy scripts set inline display:none; reset it so chips can reappear.
      wrap.style.display = shouldShowAppliedWrap ? '' : 'none';
    }
  }

  function deriveParentCategoryLabel(input) {
    if (!input) return '';

    let key = mapNameToKey(input.name, input);
    let map = {
      category: 'Category',
      stylesubcategory: 'Style/Subcategory',
      craftmanship: 'Craftsmanship',
      occasion: 'Occasion',
      metaltype: 'Metal Type',
      stonetype: 'Stone Type',
      closuretype: 'Closure Type',
      designshape: 'Design Shape',
      motif: 'Motif',
      returnable: 'Returnable',
      nearstores: 'Near Stores',
      availablecities: 'Available Cities',
      size: 'Size',
      color: 'Colors',
      polish: 'Polish',
    };

    let group = input.closest('.ct_filter-group, .breaker-items-group, .filter-group');
    if (group) {
      let heading = group.querySelector('.filter-group__heading__text');
      if (heading) {
        let headingText = String(heading.textContent || '').replace(/\s+/g, ' ').trim();
        if (headingText) return headingText;
      }
    }

    return map[key] || 'Filter';
  }

  function scrollToAppliedFilterTop() {
    if (typeof window.scrollTo === 'function') {
      try {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        window.revealHeaderAfterFilterTop && window.revealHeaderAfterFilterTop();
        return;
      } catch (e) {}
    }
    window.scrollTo(0, 0);
    window.revealHeaderAfterFilterTop && window.revealHeaderAfterFilterTop();
  }

  function queueSortApplyScrollTop() {
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(scrollToAppliedFilterTop);
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(scrollToAppliedFilterTop);
      });
    } else {
      setTimeout(scrollToAppliedFilterTop, 0);
    }
    setTimeout(scrollToAppliedFilterTop, 120);
  }

  function updateUrl() {
    let params = new URLSearchParams(window.location.search);
    let tokenBag = [];
    let keysToDelete = [];

    params.forEach(function (_value, key) {
      if (String(key || '').indexOf('filter.') === 0) keysToDelete.push(key);
    });
    keysToDelete.forEach(function (key) {
      params.delete(key);
    });
    params.delete('PriceFilterMin');
    params.delete('PriceFilterMax');

    Object.keys(state.active).forEach(function (k) {
      (state.active[k] || []).forEach(function (token) {
        if (token && tokenBag.indexOf(token) === -1) tokenBag.push(token);
      });
    });

    if (state.priceRange && (state.priceRange.min != null || state.priceRange.max != null)) {
      tokenBag.push(
        'min-max-' +
          (state.priceRange.min == null ? '0' : state.priceRange.min) +
          '-' +
          (state.priceRange.max == null ? '0' : state.priceRange.max)
      );
    }

    if (tokenBag.length) params.set('q', tokenBag.join(','));
    else params.delete('q');

    if (state.sortBy) params.set('sort_by', normalizeSortKey(state.sortBy));
    else params.delete('sort_by');

    let seenFilterPairs = {};
    getAllFilterInputs().forEach(function (input) {
      if (!input || !input.checked || !input.name || input.name === 'sort_by') return;
      let name = String(input.name || '').trim();
      if (!name || name.indexOf('filter.') !== 0) return;
      let value = String(input.value || '');
      let pairKey = name + '::' + value;
      if (seenFilterPairs[pairKey]) return;
      seenFilterPairs[pairKey] = true;
      params.append(name, value);
    });

    if (state.priceRange && state.priceRange.min != null) {
      params.set('filter.v.price.gte', String(state.priceRange.min));
    }
    if (state.priceRange && state.priceRange.max != null) {
      params.set('filter.v.price.lte', String(state.priceRange.max));
    }

    params.delete('page');
    let target = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    window.history.replaceState({}, '', target);
    persistSelectionSourceByKey();
  }

  // "Clear all" is a decision, and it has to outlive the reload that follows it.
  //
  // Without this the landing auto-open fired again on the very next page load:
  // after a clear the URL is clean, so hasExplicitFiltersInUrl() is false and
  // pickLandingCategory() re-applied the first category. Clearing then looked
  // like it had done nothing as soon as the page was refreshed.
  //
  // sessionStorage keyed on the collection path: the opt-out belongs to this
  // tab's visit to THIS collection. A new tab, or a different collection, still
  // opens on its landing category. Nothing writes this back to the URL, so a
  // shared or copied link is unaffected.
  let LANDING_OPT_OUT_PREFIX = 'k_plp_landing_optout_v1|';

  function getLandingOptOutKey() {
    return LANDING_OPT_OUT_PREFIX + String(window.location.pathname || '');
  }

  function markLandingOptOut() {
    try {
      if (window.sessionStorage) window.sessionStorage.setItem(getLandingOptOutKey(), '1');
    } catch (e) {}
  }

  function hasLandingOptOut() {
    try {
      return !!(window.sessionStorage && window.sessionStorage.getItem(getLandingOptOutKey()));
    } catch (e) {
      return false;
    }
  }

  function clearSelectionSourceSession() {
    try {
      if (window.sessionStorage) window.sessionStorage.removeItem(FILTER_SOURCE_SESSION_KEY);
    } catch (e) {}
  }

  function persistSelectionSourceByKey() {
    try {
      if (!window.sessionStorage) return;
      let active = state.active || {};
      let sourceByKey = state.selectionSourceByKey || {};
      let map = {};
      Object.keys(sourceByKey).forEach(function (key) {
        if (!key || !active[key] || !active[key].length) return;
        if (sourceByKey[key] !== 'plp' && sourceByKey[key] !== 'filter') return;
        map[key] = sourceByKey[key];
      });
      let params = new URLSearchParams(window.location.search);
      let payload = {
        path: String(window.location.pathname || ''),
        q: String(params.get('q') || ''),
        map: map,
      };
      window.sessionStorage.setItem(FILTER_SOURCE_SESSION_KEY, JSON.stringify(payload));
    } catch (e) {}
  }

  function restoreSelectionSourceByKey() {
    state.selectionSourceByKey = {};
    try {
      if (!window.sessionStorage) return;
      let raw = window.sessionStorage.getItem(FILTER_SOURCE_SESSION_KEY);
      if (!raw) return;
      let payload = JSON.parse(raw);
      if (!payload || typeof payload !== 'object') return;

      let params = new URLSearchParams(window.location.search);
      let currentPath = String(window.location.pathname || '');
      let currentQ = String(params.get('q') || '');
      if (String(payload.path || '') !== currentPath) return;
      if (String(payload.q || '') !== currentQ) return;

      let incoming = payload.map && typeof payload.map === 'object' ? payload.map : {};
      let restored = {};
      Object.keys(incoming).forEach(function (key) {
        if (!state.active[key] || !state.active[key].length) return;
        if (incoming[key] !== 'plp' && incoming[key] !== 'filter') return;
        restored[key] = incoming[key];
      });
      state.selectionSourceByKey = restored;
    } catch (e) {
      state.selectionSourceByKey = {};
    }
    state.appliedSelectionSourceByKey = cloneSelectionSourceMap(state.selectionSourceByKey);
  }

  function collectActiveState() {
    let snapshot = getActiveStateFromInputs();
    state.active = snapshot.active;
    state.priceRange = snapshot.price;
    let sourceByKey = state.selectionSourceByKey || {};
    Object.keys(sourceByKey).forEach(function (key) {
      if (!snapshot.active[key] || !snapshot.active[key].length) {
        delete sourceByKey[key];
      }
    });
    state.selectionSourceByKey = sourceByKey;  }

  function syncFilterUiFromState(options) {
    let opts = options || {};
    let shouldSyncOptions = opts.syncOptions !== false;
    let shouldSyncChips = opts.syncChips !== false;
    let shouldSyncCount = opts.syncCount !== false;
    let shouldSyncHeaderToggle = opts.syncHeaderToggle !== false;
    let shouldSyncPlp = !!opts.syncPlp;
    let shouldSyncPlpDeferred = !!opts.syncPlpDeferred;
    if (shouldSyncOptions) updateOptionVisibilityDebounced(state.active, state.priceRange);
    if (shouldSyncChips) renderAppliedChips();
    if (shouldSyncCount) updateToggleAppliedCount(getAppliedFilterCountFromState());
    if (shouldSyncHeaderToggle) syncHeaderNearbyToggleFromActiveState(state.active || {});

    if (shouldSyncPlp) syncPlpSelectionFromCheckedInputs();
    if (shouldSyncPlpDeferred) {
      setTimeout(function () {
        syncPlpSelectionFromCheckedInputs();
      }, 0);
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(function () {
          syncPlpSelectionFromCheckedInputs();
        });
      }
    }  }

  function rollbackPendingFilterChanges() {
    state.active = cloneActive(state.appliedActive || {});
    state.priceRange = state.appliedPriceRange ? { min: state.appliedPriceRange.min, max: state.appliedPriceRange.max } : null;
    syncAllFilterInputsFromState(state.active, state.priceRange);
    state.lastSelectedTokenByName = {};
    state.selectionSourceByKey = cloneSelectionSourceMap(state.appliedSelectionSourceByKey);
    syncFilterUiFromState({
      syncChips: false,
      syncPlp: true,
    });
    setApplyButtonsPending(false);
  }

  async function applyFilters() {
    releaseStaleInteractionLocks();
    state.sortBy = normalizeSortKey(state.sortBy || SORT_KEYS.RECOMMENDED);
    let runId = toNumber(state.applyRunId, 0) + 1;
    state.applyRunId = runId;
    if (!state.loaded) {
      state.deferApplyAfterLoad = true;
      setDeferredApplyLoader(true);
      collectActiveState();
      state.appliedSelectionSourceByKey = cloneSelectionSourceMap(state.selectionSourceByKey);
      syncAllFilterInputsFromState(state.active, state.priceRange);
      syncFilterUiFromState({
        syncOptions: false,
        syncHeaderToggle: false,
      });
      updateUrl();
      setApplyButtonsPending(false);
      if (!state.loading) loadAllProducts();
      return;
    }
    if (!state.fullHydrated) {
      collectActiveState();
      state.appliedSelectionSourceByKey = cloneSelectionSourceMap(state.selectionSourceByKey);
      syncAllFilterInputsFromState(state.active, state.priceRange);
      syncFilterUiFromState({
        syncOptions: false,
        syncHeaderToggle: false,
      });
      updateUrl();
      state.deferApplyAfterLoad = false;
      setDeferredApplyLoader(false);
      ensureFilterDatasetPreparing('apply-filters').then(function () {
        if (runId !== state.applyRunId || !state.loaded || !state.fullHydrated) return;
        applyFilters().catch(function () {});
      });
      // Do not render the partial dataset. The recursive call above renders
      // only after hydration is complete, preventing the product-set flash.
      return;
    }
    ensureAllNearStoreOptionsPresent();
    collectActiveState();
    state.appliedSelectionSourceByKey = cloneSelectionSourceMap(state.selectionSourceByKey);
    state.deferApplyAfterLoad = false;

    let sortKeyForCache = normalizeSortKey(state.sortBy || SORT_KEYS.RECOMMENDED);
    if (requiresServerSortOrder(sortKeyForCache) && !state.sortOrderCache[sortKeyForCache]) {
      scheduleServerSortReapply(sortKeyForCache);
    }

    let next = [];
    for (let i = 0; i < state.products.length; i += 1) {
      if (matchesProduct(state.products[i], state.active, state.priceRange)) next.push(state.products[i]);
    }
    state.filtered = sortProducts(next);
    state.page = 1;
    let existingCards = nodes.list.querySelectorAll('.product-block[data-product-id]');
    let keepStartupCards = hasCurrentStartupPreview() &&
      existingCards.length === Math.min(state.perPage, state.filtered.length) &&
      Array.prototype.every.call(existingCards, function (card, index) {
        return card.getAttribute('data-product-id') === String(state.filtered[index].id);
    });
    state.startupPreviewSignature = '';
    if (nodes.pagination) nodes.pagination.style.display = state.fullHydrated ? '' : 'none';
    nodes.countTargets.forEach(function (node) { node.style.visibility = state.countsAreFinal ? '' : 'hidden'; });
    if (keepStartupCards) {
      // Retain decoded images, slider position and wishlist state on handover.
      resetAndRebindPagination('startup-preview-complete');
      renderCount();
    } else {
      renderProductsOnly();
    }
    syncAllFilterInputsFromState(state.active, state.priceRange);
    syncFilterUiFromState({
      syncPlp: true,
      syncPlpDeferred: true,
    });
    // Ensure any deferred loader is closed as soon as this render cycle completes.
    setDeferredApplyLoader(false);
    syncSortDropdownUI();
    updateUrl();
    state.appliedActive = cloneActive(state.active || {});
    state.appliedPriceRange = state.priceRange ? { min: state.priceRange.min, max: state.priceRange.max } : null;
    if (state.startupMaskActive) {
      setStartupLoader(false);
      state.startupMaskActive = false;
    }
    setApplyButtonsPending(false);
    runExplicitUiSync('apply-filters-finished');
  }

  function setApplyButtonsPending(isPending) {
    state.pendingApply = !!isPending;    let applyButtons = root.querySelectorAll('.apply_btn.ct_submit_sec, .apply_btn.ct_submit');
    applyButtons.forEach(function (btn) {
      if (state.pendingApply) {
        btn.removeAttribute('disabled');
      } else {
        btn.setAttribute('disabled', 'disabled');
      }
    });
  }

  function clearAllFilters() {
    // Every caller of this is the customer's own doing — the "Clear all" link on
    // the rail and in the sidebar, and removing the last applied chip. So this
    // is the right place to record that "All" is now what they want on this
    // collection, including after the reload that a server-refresh clear does.
    releaseStaleInteractionLocks({ forceCloseSort: true });
    getAllFilterInputs().forEach(function (input) {
      input.checked = false;
      input.disabled = false;
      let item = input.closest('.filter-group__item');
      if (item) item.style.display = '';
    });
    let price = getPriceInputs();
    if (price.minInput) price.minInput.value = '';
    if (price.maxInput) price.maxInput.value = '';
    activateAllPlpTabs();
    state.active = {};
    state.priceRange = null;
    state.lastSelectedTokenByName = {};
    state.selectionSourceByKey = {};
    state.appliedSelectionSourceByKey = {};
    clearSelectionSourceSession();
    autoOpenFirstCategoryOnLanding(true);
    collectActiveState();
    syncAllFilterInputsFromState(state.active, state.priceRange);
    syncFilterUiFromState({
      syncOptions: false,
      syncChips: false,
      syncCount: false,
      syncHeaderToggle: false,
      syncPlp: true,
    });
    if (!state.loaded) {
      syncFilterUiFromState({
        syncOptions: false,
        syncHeaderToggle: false,
      });
      updateToggleAppliedCount(0);
      updateUrl();
      setApplyButtonsPending(false);
      return;
    }
    applyFilters();
  }

  function resetFilterOptionVisibilityState(source) {
    let allItems = root.querySelectorAll('.filter-group__item');
    allItems.forEach(function (item) {
      if (!item) return;
      item.style.display = '';
      item.classList.remove('filter-group__item--active');
    });

    getAllFilterInputs().forEach(function (input) {
      if (!input || !input.name || input.name === 'sort_by') return;
      input.disabled = false;
      let item = input.closest('.filter-group__item');
      if (item) item.classList.toggle('filter-group__item--active', !!input.checked);
    });

    root.querySelectorAll('.ct_filter-group.filter-group').forEach(function (group) {
      if (!group) return;
      group.style.display = '';
      let heading = group.querySelector('a[data-toggle-target], .filter-group__heading[data-toggle-target]');
      if (heading) heading.classList.remove('toggle-target-toggler--is-hidden');
      let target = heading ? String(heading.getAttribute('data-toggle-target') || '') : '';
      if (!target) return;
      try {
        let itemsWrap = (group.closest('#CollectionFilterForm, .collection-filter-form') || root).querySelector(target);
        if (itemsWrap) itemsWrap.classList.remove('toggle-target--hidden');
      } catch (e) {}
    });
  }

  function shouldServerRefreshFacetsOnInteraction() {
    return !!state.urlFiltersAtLoad;
  }

  function navigateToCurrentFilterUrl(source) {
    updateUrl();
    let target = window.location.pathname + window.location.search;
    window.location.assign(target);
  }

  function closeSidebarIfVisible() {
    let container = root.querySelector('.filter-container');
    if (!container) return;

    let isVisible =
      container.classList.contains('filter-container--show-filters-mobile') ||
      container.classList.contains('filter-container--show-filters-desktop');

    if (!isVisible) return;

    let closeBtn = root.querySelector('.filters__close[data-toggle-filters]');
    if (closeBtn) {
      closeBtn.click();
      setTimeout(function () {
        if (isAnyFilterDrawerOpen()) {
          forceToggleFilterContainer(false);
        } else {
          cleanupStaleFilterUiState();
        }
      }, 120);
      return;
    }

    container.classList.remove('filter-container--show-filters-mobile');
    container.classList.remove('filter-container--show-filters-desktop');
    root.querySelectorAll('.toggle-btn[data-toggle-filters]').forEach(function (btn) {
      btn.classList.remove('toggle-btn--revealed-desktop');
    });
    cleanupStaleFilterUiState();
  }

  function cleanupStaleFilterUiState() {
    if (isAnyFilterDrawerOpen()) return;
    releaseStaleInteractionLocks();
    let container = root.querySelector('.filter-container');
    if (container) {
      container.classList.remove('filter-container--show-filters-mobile');
      container.classList.remove('filter-container--show-filters-desktop');
    }
    root.querySelectorAll('.toggle-btn[data-toggle-filters]').forEach(function (btn) {
      btn.classList.remove('toggle-btn--revealed-desktop');
    });
    syncBodyScrollLock();
  }

  function forceToggleFilterContainer(shouldOpen) {
    let container = root.querySelector('.filter-container');
    if (!container) return false;
    let open = !!shouldOpen;

    container.classList.remove('filter-container--show-filters-mobile');
    container.classList.remove('filter-container--show-filters-desktop');
    root.querySelectorAll('.toggle-btn[data-toggle-filters]').forEach(function (btn) {
      btn.classList.remove('toggle-btn--revealed-desktop');
    });

    if (open) {
      if (window.innerWidth <= 990) {
        container.classList.add('filter-container--show-filters-mobile');
      } else {
        container.classList.add('filter-container--show-filters-desktop');
      }
      root.querySelectorAll('.toggle-btn[data-toggle-filters]').forEach(function (btn) {
        btn.classList.add('toggle-btn--revealed-desktop');
      });
    }

    syncBodyScrollLock();
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(updateMainFilterPanelCompensation);
    } else {
      setTimeout(updateMainFilterPanelCompensation, 0);
    }
    return true;
  }

  function setBodyScrollLocked(shouldLock) {
    let lock = !!shouldLock;
    if (state.bodyScrollLocked === lock) return;

    let body = document.body;
    if (!body) return;

    if (lock) {
      state.bodyScrollTop = toNumber(window.pageYOffset, 0);
      state.bodyScrollLocked = true;
      document.documentElement.classList.add('kushal-filter-scroll-lock');
      body.classList.add('kushal-filter-scroll-lock');
      window.themeScrollLock && window.themeScrollLock.lock();
      return;
    }

    state.bodyScrollLocked = false;
    document.documentElement.classList.remove('kushal-filter-scroll-lock');
    body.classList.remove('kushal-filter-scroll-lock');
    window.themeScrollLock && window.themeScrollLock.unlock();
    state.bodyScrollTop = 0;
  }

  function isMobileFilterDrawerOpen() {
    let container = root.querySelector('.filter-container');
    if (!container) return false;
    return container.classList.contains('filter-container--show-filters-mobile');
  }

  function isAnyFilterDrawerOpen() {
    let container = root.querySelector('.filter-container');
    if (!container) return false;
    return (
      container.classList.contains('filter-container--show-filters-mobile') ||
      container.classList.contains('filter-container--show-filters-desktop')
    );
  }

  function clearIOSFilterFooterDockingStyles(footer, panel) {
    if (footer) {
      footer.style.position = '';
      footer.style.left = '';
      footer.style.right = '';
      footer.style.top = '';
      footer.style.bottom = '';
      footer.style.width = '';
      footer.style.transform = '';
      footer.style.zIndex = '';
      footer.style.visibility = '';
      footer.style.opacity = '';
      footer.style.pointerEvents = '';
    }
    if (panel) {
      panel.style.transform = '';
      panel.style.right = '';
    }
  }

  function syncIOSFilterFooterDocking() {
    let panel = root.querySelector('.filter-container .filters');
    let footer = panel
      ? panel.querySelector('#CollectionFilterForm .filter-footer-btn-main:not(.braeker-footer-btn-main)')
      : null;
    if (!footer) return;

    let shouldDock = isIOSWebKit() && window.innerWidth <= 990 && isMobileFilterDrawerOpen();
    if (!shouldDock) {
      clearIOSFilterFooterDockingStyles(footer, panel);
      return;
    }

    panel.style.transform = 'none';
    panel.style.right = '0';

    footer.style.position = 'fixed';
    footer.style.left = '0';
    footer.style.right = '0';
    footer.style.top = 'auto';
    footer.style.bottom = '0';
    footer.style.width = '100%';
    footer.style.transform = 'translateX(0)';
    footer.style.zIndex = '800212';
    footer.style.visibility = 'visible';
    footer.style.opacity = '1';
    footer.style.pointerEvents = 'auto';
  }

  function syncBodyScrollLock() {
    setBodyScrollLocked(isMobileFilterDrawerOpen());
    syncIOSFilterFooterDocking();
  }

  function syncMobileFilterPaneGeometry() {
    let defaultTop = 113;
    let shouldPin = isMobileFilterDrawerOpen() && window.innerWidth <= 990;
    if (!shouldPin) {
      root.style.setProperty('--kushal-filter-pane-top', String(defaultTop) + 'px');
      return;
    }

    let panel = root.querySelector('.filter-container .filters');
    let heading = panel ? panel.querySelector('.filters__heading') : null;
    if (!heading) {
      root.style.setProperty('--kushal-filter-pane-top', String(defaultTop) + 'px');
      return;
    }

    let headingRect = heading.getBoundingClientRect();
    let headingBottom = Math.max(0, Math.round(toNumber(headingRect.bottom, defaultTop)));
    if (!headingBottom) headingBottom = defaultTop;
    root.style.setProperty('--kushal-filter-pane-top', String(headingBottom) + 'px');
  }

  function scheduleMainFilterPanelCompensation() {
    if (state.pendingMainFilterCompensationFrame) return;
    if (window.requestAnimationFrame) {
      state.pendingMainFilterCompensationFrame = window.requestAnimationFrame(function () {
        state.pendingMainFilterCompensationFrame = 0;
        updateMainFilterPanelCompensation();
      });
      return;
    }
    state.pendingMainFilterCompensationFrame = window.setTimeout(function () {
      state.pendingMainFilterCompensationFrame = 0;
      updateMainFilterPanelCompensation();
    }, 16);
  }

  function updateMainFilterPanelCompensation() {
    syncMobileFilterPaneGeometry();
  }

  function bindMainFormScrollCompensation() {
    if (state.mainFormScrollCompensationBound) return;
    state.mainFormScrollCompensationBound = true;
  }

  function observeFilterContainerState() {
    if (getMutationSyncMode() !== 'observerFallback') return;
    if (!window.MutationObserver || state.filterContainerObserver) return;
    let container = root.querySelector('.filter-container');
    if (!container) return;
    state.wasMobileFilterDrawerOpen = isMobileFilterDrawerOpen();
    state.wasAnyFilterDrawerOpen = isAnyFilterDrawerOpen();

    state.filterContainerObserver = new MutationObserver(function (mutations) {
      for (let i = 0; i < mutations.length; i += 1) {
        let mutation = mutations[i];
        if (mutation.type !== 'attributes') continue;
        if (mutation.attributeName !== 'class') continue;
        let isMobileOpenNow = isMobileFilterDrawerOpen();
        let isAnyOpenNow = isAnyFilterDrawerOpen();
        if (isAnyOpenNow && !state.wasAnyFilterDrawerOpen) {
          emitMainFilterOpenedEventOnce();
        }
        if (isMobileOpenNow && !state.wasMobileFilterDrawerOpen) {
          ensureMainFilterStartsFromFirst();
        }
        if (!isAnyOpenNow && state.wasAnyFilterDrawerOpen && state.pendingApply) {
          rollbackPendingFilterChanges();
        }
        state.wasMobileFilterDrawerOpen = isMobileOpenNow;
        state.wasAnyFilterDrawerOpen = isAnyOpenNow;
        syncBodyScrollLock();
        scheduleMainFilterPanelCompensation();
        return;
      }
    });

    state.filterContainerObserver.observe(container, { attributes: true, attributeFilter: ['class'] });
  }

  function bindMobileSplitScrollGuard() {
    if (state.mobileSplitScrollBound) return;
    state.mobileSplitScrollBound = true;
  }

  function uncheckByToken(token) {
    let key = arguments.length > 1 ? arguments[1] : '';
    if (!token) return;
    getAllFilterInputs().forEach(function (input) {
      if (!input || !input.name || input.name === 'sort_by') return;
      let inputKey = mapNameToKey(input.name, input);
      if (key && inputKey !== key) return;
      let inputToken = deriveToken(input);
      if (inputToken === token) input.checked = false;
    });
  }

  function applyLegacyFilterParamsFromUrl(params) {
    if (!(params instanceof URLSearchParams)) return;

    getAllFilterInputs().forEach(function (input) {
      if (!input || !input.name || input.name === 'sort_by' || input.disabled) return;
      let type = String(input.type || '').toLowerCase();
      if (type !== 'checkbox' && type !== 'radio') return;
      let values = params.getAll(input.name);
      if (!values || !values.length) return;
      let inputValue = String(input.value || '');
      if (values.indexOf(inputValue) !== -1) {
        input.checked = true;
        return;
      }

      // Robust token-level matching for formatted/case-shifted URL values,
      // especially for available cities on mobile back/refresh restores.
      let inputKey = mapNameToKey(input.name, input);
      let inputToken = deriveToken(input);
      if (!inputToken) return;
      let matchedByToken = values.some(function (rawValue) {
        let rawToken = handleize(rawValue);
        if (!rawToken) return false;
        if (inputKey === 'availablecities') {
          let canonicalRaw = resolveCityCanonical(rawValue);
          let canonicalInput = resolveCityCanonical(inputValue);
          let left = canonicalRaw ? canonicalRaw.token : rawToken;
          let right = canonicalInput ? canonicalInput.token : inputToken;
          return left === right;
        }
        return rawToken === inputToken;
      });
      if (matchedByToken) input.checked = true;
    });

    let p = getPriceInputs();
    let minValue = params.has('filter.v.price.gte') ? params.get('filter.v.price.gte') : params.get('PriceFilterMin');
    let maxValue = params.has('filter.v.price.lte') ? params.get('filter.v.price.lte') : params.get('PriceFilterMax');

    if (p.minInput && minValue !== null) p.minInput.value = String(minValue || '');
    if (p.maxInput && maxValue !== null) p.maxInput.value = String(maxValue || '');
  }

  function restoreFromUrl() {
    let params = new URLSearchParams(window.location.search);
    state.sortBy = normalizeSortKey(params.get('sort_by') || state.sortBy);

    if (!hasExplicitFiltersInUrl()) {
      clearCheckedFilterInputs();
      state.lastSelectedTokenByName = {};
      state.selectionSourceByKey = {};
      state.appliedSelectionSourceByKey = {};
      clearSelectionSourceSession();
      syncPlpSelectionFromCheckedInputs();
      return;
    }

    let q = params.get('q') || '';
    let tokens = q.split(',').map(function (t) { return handleize(t); }).filter(Boolean);
    clearCheckedFilterInputs();
    applyLegacyFilterParamsFromUrl(params);

    let hasExplicitFilterParams = false;
    params.forEach(function (_value, key) {
      if (hasExplicitFilterParams) return;
      if (String(key).indexOf('filter.') === 0) hasExplicitFilterParams = true;
    });

    if (!tokens.length || hasExplicitFilterParams) {
      syncPlpSelectionFromCheckedInputs();
      collectActiveState();
      restoreSelectionSourceByKey();
      return;
    }

    let keysAlreadySelected = {};
    getAllFilterInputs().forEach(function (input) {
      if (!input || !input.checked || !input.name || input.name === 'sort_by') return;
      let selectedKey = mapNameToKey(input.name, input);
      if (!selectedKey || selectedKey.indexOf('__') === 0) return;
      keysAlreadySelected[selectedKey] = true;
    });

    tokens.forEach(function (token) {
      if (token.indexOf('min-max-') === 0) {
        let parts = token.split('-');
        if (parts.length === 4) {
          let p = getPriceInputs();
          if (p.minInput) p.minInput.value = parts[2] === '0' ? '' : parts[2];
          if (p.maxInput) p.maxInput.value = parts[3] === '0' ? '' : parts[3];
        }
        return;
      }

      let exact = root.querySelector('input[data-q-token="' + token + '"]');
      if (exact && !exact.disabled) {
        exact.checked = true;
        return;
      }

      let byTag = root.querySelector('.filter-group__item[data-tag="' + token + '"] input[type="checkbox"], .filter-group__item[data-tag="' + token + '"] input[type="radio"]');
      if (byTag && !byTag.disabled) {
        byTag.checked = true;
        let byTagKey = mapNameToKey(byTag.name, byTag);
        if (byTagKey) keysAlreadySelected[byTagKey] = true;
        return;
      }

      // Fallback: token collisions can exist across multiple filter groups
      // (for example same text in different facets). Pick one best match only,
      // and avoid auto-selecting additional groups on back navigation.
      let matchedInput = null;
      getAllFilterInputs().forEach(function (input) {
        if (matchedInput) return;
        if (!input || input.disabled || input.checked || !input.name || input.name === 'sort_by') return;
        if (deriveToken(input) !== token) return;
        let inputKey = mapNameToKey(input.name, input);
        if (inputKey && keysAlreadySelected[inputKey]) return;
        matchedInput = input;
      });
      if (matchedInput) {
        matchedInput.checked = true;
        let matchedKey = mapNameToKey(matchedInput.name, matchedInput);
        if (matchedKey) keysAlreadySelected[matchedKey] = true;
      }
    });

    syncPlpSelectionFromCheckedInputs();
    collectActiveState();
    restoreSelectionSourceByKey();
  }

  function bindEvents() {
    document.addEventListener(
      'submit',
      function (event) {
        let form = event.target;
        if (!form || !root.contains(form)) return;
        if (!form.matches('#CollectionFilterForm, .collection-filter-form, #CollectionFilterForm_custom_dd')) return;
        event.preventDefault();
        event.stopImmediatePropagation();
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        if (!root.contains(event.target)) return;
        releaseStaleInteractionLocks();
        if (event.target.closest('.link-dropdown__button, .sort-by-icon')) {
          // Warm alternative orders on sort intent, not during every landing.
          prewarmServerSortCaches();
        }
        let utilityBarHit = event.target.closest('.CT-Main_utility-bar.utility-bar, .CT-Main_utility-bar .utility-bar, .utility-bar__left, .utility-bar__right');
        if (utilityBarHit) {
          runExplicitUiSync('utility-bar-click');
          ensureFilterDatasetPreparing('utility-bar-click').catch(function () {});
        }

        let sortShade = event.target.closest('.ct_fil_shade.ct_fill_active');
        if (sortShade) {
          event.preventDefault();
          event.stopImmediatePropagation();
          releaseStaleInteractionLocks({ forceCloseSort: true });
          return;
        }

        let filterToggleHit = event.target.closest('[data-toggle-filters]');
        if (filterToggleHit) {
          triggerFilterDrawerToggle(event, filterToggleHit, 'delegated-click');
          return;
        }

        let clickedInsideSortUi = !!event.target.closest('.link-dropdown, .ct_fil_shade');
        if (!clickedInsideSortUi && isSortDropdownActuallyOpenInRoot()) {
          closeSortDropdownUI();
          releaseStaleInteractionLocks({ forceCloseSort: true });
        }

        let groupHeading = event.target.closest('.ct_filter-group.filter-group a[data-toggle-target], .ct_filter-group.filter-group .filter-group__heading[data-toggle-target]');
        if (groupHeading) {
          let scopeForHeading = groupHeading.closest('#CollectionFilterForm, .collection-filter-form');
          if (scopeForHeading) {
            event.preventDefault();
            event.stopImmediatePropagation();
            let isMainSidebarHeading = scopeForHeading.id === 'CollectionFilterForm';
            let isDesktopViewport = window.innerWidth > 990;
            if (!(isMainSidebarHeading && isDesktopViewport)) {
              updateFilterGroupVisibilityInScope(scopeForHeading);
            }
            activateFilterGroupFromHeading(scopeForHeading, groupHeading, {
              allowCollapseActive: isMainSidebarHeading && isDesktopViewport,
              limitToClicked: isMainSidebarHeading && isDesktopViewport
            });
            return;
          }
        }

        let sidebarClickable = event.target.closest('.filter-group__item, .filter-img_content, .filter-img_content_img, .ct-filter-name, .ct-filter-count');
        let isInsideBreakerClick = !!event.target.closest('.collection-filter-form');
        let isInsidePlpClick = !!event.target.closest('#CollectionFilterForm_custom_dd');
        if (sidebarClickable && isInsidePlpClick && !isInsideBreakerClick) {
          setTimeout(function () {
            syncPlpSelectionFromCheckedInputs();
          }, 0);
        }

        let sortLink = event.target.closest('.CT_link-dropdown__options .CT_short_link, .link-dropdown__options .link-dropdown__link');
        if (sortLink) {
          event.preventDefault();
          event.stopImmediatePropagation();
          try {
            let sortUrl = new URL(sortLink.getAttribute('href'), window.location.origin);
            state.sortBy = normalizeSortKey(sortUrl.searchParams.get('sort_by') || state.sortBy);
          } catch (e) {}

          // Keep sort UX snappy: close dropdown immediately on tap/click,
          // then continue with heavy work (cache warm-up / apply / redirect).
          syncSortDropdownUI();
          closeSortDropdownUI();

          if (!state.loaded) {
            state.deferApplyAfterLoad = true;
            setDeferredApplyLoader(true);
            syncSortDropdownUI();
            updateUrl();
            queueSortApplyScrollTop();
            runExplicitUiSync('sort-change-deferred');
            return;
          }

          applyFilters();
          queueSortApplyScrollTop();
          runExplicitUiSync('sort-change');
          return;
        }

        let li = event.target.closest('.plp_filter_main li');
        if (li) {
          let ownList = li.closest('.plp_filter_main');
          let autoLi = ownList ? ownList.querySelector('.plp-auto-open') : null;
          if (autoLi) autoLi.classList.remove('plp-auto-open');

          let radio = li.querySelector(PLP_INPUT_SELECTOR);
          if (radio && !radio.disabled) {
            // Sort radios share the same breaker markup as category filters,
            // but they must update state.sortBy instead of being treated as a
            // product filter. Otherwise the client keeps the manual order and
            // pinned products are moved back to the top after every render.
            if (radio.name === 'sort_by') {
              if (event.target !== radio) {
                event.preventDefault();
                radio.checked = true;
              }
              state.sortBy = normalizeSortKey(radio.value);
              syncSortDropdownUI();
              event.stopImmediatePropagation();

              if (!state.loaded) {
                state.deferApplyAfterLoad = true;
                setDeferredApplyLoader(true);
                updateUrl();
                queueSortApplyScrollTop();
                runExplicitUiSync('sort-change-deferred');
                return;
              }

              applyFilters();
              queueSortApplyScrollTop();
              runExplicitUiSync('sort-change');
              return;
            }

            let tappedTheInput = event.target === radio;
            // PLP Plus is a true single-select rail: tapping the active pill
            // again must not leave the rail with no selected category.
            let wasAlreadySelected = radio.checked || li.classList.contains('active') || li.classList.contains('plp-auto-open');
            let nextChecked = wasAlreadySelected ? true : (tappedTheInput ? !!radio.checked : !radio.checked);
            if (nextChecked) clearOtherPlpSelections(ownList, radio);
            if (!tappedTheInput) {
              event.preventDefault();
              radio.checked = nextChecked;
            }
            event.stopImmediatePropagation();
            let selectedToken = deriveToken(radio);
            if (selectedToken) {
              let selectedName = String(radio.name || '');
              let selectedKey = mapNameToKey(selectedName, radio);
              if (nextChecked) {
                radio.setAttribute('checked', 'checked');
                state.lastSelectedTokenByName[selectedName] = selectedToken;
              } else {
                radio.removeAttribute('checked');
                if (state.lastSelectedTokenByName[selectedName] === selectedToken) {
                  delete state.lastSelectedTokenByName[selectedName];
                }
              }
              // Same value in the sidebar drawer, kept in step with the chip
              syncTokenAcrossInputs(selectedKey, selectedToken, nextChecked, selectedName);
              if (selectedKey) state.selectionSourceByKey[selectedKey] = 'plp';
            }
            syncPlpSelectionFromCheckedInputs();
            if (nextChecked) revealPlpSelection(ownList, li);
            applyFilters();
            // PLP+ rail changes re-render the grid in place; bring the shopper
            // back to the top after switching to the selected tab.
            queueSortApplyScrollTop();
            if (nextChecked) emitQuickFilterSelectedEvent(radio);
            return;
          }
        }

        let appliedChip = event.target.closest('.filter-group__applied-item[data-token]');
        if (appliedChip) {
          event.preventDefault();
          event.stopImmediatePropagation();
          state.filterInteractionStarted = true;
          let prevClearSnapshot = getActiveStateFromInputs();
          let chipKey = String(appliedChip.getAttribute('data-key') || '');
          let chipGroup = getFilterGroupLabelFromKey(chipKey) || 'All';
          uncheckByToken(
            handleize(appliedChip.getAttribute('data-token')),
            chipKey
          );
          // uncheckByToken() only unchecks DOM inputs, it does not touch
          // state.active. updateUrl() builds the `q` token list from state.active,
          // so without this resync the just-removed token is written straight back
          // into the URL, and restoreFromUrl() re-applies it from `q` on the reload
          // that navigateToCurrentFilterUrl() triggers - the cross became a no-op.
          // clearAllFilters() already does the same thing, which is why "Clear all"
          // worked while a single chip removal did not.
          collectActiveState();
          let nextClearSnapshot = getActiveStateFromInputs();
          emitFilterClearedEvent(chipGroup, {
            previousSnapshot: prevClearSnapshot,
            nextSnapshot: nextClearSnapshot,
          });
          resetFilterOptionVisibilityState('chip-remove');

          let hasRemainingActive = false;
          if (nextClearSnapshot && nextClearSnapshot.active) {
            let activeKeys = Object.keys(nextClearSnapshot.active);
            for (let k = 0; k < activeKeys.length; k += 1) {
              if (nextClearSnapshot.active[activeKeys[k]] && nextClearSnapshot.active[activeKeys[k]].length > 0) {
                hasRemainingActive = true;
                break;
              }
            }
          }
          if (nextClearSnapshot && nextClearSnapshot.price && (nextClearSnapshot.price.min != null || nextClearSnapshot.price.max != null)) {
            hasRemainingActive = true;
          }

          if (!hasRemainingActive) {
            if (shouldServerRefreshFacetsOnInteraction()) {
              clearAllFilters();
              navigateToCurrentFilterUrl('clear-all');
              return;
            }
            clearAllFilters();
            runExplicitUiSync('filter-clear');
            return;
          }

          if (shouldServerRefreshFacetsOnInteraction()) {
            navigateToCurrentFilterUrl('chip-remove');
            return;
          }
          applyFilters();
          return;
        }

        let clearLink = event.target.closest('.filter-group__clear-link');
        if (clearLink) {
          event.preventDefault();
          event.stopImmediatePropagation();
          state.filterInteractionStarted = true;
          let prevClearSnapshot = getActiveStateFromInputs();
          let clearGroup = 'All';
          let clearGroupRoot = clearLink.closest('.ct_filter-group.filter-group');
          if (clearGroupRoot) {
            let clearHeading = clearGroupRoot.querySelector('.filter-group__heading__text');
            let clearHeadingText = clearHeading ? String(clearHeading.textContent || '').replace(/\s+/g, ' ').trim() : '';
            if (clearHeadingText) clearGroup = clearHeadingText;
          }
          emitFilterClearedEvent(clearGroup, {
            previousSnapshot: prevClearSnapshot,
            nextSnapshot: { active: {}, price: null },
          });
          let isMainSidebarClear = !!clearLink.closest('#CollectionFilterForm');
          let isPlpAllClear = !!clearLink.closest('#CollectionFilterForm_custom_dd');
          // Close the drawer before resetting group visibility. Resetting the
          // filter sections first lets the previously open group paint for a
          // frame while Clear all is applying, which causes the stale-panel
          // flash seen on mobile.
          if (isMainSidebarClear) closeSidebarIfVisible();
          resetFilterOptionVisibilityState('clear-all');
          if (shouldServerRefreshFacetsOnInteraction()) {
            clearAllFilters();
            navigateToCurrentFilterUrl('clear-all');
            return;
          }
          clearAllFilters();
          if (isPlpAllClear) {
            emitQuickFilterSelectedEvent(null, 'All');
          }
          if (isMainSidebarClear) {
            queueSortApplyScrollTop();
          }
          runExplicitUiSync('filter-clear');
          return;
        }

        let applyBtn = event.target.closest('.apply_btn');
        if (applyBtn) {
          event.preventDefault();
          event.stopImmediatePropagation();
          state.filterInteractionStarted = true;
          let prevStateForEvent = {
            active: cloneActive(state.active || {}),
            price: state.priceRange ? { min: state.priceRange.min, max: state.priceRange.max } : null,
          };
          let isBreakerApply =
            !!applyBtn.closest('.breaker_filter-main') ||
            !!applyBtn.closest('.breaker-items-group-main') ||
            !!applyBtn.closest('[data-kushal-breaker-filter="true"]');
          let isMainApply = !isBreakerApply && !!applyBtn.closest('#CollectionFilterForm');
          let breakerFormForEvent = null;
          let breakerSnapshotForEvent = null;
          let shouldEmitBreakerSelectedEvent = false;
          let mainSnapshotForEvent = null;
          let shouldEmitMainSelectedEvent = false;
          if (isBreakerApply) {
            breakerFormForEvent = applyBtn.closest('.collection-filter-form');
            if (breakerFormForEvent) {
              breakerSnapshotForEvent = getActiveStateFromContainer(breakerFormForEvent);
              shouldEmitBreakerSelectedEvent =
                !areActiveStatesEqual(prevStateForEvent.active, breakerSnapshotForEvent.active || {}) ||
                !arePriceRangesEqual(prevStateForEvent.price, breakerSnapshotForEvent.price || null);
              Object.keys(breakerSnapshotForEvent.active || {}).forEach(function (key) {
                if (key) state.selectionSourceByKey[key] = 'filter';
              });
              // Preserve filters from other forms when applying breaker filters
              let mergedBreakerActive = cloneActive(prevStateForEvent.active);
              Object.keys(breakerSnapshotForEvent.active || {}).forEach(function (key) {
                mergedBreakerActive[key] = breakerSnapshotForEvent.active[key];
              });
              syncAllFilterInputsFromState(mergedBreakerActive, breakerSnapshotForEvent.price);
              syncPlpSelectionFromCheckedInputs();
            }
          } else if (isMainApply) {
            let mainForm = root.querySelector('#CollectionFilterForm');
            if (mainForm) {
              let prevActive = cloneActive(state.active || {});
              let prevPrice = state.priceRange ? { min: state.priceRange.min, max: state.priceRange.max } : null;
              let mainSnapshot = getActiveStateFromContainer(mainForm);
              mainSnapshotForEvent = mainSnapshot;
              shouldEmitMainSelectedEvent =
                !areActiveStatesEqual(prevActive, mainSnapshot.active || {}) ||
                !arePriceRangesEqual(prevPrice, mainSnapshot.price || null);
              let nextActive = mainSnapshot.active || {};
              let allKeys = {};

              Object.keys(prevActive).forEach(function (key) { allKeys[key] = true; });
              Object.keys(nextActive).forEach(function (key) { allKeys[key] = true; });

              Object.keys(allKeys).forEach(function (key) {
                if (!key) return;
                let beforeValues = prevActive[key] || [];
                let afterValues = nextActive[key] || [];
                if (areTokenSetsEqual(beforeValues, afterValues)) return;
                if (afterValues.length) state.selectionSourceByKey[key] = 'filter';
                else delete state.selectionSourceByKey[key];
              });

              // Preserve filters from other forms (like breaker filters) when applying main filters
              let mergedActive = cloneActive(prevActive);
              Object.keys(mainSnapshot.active || {}).forEach(function (key) {
                mergedActive[key] = mainSnapshot.active[key];
              });
              syncAllFilterInputsFromState(mergedActive, mainSnapshot.price);
              syncPlpSelectionFromCheckedInputs();
            }
          }

          applyFilters();
          // Update filter counts for all filters after apply
          updateOptionVisibilityDebounced(state.active, state.priceRange);
          runExplicitUiSync('filter-apply');

          if (isMainApply && shouldEmitMainSelectedEvent) {
            emitMainFilterOptionSelectedEvent(mainSnapshotForEvent);
          }

          if (!isBreakerApply) {
            if (window.innerWidth <= 990) {
              closeSidebarIfVisible();
            }
            if (isMainApply) {
              queueSortApplyScrollTop();
            }
          } else if (window.requestAnimationFrame) {
            if (shouldEmitBreakerSelectedEvent) {
              emitBreakerFilterSelectedEvent(breakerFormForEvent, breakerSnapshotForEvent);
            }
            window.requestAnimationFrame(scrollToAppliedFilterTop);
          } else {
            if (shouldEmitBreakerSelectedEvent) {
              emitBreakerFilterSelectedEvent(breakerFormForEvent, breakerSnapshotForEvent);
            }
            setTimeout(scrollToAppliedFilterTop, 0);
          }
        }
      },
      true
    );

    let triggerFilterDrawerToggle = function (event, toggleElOverride, source) {
      let toggleEl = toggleElOverride || null;
      if (!toggleEl && event && event.currentTarget && event.currentTarget.matches && event.currentTarget.matches('[data-toggle-filters]')) {
        toggleEl = event.currentTarget;
      }
      if (!toggleEl) {
        toggleEl = event && event.target && event.target.closest ? event.target.closest('[data-toggle-filters]') : null;
      }
      if (!toggleEl) return;

      let now = Date.now();
      let delta = now - state.lastDrawerToggleAt;
      let usedGuard = delta < 350;
      if (usedGuard) {
        if (event && event.preventDefault) event.preventDefault();
        if (event && event.stopPropagation) event.stopPropagation();
        return;
      }
      state.lastDrawerToggleAt = now;

      let wasMobileOpenBefore = isMobileFilterDrawerOpen();
      if (event && event.preventDefault) event.preventDefault();
      if (event && event.stopPropagation) event.stopPropagation();
      releaseStaleInteractionLocks({ forceCloseSort: true });
      closeSortDropdownUI();
      let shouldOpen = !wasMobileOpenBefore;
      forceToggleFilterContainer(shouldOpen);
      let isDrawerOpenNow = isAnyFilterDrawerOpen();
      if (shouldOpen && isDrawerOpenNow) {
        emitMainFilterOpenedEventOnce();
        ensureFilterDatasetPreparing('filter-ui-open').catch(function () {});
      }
      if (!isDrawerOpenNow && state.pendingApply) {
        rollbackPendingFilterChanges();
      }
      if (!isDrawerOpenNow) cleanupStaleFilterUiState();
      runExplicitUiSync(shouldOpen ? 'drawer-open' : 'drawer-close');
    };

    root.addEventListener(
      'change',
      function (event) {
        let input = event.target;
        if (input && input.matches && input.matches('input[data-nearby-products-toggle]')) {
          event.stopImmediatePropagation();
          handleHeaderNearbyToggleChange(!!input.checked);
          return;
        }
        // PLP+ chips are driven entirely by the click handler above, which
        // leaves the checkbox's native toggle in place. The change event that
        // follows would otherwise be picked up below as a breaker-form edit and
        // park the UI in "apply pending".
        if (input && input.closest && input.closest('.plp_filter_main')) {
          event.stopImmediatePropagation();
          return;
        }
        let isPriceInput =
          !!input &&
          input.matches &&
          input.matches('input.cc-price-range__input--min, input.cc-price-range__input--max');
        if (!input || (!input.name && !isPriceInput)) return;
        if (!input.matches('input[type="checkbox"], input[type="radio"], input.cc-price-range__input--min, input.cc-price-range__input--max')) return;

        let filterForm = input.closest('#CollectionFilterForm, .collection-filter-form');
        if (filterForm) {
          event.stopImmediatePropagation();
          let isBreakerForm =
            filterForm.classList &&
            filterForm.classList.contains('collection-filter-form') &&
            String(filterForm.id || '') !== 'CollectionFilterForm';
          if (isBreakerForm) {
            setApplyButtonsPending(true);
            // Collect state from ALL forms to preserve selections from main + other breaker forms
            let allFormsSnapshot = getActiveStateFromInputs();
            state.active = allFormsSnapshot.active || {};
            state.priceRange = allFormsSnapshot.price;
            updateOptionVisibilityDebounced(state.active, state.priceRange, filterForm);
            ensureFilterDatasetPreparing('breaker-filter-change').catch(function () {});
            emitBreakerFilterInteractedEvent(input, filterForm);
            return;
          }
          setApplyButtonsPending(true);
          // Collect state from ALL forms (main + all breakers) to avoid losing selections from other forms
          let allFormsSnapshot = getActiveStateFromInputs();
          state.active = allFormsSnapshot.active || {};
          state.priceRange = allFormsSnapshot.price;
          updateOptionVisibilityDebounced(state.active, state.priceRange, filterForm);
          ensureFilterDatasetPreparing('side-filter-change').catch(function () {});
          return;
        }
      },
      true
    );

    function markPendingForPriceInteraction(filterForm) {
      if (!filterForm) return;
      let snapshot = getActiveStateFromContainer(filterForm);
      let priceChanged = !arePriceRangesEqual(snapshot.price || null, state.priceRange || null);
      if (!priceChanged) return;
      setApplyButtonsPending(true);
      updateToggleAppliedCount(getAppliedFilterCountFromState());
      ensureFilterDatasetPreparing('price-filter-change').catch(function () {});
    }

    root.addEventListener(
      'input',
      function (event) {
        let input = event.target;
        if (!isPriceMinInput(input) && !isPriceMaxInput(input)) return;
        let filterForm = input.closest('#CollectionFilterForm, .collection-filter-form');
        markPendingForPriceInteraction(filterForm);
      },
      true
    );

    function handlePriceControlInteraction(event) {
      let target = event.target;
      if (!target || !target.closest) return;
      let control = target.closest('.cc-price-range__control');
      if (!control) return;
      let filterForm = control.closest('#CollectionFilterForm, .collection-filter-form');
      if (!filterForm) return;
      setTimeout(function () {
        markPendingForPriceInteraction(filterForm);
      }, 0);
    }

    root.addEventListener('pointerup', handlePriceControlInteraction, true);
    root.addEventListener('mouseup', handlePriceControlInteraction, true);
    root.addEventListener('touchend', handlePriceControlInteraction, true);
    root.addEventListener('keyup', handlePriceControlInteraction, true);
  }

  function recoverAfterBackForwardNavigation() {
    if (!root || !document.body || !document.body.contains(root)) return;
    releaseStaleInteractionLocks({ forceCloseSort: true });
    cleanupStaleFilterUiState();
    syncSortUiFromUrl();
    syncPlpSelectionFromCheckedInputs();
    setApplyButtonsPending(false);
    updateMainFilterPanelCompensation();
  }

  function startFreezeWatchdog() {
    if (state.freezeWatchdogBound) return;
    state.freezeWatchdogBound = true;

    setInterval(function () {
      if (!root || !document.body || !document.body.contains(root)) return;

      let hasSortShade = !!root.querySelector('.ct_fil_shade.ct_fill_active');
      let hasExpandedSort = !!root.querySelector('.link-dropdown__button[aria-expanded="true"]');
      let sortActuallyOpen = isSortDropdownActuallyOpenInRoot();
      let drawerOpen = isAnyFilterDrawerOpen();
      let container = root.querySelector('.filter-container');
      let ajaxLoading = !!(container && container.classList.contains('ajax-loading'));

      let hasStaleSortLock = (hasSortShade || hasExpandedSort) && !sortActuallyOpen;
      let hasStaleAjaxLock = ajaxLoading && !drawerOpen;

      if (hasStaleSortLock || hasStaleAjaxLock) {
        releaseStaleInteractionLocks({ forceCloseSort: true });
      }
    }, 1500);
  }

  function runWhenIdle(task, timeout) {
    if (typeof task !== 'function') return;
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(function () { task(); }, { timeout: toNumber(timeout, 600) || 600 });
      return;
    }
    window.setTimeout(task, 60);
  }

  // Init segmentation (single-file modularization)
  function initBootstrapTemplates() {
    // Cache templates before startup skeleton can replace list markup.
    getBreakerTemplateHtml();
    getCollectionAppBannerTemplateHtml();
  }

  function initStartupLoaderState() {
    // Show startup loader if:
    // 1) server has not rendered products yet, or
    // 2) page loaded with pre-applied URL filters/sort that must finalize after hydration.
    let hasServerProducts = !!(nodes.list && nodes.list.querySelector('.product-block[data-product-id], .CT_product-block[data-product-id]'));
    let hasStartupUrlFilters = hasExplicitFiltersInUrl();
    // 3) the PLP is about to open itself on a category. The server rendered the
    //    WHOLE collection, so without this the customer sees every product, then
    //    a re-render a second later once the filter lands. applyFilters() drops
    //    the mask as soon as the filtered grid is painted.
    let willAutoOpen = !!pickLandingCategory();
    if (!hasServerProducts || hasStartupUrlFilters || willAutoOpen) {
      state.startupMaskActive = true;
      setStartupLoader(true);
      if (state.startupMaskReleaseTimer) {
        window.clearTimeout(state.startupMaskReleaseTimer);
        state.startupMaskReleaseTimer = null;
      }
    } else {
      root.classList.remove('k-custom-filter-pending');
    }
  }

  function initCoreBindings() {
    bindEvents();
    bindLocationStoreWatcher();
    window.addEventListener('pageshow', function (event) {
      let navType = '';
      try {
        let navEntries = window.performance && window.performance.getEntriesByType ? window.performance.getEntriesByType('navigation') : [];
        if (navEntries && navEntries.length) navType = String(navEntries[0].type || '');
      } catch (e) {}

      if (!(event && event.persisted) && navType !== 'back_forward') return;
      window.setTimeout(recoverAfterBackForwardNavigation, 0);
      window.setTimeout(recoverAfterBackForwardNavigation, 120);
    });
  }

  function initCoreDeferredBindings() {
    startFreezeWatchdog();
    if (getMutationSyncMode() === 'observerFallback') {
      observeFilterContainerState();
    }
    bindMobileSplitScrollGuard();
    bindMainFormScrollCompensation();
  }

  function initViewportBindings() {
    window.addEventListener('resize', function () {
      scheduleMainFilterPanelCompensation();
      syncIOSFilterFooterDocking();
    });
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', function () {
        scheduleMainFilterPanelCompensation();
        syncIOSFilterFooterDocking();
      });
      window.visualViewport.addEventListener('scroll', function () {
        scheduleMainFilterPanelCompensation();
        syncIOSFilterFooterDocking();
      });
    }
  }

  // Which category the PLP would open itself on, or null for none. Pure — it
  // reads the rail and decides, and changes nothing. Split out of the mutator
  // below so initStartupLoaderState() can ask the same question BEFORE anything
  // renders: if a landing category is coming, the server-rendered unfiltered
  // grid is the wrong answer and must stay behind the startup mask rather than
  // being shown and then swapped out a second later.
  function pickLandingCategory(ignoreUrl) {
    // A shared, filtered or back-navigated URL already says what to show.
    if (!ignoreUrl && hasExplicitFiltersInUrl()) return null;

    // The customer has cleared this collection at least once in this tab, so
    // "All" is the default they asked for — do not put a category back.
    let list = root.querySelector('#CollectionFilterForm_custom_dd .plp_filter_main')
      || root.querySelector('.plp_filter_main');
    if (!list) return null;

    // The landing auto-open is only for the Category rail. If Category is not
    // available, do not promote the first remaining PLP filter (Style,
    // Occasion, etc.) into an automatic selection.
    let categoryRail = list.closest('.rxd_category');
    if (!categoryRail) return null;

    // Something is already on (server-rendered active value) — leave it alone.
    if (list.querySelector(PLP_INPUT_SELECTOR + ':checked')) return null;

    // A pill is disabled exactly when its facet count is 0 and it is not active
    // (snippets/plp_plus_filter.liquid), so "not disabled" IS "has products".
    let candidates = [];
    Array.prototype.forEach.call(list.querySelectorAll('li'), function (li) {
      let input = li.querySelector(PLP_INPUT_SELECTOR);
      if (!input || input.disabled) return;
      candidates.push({ li: li, input: input, rank: plpPinnedRank(li) });
    });
    if (!candidates.length) return null;

    // Prefer the pinned five in their fixed order; otherwise use the first
    // available value from the Category rail.
    let pinned = candidates.filter(function (c) { return c.rank >= 0; });
    pinned.sort(function (a, b) { return a.rank - b.rank; });
    return pinned.length ? pinned[0] : candidates[0];
  }

  // Landing state: open the first category that actually has products instead
  // of showing the whole collection under a hidden "All".
  //
  // The pill is checked BEFORE collectActiveState() runs, so the rest of the
  // startup path treats it exactly as it would a value the server rendered
  // active — no second applyFilters() racing loadAllProducts().
  //
  // Not fired: emitQuickFilterSelectedEvent(). That event reports a customer
  // tapping a chip, and this is not one.
  function autoOpenFirstCategoryOnLanding(forceDefault) {
    // A shared, filtered or back-navigated URL already says what to show; never
    // override it. state.urlFiltersAtLoad is set by the caller just above.
    let chosen = pickLandingCategory(!!forceDefault);
    if (!chosen) return;

    let input = chosen.input;
    input.checked = true;
    input.setAttribute('checked', 'checked');

    // Marker only — it carries no styling, so the pill renders as a normal
    // selected chip and the customer can see what the grid is filtered to.
    // The rail's click handler reads this class to tell a landing DEFAULT apart
    // from a real choice, and replaces it on the first tap rather than adding
    // to it (the rail is multi-select, so without that two pills would light up).
    chosen.li.classList.add('plp-auto-open');

    // Same bookkeeping the chip click handler does, so the drawer, the applied
    // count and the URL all agree with the rail from the first paint.
    let token = deriveToken(input);
    let name = String(input.name || '');
    let key = mapNameToKey(name, input);
    if (token) {
      state.lastSelectedTokenByName[name] = token;
      syncTokenAcrossInputs(key, token, true, name);
    }
    if (key) state.selectionSourceByKey[key] = 'plp';
  }

  function initInitialStateSync() {
    normalizeNearStoreLabelsInContainer(root);
    if (getMutationSyncMode() === 'observerFallback') {
      observePlpListMutations();
    }
    state.urlFiltersAtLoad = hasExplicitFiltersInUrl();
    state.filterInteractionStarted = false;
    restoreFromUrl();
    // Called TWICE on purpose, and both are needed.
    //
    // This one is for the paint: it runs synchronously at DOMContentLoaded, so
    // the landing category is lit before anything is fetched. Without it the
    // only call is the one inside loadAllProducts(), which sits behind an
    // `await fetchPageDetailed(...)` — the pill stayed unselected for the 1-2s
    // that request takes and then lit up late.
    //
    // The second call is inside loadAllProducts(), after its own
    // restoreFromUrl() wipes every checked input again. The two statements there
    // are consecutive and synchronous, so no paint happens between the wipe and
    // the re-check and the pill never visibly flickers off.
    autoOpenFirstCategoryOnLanding();
    syncPlpSelectionFromCheckedInputs();
    syncSortUiFromUrl();
    scheduleStartupSortUiSync();
    collectActiveState();
    state.appliedActive = cloneActive(state.active || {});
    state.appliedPriceRange = state.priceRange ? { min: state.priceRange.min, max: state.priceRange.max } : null;
    syncAllFilterInputsFromState(state.active, state.priceRange);
    renderAppliedChips();
    updateToggleAppliedCount(getAppliedFilterCountFromState());
    syncHeaderNearbyToggleFromActiveState(state.active || {});
  }

  function initDeferredUiEnhancements() {
    ensureAllNearStoreOptionsPresent();
    applyNearStoreShortCodeRestrictionInDom();
    ensureAvailableCitiesFilterPresent();
    collapseAllMainFilterGroupsForDesktop();
    updateMainFilterPanelCompensation();
  }

  async function init() {
    initBootstrapTemplates();
    initStartupLoaderState();
    initCoreBindings();
    initInitialStateSync();
    loadAllProducts();
    runWhenIdle(function () {
      initCoreDeferredBindings();
      initViewportBindings();
      if (getMutationSyncMode() === 'observerFallback') {
        observeSortUiMutations();
      } else {
        runExplicitUiSync('init-idle');
      }
      initDeferredUiEnhancements();
    }, 900);
    // Do not force a full PLP re-render here — loadAllProducts already applies
    // filters only when needed. A second applyFilters() blanks images again.
    if (!state.loaded || !state.products.length) return;
    setApplyButtonsPending(false);
    syncBodyScrollLock();
    updateMainFilterPanelCompensation();
  }

  if (document.readyState === 'loading' && !collectionDomReady) {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Public API for header.liquid to sync filter after location change
  // Called from header.liquid after persisting location to localStorage
  window.__K_CUSTOM_FILTER_SYNC_LOCATION__ = function() {
    // Manually trigger the location change logic that storage event normally triggers
    // Useful for iOS where storage events are unreliable
    refreshNearStoreRestrictionFromLocationChange('manual_sync_from_header');
  };

  // The 60-min chip, for assets/plp-flash-filter.js. Going through applyFilters
  // is the whole point: the grid is rebuilt from the narrowed set, so the run of
  // six cards, the hero in the 7th slot and the breaker after it all come out
  // right for the 60-min list the same way they do for a category.
  window.__K_CUSTOM_FILTER_FLASH__ = {
    set: function (next) {
      let value = !!next;
      if (state.flashOnly === value) return;
      state.flashOnly = value;
      applyFilters();
    },
    get: function () { return !!state.flashOnly; },
    // quickcom answered after the chip was already on — re-filter against it
    refresh: function () { if (state.flashOnly) applyFilters(); }
  };
})();
